(function() {
	'use strict';

	angular.module('quantixApp').factory('localStorage', localStorage);
	localStorage.$inject = [ '$resource' ];
	function localStorage($resource) {
		return {};
	}

	angular.module('quantixApp').controller('AdvanceSearchController',
			AdvanceSearchController);

	AdvanceSearchController.$inject = [ '$scope', 'Principal', '$state',
			'advanceSearchautocomplete', '$location', 'ivhTreeviewMgr',
			'ivhTreeviewBfs', 'ivhTreeviewOptions', 'GenericService',
			'$rootScope', '$timeout', '$uibModal', '$http', '$filter',
			'ErrorHandlerService', 'PortfolioService', 'GenericServiceNew',
			'ADVANCE_SEARCH', '$window', '$anchorScroll', 'industryService',
			'$sce', 'COMPANY_PROFILE', 'INDUSTRY_PROFILE', 'MAX_ROWS_EXPORT',
			'MAX_COLUMN_EXPORT', 'CREATE_PORTFOLIO' ];

	function AdvanceSearchController($scope, Principal, $state,
			advanceSearchautocomplete, $location, ivhTreeviewMgr,
			ivhTreeviewBfs, ivhTreeviewOptions, GenericService, $rootScope,
			$timeout, $uibModal, $http, $filter, ErrorHandlerService,
			PortfolioService, GenericServiceNew, ADVANCE_SEARCH, $window,
			$anchorScroll, industryService, $sce, COMPANY_PROFILE,
			INDUSTRY_PROFILE, MAX_ROWS_EXPORT, MAX_COLUMN_EXPORT,
			CREATE_PORTFOLIO) {

		var opts = ivhTreeviewOptions();

		$scope.qflag = false;
		var wizardgrid = null;
		$scope.showcustfilter = {
			open : true
		};
		$scope.loading2 = true;
		$scope.selecteddate = {
			option : "single"
		};
		
		$scope.selecteddatefsm = {
				option : "single"
			};

		$scope.financialfilter = {
			type : 'Standalone'
		};
		$scope.business = {
			strwk : 'Strength'
		};

		// list of column to get index
		// issue not able to retriv index for Issuer Non Co-operative
		$scope.storeColumnIndexOf = [ 'Last Rating Action Date',
				'Rating Action','Long Term Rating','Short Term Rating' ]

		$scope.showsavedfilter = true;
		$rootScope.homePageMenuStatus = false;
		$rootScope.bm = false;
		$rootScope.qst = false;
		$rootScope.score = false;
		$rootScope.sme = false;
		$rootScope.fsm = false;
		$rootScope.home = false;
		$rootScope.projections = false;
		$rootScope.compProfile = false;
		$rootScope.advanceSearch = true;

		$scope.wizardvalidate = false;

		$scope.step1 = false;
		$scope.step2 = false;
		$scope.step3 = false;

		$scope.quarterdropdowncusttool = [];
		$scope.saveddatareq = true;

		$scope.showrun = false;

		// year array updated
		var currentdate = new Date();
		var prevyeardate = new Date();

		var lastdayarray = [];

		prevyeardate.setDate(currentdate.getDate() - 1825);

		var curryear = $filter('date')(currentdate, 'yyyy');
		var curryearint = parseInt(curryear);

		var prevyear = $filter('date')(prevyeardate, 'yyyy');
		var prevyearint = parseInt(prevyear);

		while (prevyearint <= curryearint) {

			var msec = Date.parse("March 31, " + prevyearint);

			lastdayarray.push(msec);
			prevyearint = prevyearint + 1;

		}

		var finalYearar = [];

		for (var i = 0; i < lastdayarray.length; i++) {

			if (prevyeardate.getTime() < lastdayarray[i]
					&& lastdayarray[i] < currentdate.getTime()) {

				var temp = new Date(lastdayarray[i]);
				var fy = $filter('date')(temp, 'yyyy');
				finalYearar.push(fy);
			}
		}

		// finalYearar = finalYearar.slice(0, 3);
		finalYearar.sort(function(a, b) {
			return b - a
		});

		$scope.currentYear = {
			val : finalYearar[0]
		};
		$scope.yeararray = finalYearar;

		$scope.quarterdropdown = [];
		
		$scope.trackUsage=function(){
			GenericService.trackUsage(new Date(),'ADVANCE SEARCH')
		}
		$scope.resetAmountChange = function(){
			for (var i = 0; i < $scope.filterUiArray.length; i++)

			{
				if ($scope.filterUiArray[i].uicomponent == 'dropdownAmountChange') {
					$scope.filterUiArray[i].selectedVals = null;
					$scope.filterUiArray[i].datasource.amntRange.amntRangeTo = null;
					$scope.filterUiArray[i].datasource.amntRange.amntRangeFrom = null;
					
				}
				}
		}

		$scope.selectdaterange = function(dvalue, ivhNode) {

			var nodearr = [];
			if (dvalue == 'single') {
				$scope.filterUiArray = $scope.filterUiArray
						.filter(function(row) {

							return !(row.node.filterTreeId
									.indexOf('CR_Date_rng_') > -1
									|| row.node.filterTreeId
											.indexOf('CR_Date_rng_Rating Action') > -1
									|| row.node.filterTreeId
											.indexOf('All_agncy_dtrng') > -1
									|| row.node.filterTreeId
											.indexOf('All_agncy_dtrng_Rating Action') > -1
									|| row.node.filterTreeId
											.indexOf('All_Case Type') > -1 || row.node.filterTreeId
									.indexOf('CR_Case Type') > -1);
						});

				$scope.searchfiletrdatac = angular
						.copy($scope.searchfiletrdata);
				ivhTreeviewBfs(
						$scope.searchfiletrdatac,
						opts,
						function(node) {
							if (null != ivhNode
									&& ivhNode.filterTreeId.startsWith('CR_')
									&& (node.filterTreeId
											.indexOf('CR_Date_rng_') > -1
											|| node.filterTreeId
													.indexOf('CR_Date_rng_Rating Action') > -1 || node.filterTreeId
											.indexOf('CR_Case Type') > -1)) {
								node.disabled = true;
								node.selected = false;
								nodearr.push(node);

							} else if (null != ivhNode
									&& ivhNode.filterTreeId.startsWith('All_')
									&& (node.filterTreeId
											.indexOf('All_agncy_dtrng') > -1
											|| node.filterTreeId
													.indexOf('All_agncy_dtrng_Rating Action') > -1 || node.filterTreeId
											.indexOf('All_Case Type') > -1)) {
								node.disabled = true;
								node.selected = false;
								nodearr.push(node);
							} else if (node.filterTreeId
									.indexOf('CR_Date_rng_') > -1
									|| node.filterTreeId
											.indexOf('CR_Date_rng_Rating Action') > -1
									|| node.filterTreeId
											.indexOf('CR_Case Type') > -1
									|| node.filterTreeId
											.indexOf('All_agncy_dtrng') > -1
									|| node.filterTreeId
											.indexOf('All_agncy_dtrng_Rating Action') > -1
									|| node.filterTreeId
											.indexOf('All_Case Type') > -1) {
								node.disabled = true;
								node.selected = false;
								nodearr.push(node);
							}
						});
				$timeout(function() {
					$scope.searchfiletrdata = $scope.searchfiletrdatac
				}, 20);

				nodearr.map(function(row) {
					$timeout(function(node1) {
						ivhTreeviewMgr.deselect($scope.searchfiletrdata, node1,
								opts);
					}, 30);
				});

			} else {

				$scope.searchfiletrdatac = angular
						.copy($scope.searchfiletrdata);
				ivhTreeviewBfs(
						$scope.searchfiletrdatac,
						opts,
						function(node) {
							if (null != ivhNode
									&& ivhNode.filterTreeId.startsWith('CR_')
									&& (node.filterTreeId
											.indexOf('CR_Date_rng_') > -1
											|| node.filterTreeId
													.indexOf('CR_Date_rng_Rating Action') > -1 || node.filterTreeId
											.indexOf('CR_Case Type') > -1)) {
								node.disabled = false;

							} else if (null != ivhNode
									&& ivhNode.filterTreeId.startsWith('All_')
									&& (node.filterTreeId
											.indexOf('All_agncy_dtrng') > -1
											|| node.filterTreeId
													.indexOf('All_agncy_dtrng_Rating Action') > -1 || node.filterTreeId
											.indexOf('All_Case Type') > -1)) {
								node.disabled = false;

							}
						});
				$timeout(function() {
					$scope.searchfiletrdata = $scope.searchfiletrdatac
				}, 20);

			}

		}

		$scope.selectdaterangewizard = function(dvalue, ivhNode) {

			var nodearr = [];
			if (dvalue == 'single') {
				$scope.filterUiArray = $scope.filterUiArray
						.filter(function(row) {

							return !(row.node.filterTreeId
									.indexOf('CR_Date_rng_') > -1
									|| row.node.filterTreeId
											.indexOf('CR_Date_rng_Rating Action') > -1
									|| row.node.filterTreeId
											.indexOf('All_agncy_dtrng') > -1
									|| row.node.filterTreeId
											.indexOf('All_agncy_dtrng_Rating Action') > -1
									|| row.node.filterTreeId
											.indexOf('All_Case Type') > -1 || row.node.filterTreeId
									.indexOf('CR_Case Type') > -1);
						});

				$scope.searchsectiondatac = angular
						.copy($scope.searchsectiondata);
				ivhTreeviewBfs(
						$scope.searchsectiondatac,
						opts,
						function(node) {
							if (null != ivhNode
									&& ivhNode.filterTreeId.startsWith('CR_')
									&& (node.filterTreeId
											.indexOf('CR_Date_rng_') > -1
											|| node.filterTreeId
													.indexOf('CR_Date_rng_Rating Action') > -1 || node.filterTreeId
											.indexOf('CR_Case Type') > -1)) {
								node.disabled = true;
								node.selected = false;
								nodearr.push(node);

							} else if (null != ivhNode
									&& ivhNode.filterTreeId.startsWith('All_')
									&& (node.filterTreeId
											.indexOf('All_agncy_dtrng') > -1
											|| node.filterTreeId
													.indexOf('All_agncy_dtrng_Rating Action') > -1 || node.filterTreeId
											.indexOf('All_Case Type') > -1)) {
								node.disabled = true;
								node.selected = false;
								nodearr.push(node);
							} else if (node.filterTreeId
									.indexOf('CR_Date_rng_') > -1
									|| node.filterTreeId
											.indexOf('CR_Date_rng_Rating Action') > -1
									|| node.filterTreeId
											.indexOf('CR_Case Type') > -1
									|| node.filterTreeId
											.indexOf('All_agncy_dtrng') > -1
									|| node.filterTreeId
											.indexOf('All_agncy_dtrng_Rating Action') > -1
									|| node.filterTreeId
											.indexOf('All_Case Type') > -1) {
								node.disabled = true;
								node.selected = false;
								nodearr.push(node);
							}
						});
				$timeout(function() {
					$scope.searchsectiondata = $scope.searchsectiondatac;
				}, 20);

				nodearr.map(function(row) {
					$timeout(function(node1) {
						ivhTreeviewMgr.deselect($scope.searchsectiondata,
								node1, opts);
					}, 30);
				});

			} else {

				$scope.searchsectiondatac = angular
						.copy($scope.searchsectiondata);
				ivhTreeviewBfs(
						$scope.searchsectiondatac,
						opts,
						function(node) {
							if (null != ivhNode
									&& ivhNode.filterTreeId.startsWith('CR_')
									&& (node.filterTreeId
											.indexOf('CR_Date_rng_') > -1
											|| node.filterTreeId
													.indexOf('CR_Date_rng_Rating Action') > -1 || node.filterTreeId
											.indexOf('CR_Case Type') > -1)) {
								node.disabled = false;

							} else if (null != ivhNode
									&& ivhNode.filterTreeId.startsWith('All_')
									&& (node.filterTreeId
											.indexOf('All_agncy_dtrng') > -1
											|| node.filterTreeId
													.indexOf('All_agncy_dtrng_Rating Action') > -1 || node.filterTreeId
											.indexOf('All_Case Type') > -1)) {
								node.disabled = false;

							}
						});
				$timeout(function() {
					$scope.searchsectiondata = $scope.searchsectiondatac;
				}, 20);

			}

		}
		$http({
			url : 'api/advanceSearch/getCurrentQuarterDate',
			method : 'POST',
			ignoreLoadingBar : true
		}).success(
				function(data) {
					$scope.dateInput = [];
					var date = new Date(Date.parse(data[0].split(" ")[0]
							.replace(/-/g, '/')));
					for (var i = 0; i < 12; i++) {

						var dateToShow = angular.copy(date);
						dateToShow.setDate(dateToShow.getDate() - 1);

						var prevyear = angular.copy(dateToShow);

						prevyear.setYear(prevyear.getFullYear() - 1);
						var lastDay = new Date(prevyear.getFullYear(), prevyear
								.getMonth() + 1, 0);
						var displaydate = new Date(dateToShow.getFullYear(),
								dateToShow.getMonth() + 1, 0);

						var lastopDate = $filter('date')(lastDay, "dd-MMM-yy");

						var displaystr = $filter('date')(displaydate,
								"dd-MMM-yy");

						var opDate = $filter('date')(dateToShow, "MMM-yy");

						var opvar = {
							'datastr' : opDate,
							'dateval' : displaystr,
							'prevdate' : lastopDate
						};
						$scope.quarterdropdown.push(opvar.dateval);
						$scope.quarterdropdowncusttool.push(opvar);
						date.setMonth(date.getMonth() - 3);

					}

					$scope.currentQuarter = {
						val : $scope.quarterdropdown[0]
					};

				}).error(function(response) {
		});

		$scope.errorMessages = [];
		$scope.accrdn = {
			isopen : true
		};

		$("#advanceSearch").addClass("active");
		GenericService.getUserModuleAccessData().then(function(result){
			$scope.Advsrchmoduleaccess = result;
			if (!$scope.Advsrchmoduleaccess[ADVANCE_SEARCH]) {
				ErrorHandlerService.forbiddenError(ADVANCE_SEARCH);
				return;
			}
			GenericService.getUserSectionAccessData().then(function(result){
				$scope.userSectionData = result;
				init();
				if ($scope.advAccessdata.indexOf('Credit Rating Details') > -1) {
					$scope.moreop = false;
				} else {
					$scope.moreop = true;
				}
				
				if ($scope.advAccessdata.indexOf('WS Business Info') > -1) {
					$scope.moreInputFlag = false;
				} else {
					$scope.moreInputFlag = true;
				}
			
				
			});

		});
		
		function init(){
			var accesssection = [];

			Object.keys($scope.userSectionData).forEach(function(key) {
				if ($scope.userSectionData[key] == 'Y') {
					accesssection.push(key);
				}
	
			});
			$scope.advAccessdata = accesssection.filter(function(row) {
				return (row.indexOf('Advance Search') > -1);
			});
			$scope.advAccessdata = $scope.advAccessdata.map(function(row) {
				return row.replace("Advance Search.", "");
			});
	
			$scope.isWS = $scope.advAccessdata.filter(function(row) {
				return row.startsWith('WS');
			});
	
			$scope.portfolioaccessdenied = false;
			if (!($scope.Advsrchmoduleaccess[CREATE_PORTFOLIO] && $scope.advAccessdata
					.indexOf('All Rating Agency') >= 0)) {
				$scope.portfolioaccessdenied = true;
			}
		}

		$scope.showcompanysrchfiler = true;

		$scope.selectedoption = {
			val : 'Universe'
		};

		$scope.showsavedfilter = true;
		$scope.custsearchfilterflag = true;

		$scope.showSearchResult = false;
		$scope.showind = false;
		$scope.showloc = false;
		$scope.shownext = false;
		$scope.shownext1 = false;
		$scope.ratedOrListedCompanies = [];
		$scope.companyListedCompanies = [];

		$scope.finyearquarterarr = [ 'MFG_year', 'BNK_year', 'NFC_year',
				'Interim_Manf_Qurter', 'Interim_Bank_Qurter',
				'Interim_Nbfc_Qurter', 'annual_Manf_Year', 'annual_Bank_Year',
				'annual_nbfc_Year' ];

		var vm = this;
		var opDate = $filter('date')(new Date(), "dd-MM-yyyy");
		$scope.range = {
			start : opDate,
			end : opDate
		};
		$scope.format = 'DD-MM-YYYY';

		$scope.searchType = '';
		$scope.accrdn = {
			isopen : true
		};
		$scope.companydata = [];

		// added for upgread dpwngrade reson data

		$scope.selctedReason = {
			type : "none"
		};
		$scope.showupgrade = false;
		$scope.showdowngrade = false;

		$scope.myQuery = {
			"text" : ""
		};
		$scope.$watch('myQuery.text', function(value) {
			if (value.length != 0) {
				ivhTreeviewBfs($scope.searchfiletrdata, opts, function(node) {
					ivhTreeviewMgr.expand($scope.searchfiletrdata, node, opts,
							true);
				});

			}
			if (value.length == 0) {
				if ($scope.searchfiletrdata != undefined
						&& $scope.searchfiletrdata != null) {
					ivhTreeviewBfs($scope.searchfiletrdata, opts,
							function(node) {
								ivhTreeviewMgr.collapse(
										$scope.searchfiletrdata, node, opts,
										true);
							});
				}

			}

		});

		$http
				.post('api/advanceSearch/getCompanySearchToolData')
				.success(
						function(data) {

							$scope.sectiondataall = data;

							$scope.sectiondata = $scope.sectiondataall
									.filter(function(row) {
										return row.displayflag == 'Y '
												&& !(row.s_no == '26'
														|| row.s_no == '27'
														|| row.s_no == '28' || row.s_no == '29');

									});
						});

		$scope.setUpDownData = function(obj) {
			if (obj.Name == 'Reasons for Upgrade') {
				$http(
						{
							url : 'api/advanceSearch/getMasterDataForUpgradeDowngradeFilter',
							method : 'POST',
							data : "reasonsForUpgrade",
						}).success(function(data) {
					$scope.upgradedata = data;
					$scope.selecteddata.rs = [];
					$scope.showupgrade = true;
					$scope.showdowngrade = false;

				}).error(function(response) {
				});
			}
			if (obj.Name == 'Reasons for Downgrade') {
				$http(
						{
							url : 'api/advanceSearch/getMasterDataForUpgradeDowngradeFilter',
							method : 'POST',
							data : "reasonsForDowngrade",
						}).success(function(data) {
					$scope.downgradedata = data;
					$scope.selecteddata.rs = [];
					$scope.showupgrade = true;
					$scope.showdowngrade = false;
				}).error(function(response) {
				});
			}
		}

		$scope.deniedRA2nd3 = function() {
			// /disable for RA2 nd RA3
			if ($scope.advAccessdata.indexOf('Business Information') >= 0
					|| $scope.advAccessdata.indexOf('Company Background') >= 0
					|| $scope.advAccessdata.indexOf('Financial Information') >= 0
					|| $scope.advAccessdata
							.indexOf('Equity  / Fixed Income Details') >= 0
					|| $scope.advAccessdata.indexOf('Credit Rating Details') >= 0
					|| $scope.advAccessdata.indexOf('Industry Info') >= 0) {
				return false;
			} else {
				$scope.errorMessages = [];
				$scope.nextbuttonflag = true;
				$scope.iferror = true;
				$scope.errorMessages
						.push(" This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001. ");

				$timeout(function() {

					$scope.iferror = false;
					$scope.errorMessages = "";

				}, 5000);

				return true;

			}
		}

		$scope.compbackallid = [ "CB_Industry_Classification",
				"CB_Registered_Office_Location", "CB_Listing_Status",
				"CB_Company_Type", "CB_BOD", "CB_associate_company",
				"CB_Banker" ];

		$scope.custFilterDataCopy = [];

		$scope.isWizardRatingSearch = function() {
			return $scope.selectedsec ? $scope.selectedsec.sectionId === 10
					: false;
		}
		// custom search tool
		$scope.setCustomSearchTool = function() {
			if (!$scope.isWizardRatingSearch()) {
				if ($scope.deniedRA2nd3()) {
					return false;
				}
			}
			$scope.loading2 = true;
			$scope.showcustfilter.open = true;
			$scope.runflag = false;
			$scope.rbtnCaseTypeAll = true;

			if ($scope.queryflag != 'edit') {
				$scope.filterUiArray = [];
			}

			$scope.searchType = $scope.isWizardRatingSearch() ? 'WIZARD'
					: 'CUSTOM';
			$scope.searchfiletrdata = [];

			if ($scope.custFilterDataCopy.length == 0) {

				$http.post('api/masterData/getAdvanceFilterTreeList', {
					ignoreLoadingBar : true
				}).success(function(data) {
					$scope.custFilterDataCopy = data;
					$scope.customFilterDataConf(data);
				});

			} else {
				$scope.customFilterDataConf($scope.custFilterDataCopy);
			}

		}

		$scope.customFilterDataConf = function(data) {

			if ($scope.searchType === 'CUSTOM') {
				data = data.filter(function(row) {
					return row.filterTreeId != 'company_name_search'
				});
			}

			for (var i = 0; i < $scope.advAccessdata.length; i++) {
				ivhTreeviewBfs(
						data,
						opts,
						function(node) {
							if ($scope.advAccessdata[i] == 'Business Information'
									&& node.label == 'Business Information') {
								ivhTreeviewBfs(node, opts, function(node) {
									node.disabled = false;
								});
							}

							if ($scope.advAccessdata[i] == 'Company Background'
									&& node.label == 'Company Background') {
								ivhTreeviewBfs(node, opts, function(node) {
									node.disabled = false;
								});
							}
							if ($scope.advAccessdata[i] == 'Financial Information'
									&& node.label == 'Financials') {
								ivhTreeviewBfs(node, opts, function(node) {
									node.disabled = false;
								});
							}
							if ($scope.advAccessdata[i] == 'Equity  / Fixed Income Details'
									&& (node.label == 'Fixed Income Securities Information' || node.label == 'Equity Details')) {
								ivhTreeviewBfs(node, opts, function(node) {
									node.disabled = false;
								});
							}

							if ($scope.advAccessdata[i] == 'Credit Rating Details'
									&& (node.label == 'Credit Rating Details')) {
								ivhTreeviewBfs(node, opts, function(node) {
									node.disabled = false;
								});
							}
							if ($scope.advAccessdata[i] == 'Industry Info'
									&& (node.label == 'Industry Information')) {
								ivhTreeviewBfs(node, opts, function(node) {
									node.disabled = false;
								});
							}
							
						

						});
				
				//FSM and ScoreCard
				ivhTreeviewBfs(
						data,
						opts,
						function(node) {
							if (node.label == 'FSM' && ($scope.Advsrchmoduleaccess['Financial Sensitivity Model'] || $scope.Advsrchmoduleaccess['FSM Unlisted'] || $scope.Advsrchmoduleaccess['FMSM'])) {
								ivhTreeviewBfs(node, opts, function(node) {
									node.disabled = false;
								});
							}
							if (node.label == 'ScoreCard' && $scope.Advsrchmoduleaccess['Scorecard'] ) {
								ivhTreeviewBfs(node, opts, function(node) {
									node.disabled = false;
								});
							}
						});
			}

			ivhTreeviewBfs(data, opts, function(node) {

				if (node.children != undefined && node.children.length > 0) {
					node.disabled = true;
				}
			});
			// end
			$scope.searchfiletrdata = data;
			$scope.selecteddate = {
				option : "single"
			};
			$scope.status = {
				unlisted : null,
				rated : null,
				unrated: null
			};
			var isWizardRatingSearch = $scope.isWizardRatingSearch();
			$scope.tempdata = angular.copy($scope.searchfiletrdata);
			$scope
					.$watch(
							'status.unlisted',
							function(value) {
								if (value) {

									$scope.searchfiletrdatac = angular
											.copy($scope.tempdata);

									ivhTreeviewBfs(
											$scope.searchfiletrdatac,
											opts,
											function(node) {

												if ((node.filterTreeId
														.indexOf('equity') > -1)
														|| (node.filterTreeId
																.indexOf('BOD') > -1)
														|| (node.filterTreeId
																.indexOf('associate_company') > -1)
														|| (node.filterTreeId
																.indexOf('Interim') > -1)
														|| (node.filterTreeId
																.indexOf('Intrm') > -1)
														|| (node.filterTreeId
																.indexOf('annual') > -1)
														|| (node.filterTreeId
																.indexOf('annnual') > -1)) {
													node.selected = false;
													node.hide = true;
													node.disabled = true;
												}
											
											});
									$timeout(
											function() {
												$scope.searchfiletrdata = $scope.searchfiletrdatac;
											}, 10);
								} else {
									$timeout(
											function() {
												if (isWizardRatingSearch
														&& $scope.queryflag == "reset")
													$scope.searchsectiondata = $scope.tempdata;
												$scope.searchfiletrdata = $scope.tempdata;
											}, 10);
								}
							});

			if ($scope.selecteddate.option == 'single') {
				$scope.searchfiletrdatac = angular
						.copy($scope.searchfiletrdata);

				ivhTreeviewBfs(
						$scope.searchfiletrdatac,
						opts,
						function(node) {
							if (node.filterTreeId.indexOf('CR_Date_rng_') > -1
									|| node.filterTreeId
											.indexOf('CR_Date_rng_Rating Action') > -1
									|| node.filterTreeId
											.indexOf('All_agncy_dtrng') > -1
									|| node.filterTreeId
											.indexOf('All_agncy_dtrng_Rating Action') > -1
									|| node.filterTreeId
											.indexOf('All_Case Type') > -1
									|| node.filterTreeId
											.indexOf('CR_Case Type') > -1) {
								node.disabled = true;

							}
						});
				$timeout(function() {
					$scope.searchfiletrdata = $scope.searchfiletrdatac
				}, 20);

			}

			if ($scope.queryflag == 'edit' && $scope.filterUiArray != []) {
				angular.forEach($scope.filterUiArray, function(value, key) {
					if ($scope.isWizardRatingSearch()) {
						ivhTreeviewMgr.expandTo($scope.searchsectiondata,
								value.node.id, opts);
						ivhTreeviewMgr.select($scope.searchsectiondata,
								value.node.id, opts);
					} else {
						ivhTreeviewMgr.expandTo($scope.searchfiletrdatac,
								value.node.id, opts);
						ivhTreeviewMgr.select($scope.searchfiletrdatac,
								value.node.id, opts);
					}
				});

			}

			$scope.loading2 = false;
		}

		var nodearr = [];

		// added for long-short term scale input component
		$scope.selectedtype = {
			term : "none"
		};
		$scope.setScaleData = function(obj) {
			if (obj.Name == "Long Term") {

				var promise = GenericService.getLongTermCreditRatingData();
				promise.then(function(data) {

					$scope.longTermRatingTypes = data;

					$scope.peerGroupLongTermRatingValues = {
						minValue : $scope.longTermRatingTypes[2],
						maxValue : $scope.longTermRatingTypes[8],
						options : {
							stepsArray : $scope.longTermRatingTypes,
							showSelectionBar : true,
							showTicksValues : true

						}
					};

					$scope.peerGroupLongTermRatingValuesTo = {
						minValue : $scope.longTermRatingTypes[2],
						maxValue : $scope.longTermRatingTypes[8],
						options : {
							stepsArray : $scope.longTermRatingTypes,
							showSelectionBar : true,
							showTicksValues : true

						}
					};

					$scope.showlongtermscale = true;
					$scope.showshorttermscale = false;

				}, function(response, status, headers, config) {
					ErrorHandlerService.handleError(response, status, headers,
							config);
				});

			}
			if (obj.Name == "Short Term") {

				var promise = GenericService.getShortTermCreditRatingData();
				promise.then(function(data) {
					$scope.shortTermRatingTypes = data;

					$scope.peerGroupShortTermRatingValues = {
						minValue : $scope.shortTermRatingTypes[0],
						maxValue : $scope.shortTermRatingTypes[8],
						options : {
							stepsArray : $scope.shortTermRatingTypes,
							showSelectionBar : true,
							showTicksValues : true
						}
					};

					$scope.peerGroupShortTermRatingValuesTo = {
						minValue : $scope.shortTermRatingTypes[0],
						maxValue : $scope.shortTermRatingTypes[8],
						options : {
							stepsArray : $scope.shortTermRatingTypes,
							showSelectionBar : true,
							showTicksValues : true
						}
					};

					$scope.showshorttermscale = true;
					$scope.showlongtermscale = false;
				}, function(response, status, headers, config) {
					ErrorHandlerService.handleError(response, status, headers,
							config);
				});

			}

		}
		$scope.wizardflag = false;
		// added for wizard
		$scope.seachWizardGnerate = function(resetfilter) {
			
			if (resetfilter) {
				$scope.filter = undefined;
			}

			$scope.removeData = false;
			$scope.wizardflag = true;
			$scope.filterdatalist = $scope.searchComapny(false);
			var filter = {
				pageNumber : 1,
				pageSize : 10,
				filterExpressions : [],
				sortExpressions : [],
				doFilter: false,
				ratingActionIndex: -1,
				lastRatingActionIndex: -1,
				ltRating: -1,
				stRating: -1
			};

			if (typeof $scope.filter != 'undefined') {
				filter.pageNumber = $scope.filter.pageIndex + 1 || 1;
				filter.pageSize = $scope.filter.pageSize || 10;

				//for filter expression
				$scope.filter.filterExpressions.forEach(function(
						filterExpression) {

					var expression = {};
					expression.columnIndex = filterExpression.columnName;
					expression.expression = filterExpression.expression;
					filter.filterExpressions.push(expression);
				});

				$scope.filter.sorts.forEach(function(sortExpression) {

					var expression = {};
					expression.sortColumn = sortExpression.sortColumn;
					expression.sortOrder = sortExpression.isAscending ? "asc"
							: "desc";
					filter.sortExpressions.push(expression);
				});

			}
			
			//this filter are for Suspended / INC*>15M Case
			if (!$scope.rbtnCaseTypeAll && typeof $scope.wizardop != 'undefined') {
				filter.doFilter = true;
				filter.ratingActionIndex = $scope.wizardop.ratingActionIndex;
				filter.lastRatingActionIndex = $scope.wizardop.lastRatingActionIndex;
				filter.ltRating = $scope.wizardop.ltRating;
				filter.stRating = $scope.wizardop.stRating;
				
			}

			$scope.arrtosend = [];
			$scope.arrtosend = angular.copy($scope.selectedoutputfiltr);

			for (var i = 0; i < $scope.selectedoutputfiltr.length; i++) {
				if ($scope.selectedoutputfiltr[i].sectionName == 'Detailed Financials'
						&& $scope.selectedoutputfiltr[i].moduleName == 'null') {
					$scope.filteredarr = $scope.sectiondataall.filter(function(
							row) {
						return row.sectionName == 'Detailed Financials'
								&& row.moduleName != 'null';
					});

					$scope.filteredarr.map(function(row) {
						$scope.arrtosend.push(row)
					});
				}

				if ($scope.selectedoutputfiltr[i].sectionName == 'Business Information'
						&& $scope.selectedoutputfiltr[i].moduleName == 'null') {
					$scope.arrtosend = angular.copy($scope.selectedoutputfiltr);
					$scope.arrtosend.splice(i, 1);
					$scope.filteredarr = $scope.sectiondataall.filter(function(
							row) {
						return row.sectionName == 'Business Information'
								&& row.moduleName != 'null';
					});

					$scope.filteredarr.map(function(row) {
						$scope.arrtosend.push(row)
					});
				}

			}

			$scope.universeFlag = true;
			if ($scope.selectedsec.sectionName == 'Monitor companies in my portfolio'
					|| ($scope.selectedsec.sectionName == 'Rating Search' && $scope.selectedoption.val != 'Universe')) {
				$scope.universeFlag = false + ',' +  ( typeof $scope.selectedoption.portfolio != 'undefined' ? $scope.selectedoption.portfolio : 'All');
			}

			if ($scope.associate_comp_flag) {
				$scope.asscomparr = $scope.sectiondataall.filter(function(row) {
					return row.sectionName == 'Associate company';
				}, 100);

				$scope.arrtosend.push($scope.asscomparr[0]);
			}

			var dataToSend = {

				"filterObj" : $scope.filterdatalist,
				"pagable" : filter,
				"columnNames" : " ",
				"sectiondata" : $scope.arrtosend,
				"universeFlag" : $scope.universeFlag,
				"smeflag" : $scope.smeflag,
				"currentYear" : $scope.currentYear.val,
				"associate_comp_flag" : $scope.associate_comp_flag,
                "cacheReload" : $scope.cacheReload
			}

			// will use to set alert for all company
			$scope.wizardFilters = dataToSend;

			$http({
				url : "api/advanceSearch/getWizardOutput",

				method : 'POST',
				data : angular.toJson(dataToSend)

			})
					.success(
							function(response, status, headers, config) {
								
								if (response.length == 0) {
									$scope.iferror = true;
									$scope.errorMessages = [];
									$scope.showwizardop = false;
									$scope.errorMessages
											.push("No data found for selected criteria ");
									$window.scrollTo(0, 0);
									$scope.compCount = 0;
									$timeout(function() {

										$scope.iferror = false;
										$scope.errorMessages = [];

										$scope.filterUiArray.forEach(function(
												entry) {
											entry.errorflag = false;
										});

									}, 5000);

									return false;
								}
								

								$scope.cacheReload = false;
								$scope.prevresponse = response;

								$scope.headerrow = response[0];
								$scope.compCount = response[1];
								$scope.columnsToShow = $scope.headerrow;
								$scope.searchOutputRowCnt = response[2];
								$scope.searchOutput = response[3];
								$scope.ratedOrListedCompanies = [];

								//will add unique company code for portfolio and search
								var set = new Set();
								angular.forEach($scope.searchOutput, function(
										value, key) {
									set.add(value[0]);
								});

								$scope.ratedOrListedCompanies = Array.from(set);

								$scope.searcharr = [];
								angular.forEach($scope.ratedOrListedCompanies,
										function(value, key) {

											$scope.searcharr.push({
												companyCode : value
											});
										});

								var index = 0;
								var lastRatingActionIndex = -1;
								var ratingActionIndex = -1;
								var ltRating = -1;
								var stRating = -1;
								$scope.columnsarr = $scope.headerrow
										.map(function(row) {
											if (row.displayFlag) {
												row.displayindex = index;
											}
											if ($scope.storeColumnIndexOf[0] == row.displayName
													.trim()) {
												lastRatingActionIndex = index;
											} else if ($scope.storeColumnIndexOf[1] == row.displayName
													.trim()) {
												ratingActionIndex = index;
											}
											else if ($scope.storeColumnIndexOf[2] == row.displayName
													.trim()) {
												ltRating = index;
											}
											else if ($scope.storeColumnIndexOf[3] == row.displayName
													.trim()) {
												stRating = index;
											}
											index = index + 1;
											return row;
										});
								$scope.columnsarr = $scope.columnsarr
										.filter(function(row) {
											return row.displayFlag;
										});
								$scope.loading = false;
								$scope.showwizardop = true;

								$scope.wizardop = {
									dataProvider : $scope.searchOutput,
									styles : flexiciousNmsp.UIUtils
											.getThemeById('officeblue').styles,
									delegate : $scope,
									lastRatingActionIndex : lastRatingActionIndex,
									ratingActionIndex : ratingActionIndex,
									ltRating : ltRating,
									stRating : stRating,
									outStandingRatingIndex : -1
								};
								$timeout(function() {

									$scope.buildGridwizardopfilter();
								}, 100);

							}).error(
							function(response, status, headers, config) {

							});

			$scope.activeflag.val = 3;

		}

/*		if ($scope.advAccessdata.indexOf('Credit Rating Details') > -1) {
			$scope.moreop = false;
		} else {
			$scope.moreop = true;
		}*/

		$scope.setOutputFilter = function() {
			$scope.remaingOutputsec = [];
			$scope.outputfilter = [];
			$scope.wizardvalidate = true;

			var validateflag = $scope.searchComapny(true);

			if (!validateflag) {
				$scope.activeflag.val = 1;
				goToPrevTab1($scope.activeflag.val);
				$scope.wizardvalidate = true;
				return false;
			} else {

				$scope.wizardvalidate = false;
			}

			$scope.shownext1 = true
			$scope.sectiondataall
					.map(function(row) {
						if ($scope.selectedsec.outputfilterlist
								.indexOf(row.s_no.toString()) > -1
								&& (row.sectionName != 'Summary Financials'
										|| row.sectionName != 'Interim Financials' || row.sectionName != 'Financial Information')) {
							$scope.outputfilter.push(row);
						} else if ((row.displayflag.trim() == 'Y'
								&& row.sectionName != 'Summary Financials'
								&& row.sectionName != 'Interim Financials' && row.sectionName != 'Financial Information')) {
							$scope.remaingOutputsec.push(row);
						}
					});
			$scope.activeflag.val = 2;
		}

		$scope.hideOPFilter = [ 'Detailed Financials' ];

		$scope.moreOutputSec = function() {

			// cause add data issue 2nd time
			// filter should not seen on wizard output screen
			//to avoid duplicate insert objects
			var existingOPFilter = $scope.outputfilter.map(function(x) {
				return x.sectionName;
			});
			$scope.moreop = true;

			$scope.remaingOutputsec
					.filter(
							function(x) {
								return existingOPFilter.indexOf(x.sectionName
										.trim()) == -1
										&& x.displayflag.trim() == 'Y'
										&& $scope.hideOPFilter
												.indexOf(x.sectionName.trim()) == -1;
							}).forEach(function(x) {
						$scope.outputfilter.push(x);
					});
		}
		$scope.nextbuttonflag = true;
		$scope.addSection = function(sec) {

			// disable temperory for future.
			// if (sec.sectionName != 'Rating Search'){
			// alert('This feature is temporarily unavailable, please use the
			// custom search feature to execute queries.');
			// return;
			// }

			// RA1 should not access any query and RA2, RA3 should access only
			// rating search
			if (($scope.isWS.length == 0)
					&& ((sec.sectionName != 'Rating Search' && $scope.advAccessdata
							.indexOf('RA query (Legacy Search)') >= 0) || $scope.advAccessdata
							.indexOf('RA query (Legacy Search)') == -1)) {
				$scope.errorMessages = [];
				$scope.nextbuttonflag = true;
				$scope.iferror = true;
				$scope.errorMessages
						.push(" This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001. ");

				$timeout(function() {

					$scope.iferror = false;
					$scope.errorMessages = "";

				}, 5000);

				return false;
			}

			//will enable next button
			$scope.nextbuttonflag = false;
			
			$scope.selectedsec = sec;
			$scope.shownext = false;
			$scope.shownext1 = false;
			$scope.sectionipfilter = [];
			$scope.searchsectiondata = [];
			$scope.remaingOutputsec = [];
			$scope.outputfilter = [];
			$scope.filterUiArray = [];
			$scope.iferror = false;

			$scope.sectionlist = $scope.sectionlist.map(function(row) {

				if (row.sectionId == $scope.selectedsec.sectionId) {
					row.bgflag = true;
					return row;
				} else {
					row.bgflag = false;
					return row;
				}

			});

			ivhTreeviewMgr.deselectAll($scope.searchfiletrdata);

			if ($scope.advAccessdata.indexOf('WS Business Info') > -1) {
				$scope.moreInputFlag = false;
			} else {
				$scope.moreInputFlag = true;
			}

			if ($scope.advAccessdata.indexOf('Credit Rating Details') > -1) {
				$scope.moreop = false;
			} else {
				$scope.moreop = true;
			}

		}
		$scope.activeflag = {
			val : 0
		};

		$scope.goToPrevTab0 = function(tabid) {
			if ($scope.advAccessdata.indexOf('WS Business Info') > -1) {
				$scope.moreInputFlag = false;
			} else {
				$scope.moreInputFlag = true;
			}
			if ($scope.advAccessdata.indexOf('Credit Rating Details') > -1) {
				$scope.moreop = false;
			} else {
				$scope.moreop = true;
			}
			$timeout(function() {
				$scope.activeflag.val = 0;
			}, 1);
		}
		$scope.goToPrevTab1 = function(tabid) {
			if ($scope.advAccessdata.indexOf('WS Business Info') > -1) {
				$scope.moreInputFlag = false;
			} else {
				$scope.moreInputFlag = true;
			}
			if ($scope.advAccessdata.indexOf('Credit Rating Details') > -1) {
				$scope.moreop = false;
			} else {
				$scope.moreop = true;
			}
			$timeout(function() {
				$scope.activeflag.val = 1;
			}, 1);
		}
		$scope.goToPrevTab2 = function(tabid) {
			if ($scope.advAccessdata.indexOf('WS Business Info') > -1) {
				$scope.moreInputFlag = false;
			} else {
				$scope.moreInputFlag = true;
			}
			$scope.showwizardop = false;
			if ($scope.advAccessdata.indexOf('Credit Rating Details') > -1) {
				$scope.moreop = false;
			} else {
				$scope.moreop = true;
			}
			$timeout(function() {
				$scope.activeflag.val = 2;
			}, 0);
		}

		$scope.shownextinputfilter = function() {
			$timeout(function() {

				$scope.activeflag.val = 1;
				$scope.step1 = true;

			}, 1);

			$scope.sectionipfilter = [];
			ivhTreeviewBfs($scope.searchfiletrdata, opts, function(node) {

				if ($scope.selectedsec.inputfilterid.indexOf(node.id) > -1) {
					$scope.sectionipfilter.push(node);
				} 
			});
			$scope.searchsectiondata = $scope.sectionipfilter;
			$scope.shownext = true;
			$scope.shownext1 = false;
			$scope.activeflag.val = 1;
		}

/*		if ($scope.advAccessdata.indexOf('WS Business Info') > -1) {
			$scope.moreInputFlag = false;
		} else {
			$scope.moreInputFlag = true;
		}*/

		$scope.moreInput = function() {

			// only access to RA1
			if ($scope.advAccessdata.indexOf('WS Business Info') == -1) {
				$scope.nextbuttonflag = true;
				$scope.iferror = true;
				$scope.errorMessages
						.push("This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001. ");

				$timeout(function() {

					$scope.iferror = false;
					$scope.errorMessages = "";

				}, 5000);

				return false;
			}
			$scope.moreInputFlag = true;
			$scope.searchsectiondata = $scope.searchfiletrdata;
		}

		$scope.loadWizardData = function() {

			// disable temp for future.
			// alert('This feature is temporarily unavailable, please use the
			// "custom search" feature to execute queries.');
			// return;
			$scope.searchType = 'WIZARD';
			$scope.filterUiArray = [];
			$scope.runflag = false;
			var reqflag = 0;
			$http
					.post('api/masterData/getAdvanceFilterTreeList')
					.success(
							function(data) {

								ivhTreeviewBfs(data, opts, function(node) {

									if (node.children != undefined
											&& node.children.length > 0) {
										node.disabled = true;
									} else {
										node.disabled = false;
									}
								});
								$scope.searchfiletrdata = data;

								$scope.selecteddate = {

									option : "single"

								};
								reqflag = reqflag + 1;

								if ($scope.selecteddate.option == 'single') {
									$scope.searchfiletrdatac = angular
											.copy($scope.searchfiletrdata);

									ivhTreeviewBfs(
											$scope.searchfiletrdatac,
											opts,
											function(node) {
												if (node.filterTreeId
														.indexOf('CR_Date_rng_') > -1
														|| node.filterTreeId
																.indexOf('CR_Date_rng_Rating Action') > -1
														|| node.filterTreeId
																.indexOf('All_agncy_dtrng') > -1
														|| node.filterTreeId
																.indexOf('All_agncy_dtrng_Rating Action') > -1
														|| node.filterTreeId
																.indexOf('All_Case Type') > -1
														|| node.filterTreeId
																.indexOf('CR_Case Type') > -1) {
													node.disabled = true;

												}
											});
									$timeout(
											function() {
												$scope.searchfiletrdata = $scope.searchfiletrdatac
											}, 20);

								}
							});

			$http.post('api/advanceSearch/getWizardData').success(
					function(data) {
						$scope.sectionlist = data;
						$scope.loading = false;
					});

		}
		// end of wizard

		$scope.setCompanyTool = function(flag) {

			// will not check this condition if current search tool is wizard
			if (!$scope.wizardflag && $scope.deniedRA2nd3()) {
				return false;
			}
			if (flag === 'true') {
				$scope.searcharr = [];
				$scope.searchType = 'COMPANY_TOOL';
			}
			$http
					.post('api/advanceSearch/getCompanySearchToolData')
					.success(
							function(data) {

								$scope.sectiondataall = data;
								$scope.sectiondata = $scope.sectiondataall
										.filter(function(row) {
											return row.displayflag == 'Y'
													&& !(row.s_no == 26
															|| row.s_no == 27
															|| row.s_no == 28 || row.s_no == 29);

										});

								for (var i = 0; i < $scope.sectiondata.length; i++) {

									if ($scope.sectiondata[i].sectionName == 'Company Background'
											&& $scope.advAccessdata
													.indexOf('Company Background') > -1) {
										$scope.sectiondata[i].enableFlag = true;
									}
									if (($scope.sectiondata[i].sectionName == 'Detailed Financials'
											|| $scope.sectiondata[i].sectionName == 'Interim Financials' || $scope.sectiondata[i].sectionName == 'Summary Financials')
											&& $scope.advAccessdata
													.indexOf('Financial Information') > -1) {
										$scope.sectiondata[i].enableFlag = true;
									}
									// /added for RA2 nd RA3 acess for Summary
									// Financials section in wizard only
									if (($scope.sectiondata[i].sectionName == 'Summary Financials')
											&& $scope.advAccessdata
													.indexOf('Summary Financials') > -1
											&& $scope.searchType === 'WIZARD') {
										$scope.sectiondata[i].enableFlag = true;
									}
									if ($scope.sectiondata[i].sectionName == 'Business Information'
											&& $scope.advAccessdata
													.indexOf('Business Information') > -1) {
										$scope.sectiondata[i].enableFlag = true;
									}
									if ($scope.sectiondata[i].sectionName == 'Credit rating details '
											&& $scope.advAccessdata
													.indexOf('Credit Rating Details') > -1) {
										$scope.sectiondata[i].enableFlag = true;
									}
									if (($scope.sectiondata[i].sectionName == 'Equity Details' || $scope.sectiondata[i].sectionName == 'Fixed Income')
											&& $scope.advAccessdata
													.indexOf('Equity  / Fixed Income Details') > -1) {
										$scope.sectiondata[i].enableFlag = true;
									}
									if ($scope.sectiondata[i].sectionName == 'FSM Score' && ($scope.Advsrchmoduleaccess['Financial Sensitivity Model'] || $scope.Advsrchmoduleaccess['FSM Unlisted'] || $scope.Advsrchmoduleaccess['FMSM'])) {
										$scope.sectiondata[i].enableFlag = true;
									}
									if ($scope.sectiondata[i].sectionName == 'ScoreCard' && $scope.Advsrchmoduleaccess['Scorecard']) {
										$scope.sectiondata[i].enableFlag = true;
									}

								}

								$scope.sectiondata = $scope.sectiondata
										.map(function(row) {
											if (row.enableFlag == undefined) {
												row.enableFlag = false;
											}
											return row;
										});
								$scope.tempdata = angular
										.copy($scope.sectiondata);

							});

		}

		var companycodesselected = null;
		$scope.getsectiondatainoutput = function(gridflag) {

			$scope.tempdata = angular.copy($scope.sectiondata);
			$scope.selarr = [];
			$scope.arrtosend = [];
			for (var i = 0; i < $scope.sectiondata.length; i++) {

				if ($scope.sectiondata[i].sectionName == 'Summary Financials'
						&& $scope.sectiondata[i].checkflag == 'on') {
					$scope.filteredarr = $scope.sectiondataall.filter(function(
							row) {
						return row.moduleName != ''
								&& row.sectionName == 'Summary Financials';
					}, 100);
					$scope.filteredarr.map(function(row) {
						$scope.arrtosend.push(row)
					});
				} else if ($scope.sectiondata[i].sectionName == 'Detailed Financials'
						&& $scope.sectiondata[i].checkflag == 'on') {
					$scope.filteredarr = $scope.sectiondataall.filter(function(
							row) {
						return row.moduleName != ''
								&& row.sectionName == 'Detailed Financials';
					}, 100);
					$scope.filteredarr.map(function(row) {
						$scope.arrtosend.push(row)
					});
				} else if ($scope.sectiondata[i].sectionName == 'Interim Financials'
						&& $scope.sectiondata[i].checkflag == 'on') {
					$scope.filteredarr = $scope.sectiondataall.filter(function(
							row) {
						return row.moduleName != ''
								&& row.sectionName == 'Interim Financials';
					}, 100);
					$scope.filteredarr.map(function(row) {
						$scope.arrtosend.push(row)
					});
				} else if ($scope.sectiondata[i].sectionName == 'Business Information'
						&& $scope.sectiondata[i].checkflag == 'on') {
					$scope.filteredarr = $scope.sectiondataall.filter(function(
							row) {
						return row.moduleName == 'All'
								&& row.sectionName == 'Business Information';
					}, 100);

					$scope.filteredarr.map(function(row) {
						$scope.arrtosend.push(row)
					});
				} else if ($scope.sectiondata[i].checkflag == 'on') {

					$scope.arrtosend.push($scope.sectiondata[i]);
				}
			}

			if ($scope.associate_comp_flag) {
				$scope.asscomparr = $scope.sectiondataall.filter(function(row) {
					return row.sectionName == 'Associate company';
				}, 100);

				$scope.arrtosend.push($scope.asscomparr[0]);
			}

			if ($scope.searcharr.length > 0 && $scope.arrtosend.length > 0) {
				$scope.validateCompany = " ";

				$scope.sectiondata = $scope.sectiondata.map(function(row) {
					if (row.enableFlag == undefined) {
						row.enableFlag = false;
					}
					return row;
				});
				$scope.tempdata = angular.copy($scope.sectiondata);

				companycodesselected = $scope.searcharr.map(function(row) {
					return row.companyCode;
				});

				var flagforadddata = false;
				var moredataarr = [ 'Summary Financials',
						'Detailed Financials', 'Interim Financials',
						'Financial Information', 'Credit rating details ',
						'Business Information' ];

				$scope.arrtosend.map(function(row) {
					row.currentYear = $scope.currentYear.val;
					row.currentQuarter = $scope.currentQuarter.val;
					if (moredataarr.indexOf(row.sectionName) > -1) {
						flagforadddata = true;
					}
				});

				if (companycodesselected.length > 1000 && flagforadddata) {
					$('#hideshowcolumn').modal('hide');

					$('#moredata').modal('show');

				} else {
					
					$scope.proceedgetsectiondata();

				}

			} else {

				$scope.validateCompany = "Select Aleast one Company and Filter Name ";
			}
		}

		$scope.proceedgetsectiondata = function() {

			var filter = {
				pageNumber : 1,
				pageSize : 10,
				filterExpressions : [],
				sortExpressions : [],
				doFilter: false,
				ratingActionIndex: -1,
				lastRatingActionIndex: -1,
				ltRating: -1,
				stRating: -1

			};

			if (typeof $scope.filter != 'undefined') {
				filter.pageNumber = $scope.filter.pageIndex + 1 || 1;
				filter.pageSize = $scope.filter.pageSize || 10;

				//for filter expression
				$scope.filter.filterExpressions.forEach(function(
						filterExpression) {

					var expression = {};
					expression.columnIndex = filterExpression.columnName;
					expression.expression = filterExpression.expression;
					filter.filterExpressions.push(expression);
				});

				$scope.filter.sorts.forEach(function(sortExpression) {

					var expression = {};
					expression.sortColumn = sortExpression.sortColumn;
					expression.sortOrder = sortExpression.isAscending ? "asc"
							: "desc";
					filter.sortExpressions.push(expression);
				});

			}
			
			//this filter are for Suspended / INC*>15M Case
			if (!$scope.rbtnCaseTypeAll
					&& (typeof $scope.wizardop != 'undefined' || typeof $scope.filterdataoutput != 'undefined')) {
				filter.doFilter = true;
				if ($scope.gridflag == 'WIZARD') {
					filter.ratingActionIndex = $scope.wizardop.ratingActionIndex;
					filter.lastRatingActionIndex = $scope.wizardop.lastRatingActionIndex;
					filter.ltRating = $scope.wizardop.ltRating;
					filter.stRating = $scope.wizardop.stRating;
					
				} else if ($scope.gridflag == 'SEARCH') {
					filter.ratingActionIndex = $scope.filterdataoutput.ratingActionIndex;
					filter.lastRatingActionIndex = $scope.filterdataoutput.lastRatingActionIndex;
					filter.ltRating = $scope.filterdataoutput.ltRating;
					filter.stRating = $scope.filterdataoutput.stRating;
				}
			}
			
			// to enable return filter object for
			// search company
			var filterType = $scope.searchType;
			if (filterType == 'CUSTOM' || $scope.runflag) {
				filterType = 'CUSTOM';
				$scope.filterdatalist = angular
						.toJson($scope.finalFilterArr);
			} else if (filterType == 'WIZARD') {
				$scope.filterdatalist = angular
						.toJson($scope.wizardFilters);
			}

			var dataTosend = {
				"sectiondata" : $scope.arrtosend,
				"pagable" : filter,
				"universeFlag" : $scope.universeFlag,
				"smeflag" : $scope.smeflag,
				"gridflag" : filterType,
				"currentYear" : $scope.currentYear.val,
				"currentQuarter" : $scope.currentQuarter.val,
				"associate_comp_flag" : $scope.associate_comp_flag,
				"filterObj" : '',
				"cacheReload" : $scope.cacheReload
			};

			if ($scope.searchType == 'CUSTOM' || $scope.searchType == 'WIZARD' || $scope.runflag) {
				dataTosend.filterObj = $scope.filterdatalist;
			}
			// $http({
			// 	url : 'api/advanceSearch/getsectiondataforcodes',
			// 	method : 'POST',
			// 	data : dataTosend,
			// })

			advanceSearchautocomplete
			.getsectiondataforcodes(dataTosend)
			.then(
					function(response) {

						if (response.length > 0) {
							
							$scope.cacheReload = false;
							$scope.headerrow = response[0];
							$scope.searchOutput = response[3];
							$scope.compCount = response[1];
							$scope.searchOutputRowCnt = response[2];
							var index = 0;
							var lastRatingActionIndex = -1;
							var ratingActionIndex = -1;
							var ltRating= -1;
							var stRating= -1;
							$scope.columnsarr = $scope.headerrow
									.map(function(row) {
										if (row.displayFlag) {
											row.displayindex = index;
										}
										if ($scope.storeColumnIndexOf[0] == row.displayName
												.trim()) {
											lastRatingActionIndex = index;
										} else if ($scope.storeColumnIndexOf[1] == row.displayName
												.trim()) {
											ratingActionIndex = index;
										}
										else if ($scope.storeColumnIndexOf[2] == row.displayName
												.trim()) {
											ltRating = index;
										}
										else if ($scope.storeColumnIndexOf[3] == row.displayName
												.trim()) {
											stRating = index;
										}
										index = index + 1;
										return row;
									});
							$scope.columnsarr = $scope.columnsarr
									.filter(function(row) {
										return row.displayFlag;
									});

							if ($scope.gridflag == 'RUN') {
								$scope.showrun = true;
								$scope.showsavedfilter = false;

								$scope.filterrunqueryop = {
									dataProvider : $scope.searchOutput,
									styles : flexiciousNmsp.UIUtils
											.getThemeById('officeblue').styles,
									delegate : $scope
								};
								$timeout(function() {
									$scope.buildGridrunoutput();
								}, 100);

							}

							if ($scope.gridflag == 'WIZARD') {
								$scope.showwizardop = true;

								$scope.wizardop = {
									dataProvider : $scope.searchOutput,
									styles : flexiciousNmsp.UIUtils
											.getThemeById('officeblue').styles,
									delegate : $scope,
									lastRatingActionIndex : lastRatingActionIndex,
									ratingActionIndex : ratingActionIndex,
									ltRating : ltRating,
									stRating : stRating,
									outStandingRatingIndex : -1
								};
								$timeout(function() {
									$scope.buildGridwizardopfilter();
								}, 100);

							}

							if ($scope.gridflag == 'SEARCH') {
								$scope.showSearchResult = true;
								$scope.custsearchfilterflag = false;
								$scope.filterdataoutput = {
									dataProvider : $scope.searchOutput,
									styles : flexiciousNmsp.UIUtils
											.getThemeById('officeblue').styles,
									delegate : $scope,
									lastRatingActionIndex : lastRatingActionIndex,
									ratingActionIndex : ratingActionIndex,
									ltRating : ltRating,
									stRating : stRating,
									outStandingRatingIndex : -1
								};
								$timeout(function() {
									$scope.buildGridfilteroutput();
								}, 100);

							}
							$scope.removeData = true;
						}
						$('#hideshowcolumn').modal('hide');
					}, function(errordata) {
					});



			 

			$('#moredata').modal('hide');

		}

		$scope.companysearchresultflag = false;

		$scope.searchCompanyTool = function(flag) {

			if ($scope.searcharr.length == 0) {

				$scope.errorMessages = [];
				$scope.iferror = true;
				$scope.errorMessages
						.push("Please select atleast one company to search");

				$window.scrollTo(0, 0);
				$timeout(function() {
					$scope.iferror = false;
					$scope.errorMessages = [];

				}, 5000);
				return false;

			}

			var validarr = $scope.sectiondata.filter(function(row) {
				return row.checkflag == 'on';
			});

			if (validarr.length == 0) {

				$scope.errorMessages = [];
				$scope.iferror = true;
				$scope.errorMessages.push("Please select atleast one filter");

				$window.scrollTo(0, 0);
				$timeout(function() {
					$scope.iferror = false;
					$scope.errorMessages = [];

				}, 5000);
				return false;

			}
			$scope.errorMessages = [];
			if ($scope.searcharr.length > 0 && validarr.length > 0) {
				$scope.showcompanysrchfiler = false;

				$scope.validateCompany = " ";

				$http({
					url : 'api/advanceSearch/getSegmentMapping',
					method : 'POST',
					data : $scope.searcharr,
				})
						.success(
								function(data) {
									$scope.arrtosend = [];
									for (var i = 0; i < $scope.sectiondata.length; i++) {

										if ($scope.sectiondata[i].sectionName == 'Summary Financials'
												&& $scope.sectiondata[i].checkflag == 'on') {

											if (data.indexOf("dummy") > -1) {
												$scope.errorMessages
														.push(" Financial data will not be vaialable for this company ");
											}

											$scope.filteredarr = $scope.sectiondataall
													.filter(
															function(row) {
																return data
																		.indexOf(row.moduleName) > -1
																		&& row.sectionName == 'Summary Financials';
															}, 100);
											$scope.filteredarr
													.map(function(row) {
														$scope.arrtosend
																.push(row)
													});
										} else if ($scope.sectiondata[i].sectionName == 'Detailed Financials'
												&& $scope.sectiondata[i].checkflag == 'on') {
											$scope.filteredarr = $scope.sectiondataall
													.filter(
															function(row) {
																return data
																		.indexOf(row.moduleName) > -1
																		&& row.sectionName == 'Detailed Financials';
															}, 100);
											$scope.filteredarr
													.map(function(row) {
														$scope.arrtosend
																.push(row)
													});
										} else if ($scope.sectiondata[i].sectionName == 'Interim Financials'
												&& $scope.sectiondata[i].checkflag == 'on') {
											$scope.filteredarr = $scope.sectiondataall
													.filter(
															function(row) {
																return data
																		.indexOf(row.moduleName) > -1
																		&& row.sectionName == 'Interim Financials';
															}, 100);
											$scope.filteredarr
													.map(function(row) {
														$scope.arrtosend
																.push(row)
													});
										}

										else if ($scope.sectiondata[i].sectionName == 'Business Information'
												&& $scope.sectiondata[i].checkflag == 'on') {
											$scope.filteredarr = $scope.sectiondataall
													.filter(
															function(row) {
																return row.moduleName == 'All'
																		&& row.sectionName == 'Business Information';
															}, 100);
											$scope.filteredarr
													.map(function(row) {
														$scope.arrtosend
																.push(row)
													});
										} else if ($scope.sectiondata[i].checkflag == 'on') {

											$scope.arrtosend
													.push($scope.sectiondata[i]);
										}
									}

									var companycodesselected = $scope.searcharr
											.map(function(row) {
												return row.companyCode;
											});
									$scope.arrtosend
											.map(function(row) {
												row.companyCodes = companycodesselected;
												row.currentYear = $scope.currentYear.val;
												row.currentQuarter = $scope.currentQuarter.val;
											});
									if ($scope.arrtosend.length == 0) {
										$scope.iferror = true;
										$scope.errorMessages = [];
										$scope.errorMessages
												.push("No data found for selected criteria ");
										$window.scrollTo(0, 0);
										$timeout(function() {

											$scope.iferror = false;

										}, 5000);

										return false;

									}

									// will use for set alert for all company
									$scope.companyFilters = $scope.arrtosend;

									$http(
											{
												url : 'api/advanceSearch/getAdvOutpitFilterlist',
												method : 'POST',
												data : $scope.arrtosend,
											})
											.success(
													function(response) {
														if ($scope.errorMessages.length > 0) {
															$scope.iferror = true;
														}

														$scope.headerlist = response[0];
														$scope.searchOutput = response
																.slice(
																		2,
																		response.length);
														if (flag === 'search') {

															$scope.dtoheaderlistnew = [];
															angular
																	.forEach(
																			$scope.headerlist,
																			function(
																					x) {

																				if (((x
																						.indexOf('Company Code') > -1) || x
																						.indexOf('Company_Code') > -1)
																						|| (x
																								.indexOf('RNK') > -1)
																						|| (x
																								.indexOf('COMPANY CODE') > -1)
																						|| (x
																								.indexOf('PR_DOCUMENT') > -1)
																						|| (x
																								.indexOf('CRR_DOCUMENT') > -1)) {
																					$scope.temp = {
																						columnName : "",
																						displayName : x,
																						displayFlag : false
																					};
																				} else {
																					$scope.temp = {
																						columnName : "",
																						displayName : x,
																						displayFlag : true
																					};
																				}

																				$scope.dtoheaderlistnew
																						.push($scope.temp);
																			})
															var index = 0;
															$scope.columnsarr = $scope.dtoheaderlistnew
																	.map(function(
																			row) {
																		if (row.displayFlag) {
																			row.displayindex = index;
																		}
																		index = index + 1;
																		return row;
																	});
															$scope.columnsarr = $scope.columnsarr
																	.filter(function(
																			row) {
																		return row.displayFlag;
																	});
															$scope.filterdataoutputtool = {
																dataProvider : $scope.searchOutput,
																styles : flexiciousNmsp.UIUtils
																		.getThemeById('officeblue').styles,
																delegate : $scope
															};
															// to collapse
															// filter section
															$scope.showcompanysrchfiler = false;
															$scope.loading = false;
															$scope.companysearchresultflag = true;
															$timeout(
																	function() {
																		$scope
																				.buildGridfilteroutputopfilter();
																	}, 100);

														}
														if (flag === 'run') {

															$scope.temp = {};
															$scope.dtoheaderlistnew = [];

															angular
																	.forEach(
																			$scope.headerlist,
																			function(
																					x) {

																				if (((x
																						.indexOf('Company Code') > -1) || x
																						.indexOf('Company_Code') > -1)
																						|| (x
																								.indexOf('RNK') > -1)
																						|| (x
																								.indexOf('COMPANY CODE') > -1)
																						|| (x
																								.indexOf('PR_DOCUMENT') > -1)
																						|| (x
																								.indexOf('CRR_DOCUMENT') > -1)) {
																					$scope.temp = {
																						columnName : "",
																						displayName : x,
																						displayFlag : false
																					};
																				} else {
																					$scope.temp = {
																						columnName : "",
																						displayName : x,
																						displayFlag : true
																					};
																				}

																				$scope.dtoheaderlistnew
																						.push($scope.temp);
																			})

															$scope.arrLen = $scope.headerrow.length;

															angular
																	.forEach(
																			$scope.dtoheaderlistnew,
																			function(
																					value,
																					key) {

																				$scope.headerrow[$scope.arrLen] = value;

																				$scope.arrLen++;

																			});
															var index = 0;
															$scope.columnsarr = $scope.headerrow
																	.map(function(
																			row) {
																		if (row.displayFlag) {
																			row.displayindex = index;
																		}
																		index = index + 1;
																		return row;
																	});
															$scope.columnsarr = $scope.columnsarr
																	.filter(function(
																			row) {
																		return row.displayFlag;
																	});

															$scope.runLen = $scope.searchRunOutput.length + 1;

															angular
																	.forEach(
																			$scope.searchOutput,
																			function(
																					value,
																					key) {

																				$scope.searchRunOutput[$scope.runLen] = value;

																				$scope.runLen++;

																			});

															$scope.filterrunqueryop = {
																dataProvider : $scope.searchRunOutput,
																styles : flexiciousNmsp.UIUtils
																		.getThemeById('officeblue').styles,
																delegate : $scope
															};
															$timeout(
																	function() {
																		$scope
																				.buildGridrunoutput();
																	}, 100);

														}
													});
								});
			} else {

				$scope.validateCompany = "Select Aleast one Company and Filter Name ";
			}

		}

		$scope.reset = function() {
			$scope.filterUiArray.forEach(function(entry) {
				$scope.removeFromArr(entry);
			});
			$scope.success = '';
			$scope.selecteddate.option = null;
			$scope.successPortfolio = '';
			$scope.showSearchResult = false;
			if ($scope.isWizardRatingSearch()){
				$scope.queryflag = "reset";
			}else{
				$scope.custAddData = false;
				$scope.setCustomSearchTool();
			}
		}

		$rootScope.homePageMenuStatus = false;
		$rootScope.bm = false;
		$rootScope.qst = false;
		$rootScope.score = false;
		$rootScope.sme = false;
		$rootScope.fsm = false;
		$rootScope.home = false;
		$rootScope.projections = false;
		$rootScope.compProfile = false;
		$rootScope.advanceSearch = true;
		$scope.loaddirective = false;
		$scope.indtreeid = "advanceSearchIndTree";
		$scope.indtreeid1 = "advanceSearchIndTree1";
		var grid = null;
		$scope.filterUiArray = [];
		var count = 1;
		$scope.searcharr = [];

		$scope.deleteFromList = function(obj) {
			$scope.searcharr.splice($scope.searcharr.indexOf(obj), 1);
			if ($scope.searcharr.length == 0) {
				$scope.compSearched = true;
			}
		}
		$scope.deleteFromListcmp = function(obj) {
			$scope.searcharrcmp.splice($scope.searcharrcmp.indexOf(obj), 1);
		}

		$scope.deleteFromListbod = function(obj) {
			$scope.searcharrbod.splice($scope.searcharrbod.indexOf(obj), 1);
		}
		$scope.deleteFromListCustomer = function(obj) {
			$scope.searcharrcustomer.splice($scope.searcharrcustomer
					.indexOf(obj), 1);
		}
		$scope.deleteFromListSupplier = function(obj) {
			$scope.searcharrSupplier.splice($scope.searcharrSupplier
					.indexOf(obj), 1);
		}
		$scope.setselectedval = function(obj) {

			var ifpresentcomp = $scope.searcharr.filter(function(row) {
				return row.companyName == obj.companyName;
			});

			if (ifpresentcomp.length == 0) {
				$scope.searcharr.push(obj);
				$scope.compSearched = false;
			}

			$scope.searchcomp = ' ';
			$scope.searchbod = ' ';
			$scope.searchCustomer = ' ';
			$scope.searchSupplier = ' ';
		}

		$scope.setselectedvalcomp = function(obj) {

			var ifpresentcomp1 = $scope.searcharrcmp.filter(function(row) {
				return row.companyName == obj.companyName;
			});

			if (ifpresentcomp1.length == 0) {
				$scope.searcharrcmp.push(obj);
				$scope.compSearched = false;
			}

			$scope.searchcomp = ' ';
		}

		$scope.searcharrbod = [];
		$scope.setselectedvalbod = function(obj) {

			var ifpresentcomp2 = $scope.searcharrbod.filter(function(row) {
				return row == obj;
			});

			if (ifpresentcomp2.length == 0) {
				$scope.searcharrbod.push(obj);
			}

			$scope.searchbod = ' ';
		}

		$scope.searchFilterAutocompletebod = function(typedthings) {
			$scope.selected = true;

			if (typedthings == "cleanData") {
				$scope.listofobjbod = null;

			} else {
				advanceSearchautocomplete
						.getBODListByName(typedthings)
						.then(
								function(response) {
									$scope.listofobjbod = response.data;
									if ($scope.listofobjbod.length == 0) {
										$scope.error = true;
										$scope.showError = true;
										$scope.errorMessages = "No records match the text entered, please change your selection.";
										$timeout(function() {
											$scope.error = false;
											$scope.showError = false;
											$scope.errorMessages = "";
										}, 2000);
									}
								}, function(errordata) {
								});
			}

		}

		$scope.searcharrcustomer = [];

		$scope.setselectedvalCustomer = function(obj) {

			var ifpresentcomp2 = $scope.searcharrcustomer.filter(function(row) {
				return row == obj;
			});

			if (ifpresentcomp2.length == 0) {
				$scope.searcharrcustomer.push(obj);
			}

			$scope.searchCustomer = ' ';
		}

		$scope.searchFilterAutocompleteCustomers = function(typedthings) {
			$scope.selected = true;

			if (typedthings == "cleanData") {
				$scope.listofobjcustomer = null;

			} else {
				advanceSearchautocomplete
						.getCustomerByName(typedthings)
						.then(
								function(response) {
									$scope.listofobjcustomer = response.data;
									if ($scope.listofobjcustomer.length == 0) {
										$scope.error = true;
										$scope.showError = true;
										$scope.errorMessages = "No records match the text entered, please change your selection.";
										$timeout(function() {
											$scope.error = false;
											$scope.showError = false;
											$scope.errorMessages = "";
										}, 2000);
									}
								}, function(errordata) {
								});
			}

		}
		$scope.searcharrSupplier = [];
		$scope.setselectedvalSupplier = function(obj) {

			var ifpresentcomp2 = $scope.searcharrSupplier.filter(function(row) {
				return row == obj;
			});

			if (ifpresentcomp2.length == 0) {
				$scope.searcharrSupplier.push(obj);
			}

			$scope.searchSupplier = ' ';

		}

		$scope.searchFilterAutocompleteSupplier = function(typedthings) {
			$scope.selected = true;

			if (typedthings == "cleanData") {
				$scope.listofobjSupplier = null;

			} else {
				advanceSearchautocomplete
						.getCustomerByName(typedthings)
						.then(
								function(response) {
									$scope.listofobjSupplier = response.data;
									if ($scope.listofobjSupplier.length == 0) {
										$scope.error = true;
										$scope.showError = true;
										$scope.errorMessages = "No records match the text entered, please change your selection.";
										$timeout(function() {
											$scope.error = false;
											$scope.showError = false;
											$scope.errorMessages = "";
										}, 2000);
									}
								}, function(errordata) {
								});
			}

		}

		$scope.compSearched = true;
		$scope.searchFilterAutocomplete = function(typedthings) {
			$scope.selected = true;
			if (typedthings == "cleanData") {
				$scope.listofobj = null;

			} else {
				GenericServiceNew
						.getCompaniesListByNameNew(typedthings,
								"COMPANYPROFILE")
						.then(
								function(response) {
									$scope.listofobj = response;

									if ($scope.listofobj.length == 0) {
										$scope.error = true;
										$scope.showError = true;
										$scope.errorMessages = "No records match the text entered, please change your selection.";
										$timeout(function() {
											$scope.error = false;
											$scope.showError = false;
											$scope.errorMessages = "";
										}, 2000);
									}
								}, function(errordata) {
								});
			}

		}

		Array.prototype.groupBy = function(prop) {
			return this.reduce(function(groups, item) {
				var val = item[prop];
				groups[val] = groups[val] || [];
				groups[val].push(item);
				return groups;
			}, {});
		}

		$scope.showErrorMessages = function() {
			$scope.errorMessages = [];
			$scope.iferror = true;
			$scope.errorMessages
					.push("This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.");

			$window.scrollTo(0, 0);
			$timeout(function() {
				$scope.iferror = false;
				$scope.errorMessages = [];
				$scope.filterUiArray.forEach(function(entry) {
					entry.errorflag = false;
				});
			}, 5000);
			return false;
		}

		$scope.closeOtherParent = function(ivhNode, ivhIsSelected, ivhTree) {

			var parentHierarchy = ivhNode.hierarchy.split('.')[0];

			if (typeof ivhTree[parentHierarchy - 1] !== 'undefined') {
				var parentNodeId = ivhTree[parentHierarchy - 1].id;

				ivhTreeviewBfs($scope.searchfiletrdata, opts, function(node) {

					if (node.parentId === 'null' && parentNodeId !== node.id) {
						ivhTreeviewMgr.collapse($scope.searchfiletrdata, node,
								opts, true);
					}

				});
				$scope.scrollToNode(ivhNode);
			}

		}

		$scope.scrollToNode = function(ivhNode) {
			$timeout(function() {
				var pos = $("[title='" + ivhNode.label + "']").offset().top;
				if (pos > 0) {
					pos = Math
							.abs((pos - $("[ivh-treeview='searchfiletrdata']")
									.offset().top) - 100)
				} else {
					pos = Math
							.abs((pos - $("[ivh-treeview='searchfiletrdata']")
									.offset().top) + 100);
				}
				$('.advanceinputleft').animate({
					scrollTop : pos
				}, 'slow');
			}, 30);
		}
		
		//will use for ui array validation
//		$scope.$watchCollection('filterUiArray', function(newValue, oldValue) {
//
//			console.log(newValue);
//		    console.log(oldValue);
//		    
//		    var addedArray = newValue.filter(function(x) { return !oldValue.find(function(f){ return f.uicomponent == x.uicomponent; });});
//		    var removedArray = oldValue.filter(function(x) { return !newValue.find(function(f){ return f.uicomponent == x.uicomponent; });});
//		
//		    var changedObject = {added: addedArray, removed: removedArray};
//		    $scope.changedItems = [];
//		    $scope.changedItems.push(changedObject);
//		    console.log($scope.changedItems);
//		    
//		});
		
		$scope.filterAccessFlag = function(ivhNode) {
			
			return ($scope.advAccessdata.indexOf('Industry Info') == -1
					&& ivhNode.filterTreeId.startsWith('ind')) || 
					($scope.advAccessdata.indexOf('Business Information') == -1
							&& ivhNode.filterTreeId.startsWith('Business')) ||
							($scope.advAccessdata.indexOf('Company Background') == -1
									&& ivhNode.filterTreeId.startsWith('CB')) ||
									($scope.advAccessdata.indexOf('Financial Information') == -1
											&& ivhNode.filterTreeId.startsWith('Manf', 'BANK',
													'NBFC', 'Intrm_manf', 'Intrm_Bank',
													'Intrm_Nbfc', 'annual_manf', 'annual_Bank',
													'annnual_nbfc')) || 
													($scope.advAccessdata
															.indexOf('Equity  / Fixed Income Details') == -1
															&& ivhNode.filterTreeId
																	.startsWith('equity', 'fix_incm')) || 
																	($scope.advAccessdata.indexOf('Credit Rating Details') == -1
																			&& ivhNode.filterTreeId.startsWith('CR_', 'All'));	
													
			
		}
		
		$scope.displayFilter = function(ivhNode, ivhIsSelected, ivhTree) {

			$scope.closeOtherParent(ivhNode, ivhIsSelected, ivhTree);
			if (ivhIsSelected) {

				$scope.showSearchResult = false;
				// validation for user access
				if($scope.filterAccessFlag(ivhNode)){
					$timeout(function() {
						ivhTreeviewMgr.deselect($scope.searchfiletrdata,
								ivhNode, opts);
					}, 10);
					return $scope.showErrorMessages();
				}
				
				if (ivhNode.disabled) {
					$timeout(function() {
						ivhTreeviewMgr.deselect($scope.searchfiletrdata,
								ivhNode, opts);
					}, 10);
					return false;
				}

				$scope.success = '';

				if (ivhNode.uiType == 'datefilter') {
					var opDate = $filter('date')(new Date(), "dd-MM-yyyy");
					var tempdate = {
						start : opDate,
						end : opDate
					};
					var uifilter = {
						'uicomponent' : ivhNode.uiType,
						'datasource' : tempdate,
						'order' : count,
						'node' : ivhNode,
						'showhideflag' : true,
						'selectedVals' : null
					};
					uifilter.errorflag = false;
					$scope.filterUiArray.push(uifilter);

				}
				if (ivhNode.uiType == 'date_filter_fsm') {
					var opDate = $filter('date')(new Date(), "dd-MM-yyyy");
					var tempdate = {
						start : opDate,
						end : opDate
					};
					var uifilter = {
						'uicomponent' : ivhNode.uiType,
						'datasource' : tempdate,
						'order' : count,
						'node' : ivhNode,
						'showhideflag' : true,
						'selectedVals' : null
					};
					uifilter.errorflag = false;
					$scope.filterUiArray.push(uifilter);

				}
				if (ivhNode.uiType == 'daterangefilter') {
					var opDate = $filter('date')(new Date(), "dd-MM-yyyy");
					var tempdate = {
						start : opDate,
						end : opDate
					};
					var uifilter = {
						'uicomponent' : ivhNode.uiType,
						'datasource' : tempdate,
						'order' : count,
						'node' : ivhNode,
						'showhideflag' : true,
						'selectedVals' : null
					};
					uifilter.errorflag = false;
					$scope.filterUiArray.push(uifilter);

					return;
				}

				if (ivhNode.uiType == 'FixedIncomeDateFilter') {
					var opDate = $filter('date')(new Date(), "dd-MM-yyyy");
					var tempdate = {
						start : opDate
					};
					var uifilter = {
						'uicomponent' : ivhNode.uiType,
						'datasource' : tempdate,
						'order' : count,
						'node' : ivhNode,
						'showhideflag' : true,
						'selectedVals' : null
					};
					uifilter.errorflag = false;
					$scope.filterUiArray.push(uifilter);

					return;
				}

				if (ivhNode.uiType == 'facilityoptions') {
					var arr = ivhNode.fixedValueList.split(',');
					var dataarr = [];
					for (var i = 0; i < arr.length; i++) {
						var temp = {
							catogory : arr[i]
						};
						dataarr.push(temp);
					}
					var uifilter = {
						'uicomponent' : ivhNode.uiType,
						'datasource' : dataarr,
						'order' : count,
						'node' : ivhNode,
						'showhideflag' : true,
						'selectedVals' : null
					};
					uifilter.errorflag = false;
					$scope.filterUiArray.push(uifilter);
					return;
				}

				if (ivhNode.uiType == 'treeviewtype'
						&& ivhNode.filterTreeId != 'sf_rating type') {
					
					advanceSearchautocomplete
							.getMasterDataForUrl(ivhNode.id, 'api/advanceSearch/getMasterDataForFilterRating')
							.then(
									function(data) {
										var arr = [];
										var ratingtypeobj = data.groupBy('type');
										var ratetype = [];
										for ( var key in ratingtypeobj) {
											var obj = {
												'name' : key,
												'msGroup' : true
											};
											ratetype.push(obj);
											ratingtypeobj[key].map(function(row) {
												ratetype.push(row);
											});
											var objf = {

												'msGroup' : false
											};
											ratetype.push(objf);
										}
										var uiFilter = {
											'uicomponent' : ivhNode.uiType,
											'datasource' : ratetype,
											'order' : count,
											'node' : ivhNode,
											'showhideflag' : true,
											'selectedVals' : arr
										}
										uiFilter.errorflag = false;
										$scope.filterUiArray.push(uiFilter);

									}, function(errordata) {
									});
				
				}

				else if (ivhNode.queryFlag == 'Y') {

					if (ivhNode.filterTreeId == 'Business_info_str_weak'
							&& ivhNode.uiType == 'dropdown'
							&& ivhNode.label == 'Strengths / Weaknesses') {
						
						advanceSearchautocomplete
								.getMasterDataForUrl(ivhNode.id, 'api/advanceSearch/getMasterDataForFilterStrengthAndWeakness')
								.then(
										function(data) {
											$scope.strengthWeakness = data;

											var arr = [];
											var uiFilter = {
												'uicomponent' : ivhNode.uiType,
												'datasource' : [],
												'order' : count,
												'node' : ivhNode,
												'showhideflag' : true,
												'selectedVals' : arr
											}

											$scope.strengthFlag = false;
											$scope.weaknessFlag = false;

											if ($scope.strengthWeakness.strength != undefined
													&& $scope.strengthWeakness.strength.length > 0) {
												uiFilter.datasource = $scope.strengthWeakness.strength;

												$scope.business.strength = "Strength";
												$scope.strengthFlag = true;

												arr = [ uiFilter.datasource[0] ];

												if ($scope.strengthWeakness.weakness != undefined
														&& $scope.strengthWeakness.weakness.length > 0) {
													$scope.weaknessFlag = true;
													$scope.business.weakness = "Weakness";
												}
												$scope.business.strwk = "Strength";
											} else if ($scope.strengthWeakness.weakness != undefined
													&& $scope.strengthWeakness.weakness.length > 0) {
												$scope.strengthFlag = false;
												$scope.weaknessFlag = true;
												uiFilter.datasource = $scope.strengthWeakness.weakness;
												arr = [ uiFilter.datasource[0] ];
												$scope.business.weakness = "Weakness";
												$scope.business.strwk = "Weakness";
											} else if ($scope.strengthFlag == false
													&& $scope.weaknessFlag == false) {
												// error message
												$scope.errorMessages
														.push("Strength And Weakness Details is not available");
												$scope.iferror = true;

												$timeout(function() {

													$scope.iferror = false;
													$scope.errorMessages = "";

												}, 5000);
												$window.scrollTo(0, 0);

											}
											uiFilter.selectedVals = arr;
											uiFilter.errorflag = false;
											$scope.filterUiArray.push(uiFilter);

										}, function(errordata) {
										});
					
					} else {
						

						advanceSearchautocomplete
								.getMasterDataForUrl(ivhNode.id, 'api/advanceSearch/getMasterDataForFilter')
								.then(
										function(data) {

											if (ivhNode.uiType == 'quarter_dropdown') {

												var arr = [];
												var uiFilter = {
													'uicomponent' : ivhNode.uiType,
													'datasource' : $scope.quarterdropdowncusttool,
													'order' : count,
													'node' : ivhNode,
													'showhideflag' : true,
													'selectedVals' : arr
												}
												uiFilter.errorflag = false;
												$scope.filterUiArray
														.push(uiFilter);

											}

											else if (ivhNode.uiType == 'Rzslider') {
												var sliderdata = {
													minValue : data[2],
													maxValue : data[8],
													options : {
														stepsArray : data,
														showSelectionBar : true,
														showTicksValues : true

													}
												};
												var arr = [];
												var uiFilter = {
													'uicomponent' : ivhNode.uiType,
													'datasource' : sliderdata,
													'order' : count,
													'node' : ivhNode,
													'showhideflag' : true,
													'selectedVals' : arr
												}
												uiFilter.errorflag = false;
												$scope.filterUiArray
														.push(uiFilter);
											} else {
												var arr = [];
												var uiFilter = {
													'uicomponent' : ivhNode.uiType,
													'datasource' : data,
													'order' : count,
													'node' : ivhNode,
													'showhideflag' : true,
													'selectedVals' : arr
												}
												uiFilter.errorflag = false;
												$scope.filterUiArray
														.push(uiFilter);

											}
											
											$scope.indFilterFlag(ivhNode);

										}, function(errordata) {
										});
					}

				} else if (ivhNode.fixedValueFlag == 'Y') {
					if (ivhNode.uiType == 'year_dropdown') {

						var uiFilterDateParam = {
							'uicomponent' : ivhNode.uiType,
							'datasource' : $scope.yeararray,
							'order' : count,
							'node' : ivhNode,
							'showhideflag' : true,
							'selectedVals' : ''
						}
						uiFilterDateParam.errorflag = false;
						$scope.filterUiArray.push(uiFilterDateParam);

					}
					else if (ivhNode.uiType == 'year_dropdown_for_scorecard') {

						var uiFilterDateParam = {
							'uicomponent' : ivhNode.uiType,
							'datasource' : $scope.yeararray,
							'order' : count,
							'node' : ivhNode,
							'showhideflag' : true,
							'selectedVals' : ''
						}
						uiFilterDateParam.errorflag = false;
						$scope.filterUiArray.push(uiFilterDateParam);

					}
					else if (ivhNode.uiType == 'Rzslider_for_scorecard') {
						var data = [0,0.5,1,1.5,2,2.5,3,3.5,4,4.5,5,5.5,6,6.5,7,7.5,8,8.5,9,9.5,10];
						var sliderdata = {
							minValue : data[0],
							maxValue : data[9],
							options : {
								stepsArray : data,
								showSelectionBar : true,
								showTicksValues : true

							}
						};
						var arr = [];
						var uiFilter = {
							'uicomponent' : ivhNode.uiType,
							'datasource' : sliderdata,
							'order' : count,
							'node' : ivhNode,
							'showhideflag' : true,
							'selectedVals' : arr
						}
						uiFilter.errorflag = false;
						$scope.filterUiArray.push(uiFilter);
								
					}
					else if (ivhNode.uiType == 'range_input_fsm') {
						var rangedatasources = JSON
						.parse(ivhNode.fixedValueList);
						var uiFilterDateParam = {
								'uicomponent' : ivhNode.uiType,
								'datasource' : rangedatasources,
								'order' : count,
								'node' : ivhNode,
								'showhideflag' : true,
								'selectedVals' : ''
							}
						uiFilterDateParam.errorflag = false;
						
						$scope.filterUiArray.push(uiFilterDateParam);
					}

					else if (ivhNode.uiType == 'fin_info_range_input') {
						var keyrationtype = '';
						var rangedatasources = JSON
								.parse(ivhNode.fixedValueList)
								.map(
										function(row) {

											if (ivhNode.filterTreeId
													.indexOf('Manf') > -1) {
												keyrationtype = "Manufacutring"
											}
											if (ivhNode.filterTreeId
													.indexOf('BANK') > -1) {
												keyrationtype = "BANK"
											}
											if (ivhNode.filterTreeId
													.indexOf('NBFC') > -1) {
												keyrationtype = "NBFC"
											}
											if (ivhNode.filterTreeId
													.indexOf('Intrm_manf') > -1) {
												keyrationtype = "Interim_Manufacturing"
											}
											if (ivhNode.filterTreeId
													.indexOf('Intrm_Bank') > -1) {
												keyrationtype = "Interim_Bank"
											}
											if (ivhNode.filterTreeId
													.indexOf('Intrm_Nbfc') > -1) {
												keyrationtype = "Interim_Nbfc"
											}
											if (ivhNode.filterTreeId
													.indexOf('annual_manf') > -1) {
												keyrationtype = "annual_manfacturing";
											}
											if (ivhNode.filterTreeId
													.indexOf('annual_Bank') > -1) {
												keyrationtype = "annual_Bank";
											}
											if (ivhNode.filterTreeId
													.indexOf('annnual_nbfc') > -1) {
												keyrationtype = "annual_Nbfc";
											}

											var uiFilter = {
												'uicomponent' : ivhNode.uiType,
												'datasource' : row,
												'order' : count,
												'node' : ivhNode,
												'showhideflag' : true,
												'selectedVals' : null,
												'keyrationtypeforparam' : keyrationtype
											}
											uiFilter.errorflag = false;
											return uiFilter;
										});

						$scope.filterUiArray.push(rangedatasources[0]);

					} else if (ivhNode.uiType == 'fin_info_range_input_ind') {
						var keyrationtype = "";
						if (ivhNode.filterTreeId.indexOf('ind_mfg_') > -1) {
							keyrationtype = "ManufacturingIndustry";
						}
						if (ivhNode.filterTreeId.indexOf('ind_bank_') > -1) {
							keyrationtype = "BankIndustry";
						}
						if (ivhNode.filterTreeId.indexOf('ind_nbfc_') > -1) {
							keyrationtype = "NbfcIndustry";
						}
						var datasrc = JSON.parse(ivhNode.fixedValueList);
						var uiFilter = {
							'uicomponent' : ivhNode.uiType,
							'datasource' : datasrc[0],
							'order' : count,
							'node' : ivhNode,
							'showhideflag' : true,
							'selectedVals' : null,
							'keyrationtypeforparam' : keyrationtype
						}
						uiFilter.errorflag = false;
						$scope.filterUiArray.push(uiFilter);

					} else if (ivhNode.uiType == 'perRangeBox'
							|| ivhNode.uiType == 'IRSscoreRange') {
						var datasrc = JSON.parse(ivhNode.fixedValueList);
						var uiFilter = {
							'uicomponent' : ivhNode.uiType,
							'datasource' : datasrc[0],
							'order' : count,
							'node' : ivhNode,
							'showhideflag' : true,
							'selectedVals' : null
						}
						uiFilter.errorflag = false;
						$scope.filterUiArray.push(uiFilter);

					}

					else if (ivhNode.filterTreeId == 'CR_Case Type'
							|| ivhNode.filterTreeId == 'All_Case Type'
							|| ivhNode.filterTreeId == 'sf_Case Type'
							|| ivhNode.filterTreeId == 'CR_Facility Type'
							|| ivhNode.filterTreeId == 'sf_rating type') {
						var arr = ivhNode.fixedValueList.split(',');

						var uiFilter = {
							'uicomponent' : ivhNode.uiType,
							'datasource' : arr,
							'order' : count,
							'node' : ivhNode,
							'showhideflag' : true,
							'selectedVals' : null
						}
						uiFilter.errorflag = false;
						$scope.filterUiArray.push(uiFilter);

					}

					else {
						// for fixed json form values list
						var arr = ivhNode.fixedValueList.split(',');
						var uiFilter = {
							'uicomponent' : ivhNode.uiType,
							'datasource' : JSON.parse(arr),
							'order' : count,
							'node' : ivhNode,
							'showhideflag' : true,
							'selectedVals' : null
						}
						uiFilter.errorflag = false;
						$scope.filterUiArray.push(uiFilter);

					}

				} else {

					// should not add same element to array
					if (ivhNode.uiType != 'datefilter' && ivhNode.uiType != 'date_filter_fsm') {
						var uiFilter = {
							'uicomponent' : ivhNode.uiType,
							'datasource' : null,
							'order' : count,
							'node' : ivhNode,
							'showhideflag' : true,
							'selectedVals' : null
						}
						uiFilter.errorflag = false;
						$scope.filterUiArray.push(uiFilter);
					}

				}

				count = count + 1;
				// validation for rating info section
				if (ivhNode.filterTreeId.startsWith('CR_')
						|| ivhNode.filterTreeId.startsWith('sf_')
						|| ivhNode.filterTreeId.startsWith('All_')) {

					$scope.searchfiletrdatac = angular
							.copy($scope.searchfiletrdata);
					$timeout(
							function() {

								var activeparentid = ivhNode.parentId;
								ivhTreeviewBfs(
										$scope.searchfiletrdatac,
										opts,
										function(node) {
											if (node.id == '230') {
												ivhTreeviewBfs(
														node,
														opts,
														function(finnode) {
															if (finnode.children.length == 0) {
																if (finnode.parentId != activeparentid) {
																	finnode.disabled = true;
																} 
															}
														});
											}
										});
							}, 10);

					$timeout(function() {
						$scope.searchfiletrdata = $scope.searchfiletrdatac;
					}, 100);
					if (ivhNode.uiType.startsWith('datefilter')) {
						$scope.selecteddate.option = 'single';
					}
					$timeout(function() {
						$scope.selectdaterange($scope.selecteddate.option,
								ivhNode);
					}, 200);
				}
				// validation for rating info section ends here

				// Summary Financial disable enable logic
				if (ivhNode.filterTreeId.startsWith('Manf_')
						|| ivhNode.filterTreeId.startsWith('BANK_')
						|| ivhNode.filterTreeId.startsWith('NBFC_')
						|| ivhNode.filterTreeId.startsWith('Intrm_manf_')
						|| ivhNode.filterTreeId.startsWith('Intrm_Bank_')
						|| ivhNode.filterTreeId.startsWith('Intrm_Nbfc_')
						|| ivhNode.filterTreeId.startsWith('annual_manf_')
						|| ivhNode.filterTreeId.startsWith('annual_Bank_')
						|| ivhNode.filterTreeId.startsWith('annnual_nbfc_')
						|| ($scope.finyearquarterarr
								.indexOf(ivhNode.filterTreeId) > -1)) {
					$scope.searchfiletrdatac = angular
							.copy($scope.searchfiletrdata);
					var activeparentid = ivhNode.parentId;

					ivhTreeviewBfs($scope.searchfiletrdatac, opts, function(
							node) {
						if (node.id == '6') {
							ivhTreeviewBfs(node, opts, function(finnode) {
								if (finnode.children.length == 0) {
									if (finnode.parentId != activeparentid) {
										finnode.disabled = true;
									}
								}
							});
						}
					});

					$timeout(function() {
						$scope.searchfiletrdata = $scope.searchfiletrdatac;
					}, 30);

				}
				
				$scope.indFilterFlag(ivhNode);

			} else {

				// added now after changes in validation user access messagess
				$scope.iferror = false;
				$scope.errorMessages = [];

				$scope.filterUiArray.forEach(function(entry) {
					entry.errorflag = false;
				});
				$scope.filterUiArray = $scope.filterUiArray
						.filter(function(row) {
							return (row.node.id != ivhNode.id);
						});
				// code for industry information filter disable enable chk box

				$scope.filterUiArray1 = $scope.filterUiArray.filter(function(
						row) {
					return row.type != 'dummy';
				});

				if (ivhNode.filterTreeId.startsWith('ind_')) {
					$scope.industryfilterrm = $scope.filterUiArray1
							.filter(function(row) {
								return (row.node.filterTreeId
										.startsWith('ind_'));
							});

					if ($scope.industryfilterrm.length == 0) {

						$scope.setCustomSearchTool();
						$scope.industryfilterrm = undefined;
					}
				}

				if (ivhNode.filterTreeId.startsWith('CR_')
						|| ivhNode.filterTreeId.startsWith('sf_')
						|| ivhNode.filterTreeId.startsWith('All_')) {

					$timeout(function() {

						ivhTreeviewBfs($scope.searchfiletrdatac, opts,
								function(node) {
									if (node.id == '230') {
										ivhTreeviewBfs(node, opts, function(
												finnode) {
											if (finnode.children.length == 0) {
												finnode.disabled = false;
											}

										});
									}
								});
					}, 10);

					$timeout(function() {
						$scope.searchfiletrdata = $scope.searchfiletrdatac;
					}, 100);
					if (ivhNode.uiType.startsWith('datefilter')) {
						$scope.selecteddate.option = 'single';
					}
					$timeout(function() {
						$scope
								.selectdaterange($scope.selecteddate.option,
										null);
					}, 200);
				}

				// end

				// code for financial parameter enabling
				$scope.remaingFinfilter = $scope.filterUiArray1
						.filter(function(row) {
							return (row.node.filterTreeId.startsWith('Manf_')
									|| row.node.filterTreeId
											.startsWith('BANK_')
									|| row.node.filterTreeId
											.startsWith('NBFC_')
									|| row.node.filterTreeId
											.startsWith('Intrm_manf_')
									|| row.node.filterTreeId
											.startsWith('Intrm_Bank_')
									|| row.node.filterTreeId
											.startsWith('Intrm_Nbfc_')
									|| row.node.filterTreeId
											.startsWith('annual_manf_')
									|| row.node.filterTreeId
											.startsWith('annual_Bank_')
									|| row.node.filterTreeId
											.startsWith('annnual_nbfc_') || ($scope.finyearquarterarr
									.indexOf(row.node.filterTreeId) > -1));
						});

				if ($scope.remaingFinfilter.length == 0) {
					$scope.searchfiletrdatac = angular
							.copy($scope.searchfiletrdata);
					ivhTreeviewBfs($scope.searchfiletrdatac, opts, function(
							node) {
						if (node.id == '6') {
							ivhTreeviewBfs(node, opts, function(finnode) {

								if (finnode.children.length == 0) {
									finnode.disabled = false;
								} else {
									finnode.disabled = true;
								}
							});
						}
					});

					$timeout(function() {
						$scope.searchfiletrdata = $scope.searchfiletrdatac
					}, 0);
				}

				// end
			}

		}
		
		$scope.indFilterFlag = function(ivhNode) {
			
			// validation for industry information
			$scope.industrytype = $scope.filterUiArray
					.filter(function(row) {
						return (row.node.filterTreeId.startsWith('ind_'));
					});
			if ($scope.industrytype.length > 0) {
				
				var activeparentid = ivhNode.parentId;
				$scope.filterUiArray = $scope.industrytype;
				$scope.searchfiletrdatac = angular
						.copy($scope.searchfiletrdata);
				
				ivhTreeviewBfs($scope.searchfiletrdatac, opts, function(
						node) {
					if (node.filterTreeId != 'ind_info_Median Rating' && node.filterTreeId != 'ind_info_IRS Score' && node.children.length == 0) {
						if (!node.filterTreeId.startsWith('ind_') || node.parentId != activeparentid) {
							node.disabled = true;
						}
					}	
				});
				$timeout(function() {
					$scope.searchfiletrdata = $scope.searchfiletrdatac;
				}, 20);
			}
		}
		
		$scope.indFilterWizardFlag = function(ivhNode) {
			
			// validation for industry information
			$scope.industrytype = $scope.filterUiArray
					.filter(function(row) {
						return (row.node.filterTreeId.startsWith('ind_'));
					});
			if ($scope.industrytype.length > 0) {
				
				var activeparentid = ivhNode.parentId;
				$scope.filterUiArray = $scope.industrytype;
				$scope.searchsectiondatac = angular
						.copy($scope.searchsectiondata);
				ivhTreeviewBfs($scope.searchsectiondatac, opts, function(
						node) {
					if (node.filterTreeId != 'ind_info_Median Rating' && node.filterTreeId != 'ind_info_IRS Score' && node.children.length == 0) {
						if (!node.filterTreeId.startsWith('ind_') || node.parentId != activeparentid) {
							node.disabled = true;
						}
					}	
				});
				$timeout(function() {
					$scope.searchsectiondata = $scope.searchsectiondatac
				}, 20);
			}
		}
		

		// ////added for wizard section
		$scope.displayFilterwizard = function(ivhNode, ivhIsSelected, ivhTree) {

			$scope.closeOtherParent(ivhNode, ivhIsSelected, ivhTree);
			if (ivhIsSelected) {
				$scope.showSearchResult = false;

				$scope.success = '';

				// RA2 dont have acess 50815
				if ($scope.advAccessdata.indexOf('All Rating Agency') == -1
						&& ivhNode.filterTreeId.toLowerCase().indexOf('all') > -1) {
					$timeout(function() {
						ivhTreeviewMgr.deselect($scope.searchsectiondata,
								ivhNode, opts);
					}, 10);
					return $scope.showErrorMessages();
				}

				if (ivhNode.uiType == 'datefilter') {
					var opDate = $filter('date')(new Date(), "dd-MM-yyyy");
					var tempdate = {
						start : opDate,
						end : opDate
					};
					var uifilter = {
						'uicomponent' : ivhNode.uiType,
						'datasource' : tempdate,
						'order' : count,
						'node' : ivhNode,
						'showhideflag' : true,
						'selectedVals' : null
					};
					uifilter.errorflag = false;
					$scope.filterUiArray.push(uifilter);

				}
				if (ivhNode.uiType == 'daterangefilter') {
					var opDate = $filter('date')(new Date(), "dd-MM-yyyy");
					var tempdate = {
						start : opDate,
						end : opDate
					};
					var uifilter = {
						'uicomponent' : ivhNode.uiType,
						'datasource' : tempdate,
						'order' : count,
						'node' : ivhNode,
						'showhideflag' : true,
						'selectedVals' : null
					};
					uifilter.errorflag = false;
					$scope.filterUiArray.push(uifilter);

					return;
				}

				if (ivhNode.uiType == 'FixedIncomeDateFilter') {
					var opDate = $filter('date')(new Date(), "dd-MM-yyyy");
					var tempdate = {
						start : opDate
					};
					var uifilter = {
						'uicomponent' : ivhNode.uiType,
						'datasource' : tempdate,
						'order' : count,
						'node' : ivhNode,
						'showhideflag' : true,
						'selectedVals' : null
					};
					uifilter.errorflag = false;
					$scope.filterUiArray.push(uifilter);

					return;
				}

				if (ivhNode.uiType == 'facilityoptions') {
					var arr = ivhNode.fixedValueList.split(',');
					var dataarr = [];
					for (var i = 0; i < arr.length; i++) {
						var temp = {
							catogory : arr[i]
						};
						dataarr.push(temp);
					}
					var uifilter = {
						'uicomponent' : ivhNode.uiType,
						'datasource' : dataarr,
						'order' : count,
						'node' : ivhNode,
						'showhideflag' : true,
						'selectedVals' : null
					};
					uifilter.errorflag = false;
					$scope.filterUiArray.push(uifilter);
					return;
				}

				if (ivhNode.uiType == 'treeviewtype'
						&& ivhNode.filterTreeId != 'sf_rating type') {
					
					advanceSearchautocomplete
							.getMasterDataForUrl(ivhNode.id, 'api/advanceSearch/getMasterDataForFilterRating')
							.then(
									function(data) {
										var arr = {
												'arrval' : []
											};
											var ratingtypeobj = data.groupBy('type');
											var ratetype = [];
											for ( var key in ratingtypeobj) {
												var obj = {
													'name' : key,
													'msGroup' : true
												};
												ratetype.push(obj);
												ratingtypeobj[key].map(function(row) {
													ratetype.push(row);
												});
												var objf = {

													'msGroup' : false
												};
												ratetype.push(objf);
											}
											var uiFilter = {
												'uicomponent' : ivhNode.uiType,
												'datasource' : ratetype,
												'order' : count,
												'node' : ivhNode,
												'showhideflag' : true,
												'selectedVals' : arr
											}
											uiFilter.errorflag = false;
											$scope.filterUiArray.push(uiFilter);

										}, function(errordata) {
									});

				}

				else if (ivhNode.queryFlag == 'Y') {

					if (ivhNode.filterTreeId == 'Business_info_str_weak'
							&& ivhNode.uiType == 'dropdown'
							&& ivhNode.label == 'Strengths / Weaknesses') {
						
						advanceSearchautocomplete
								.getMasterDataForUrl(ivhNode.id, 'api/advanceSearch/getMasterDataForFilterStrengthAndWeakness')
								.then(
										function(data) {
											$scope.strengthWeakness = data;

											var arr = [];
											var uiFilter = {
												'uicomponent' : ivhNode.uiType,
												'datasource' : [],
												'order' : count,
												'node' : ivhNode,
												'showhideflag' : true,
												'selectedVals' : arr
											}

											$scope.strengthFlag = false;
											$scope.weaknessFlag = false;

											if ($scope.strengthWeakness.strength != undefined
													&& $scope.strengthWeakness.strength.length > 0) {
												uiFilter.datasource = $scope.strengthWeakness.strength;

												$scope.business.strength = "Strength";
												$scope.strengthFlag = true;

												arr = [ uiFilter.datasource[0] ];

												if ($scope.strengthWeakness.weakness != undefined
														&& $scope.strengthWeakness.weakness.length > 0) {
													$scope.weaknessFlag = true;
													$scope.business.weakness = "Weakness";
												}
												$scope.business.strwk = "Strength";
											} else if ($scope.strengthWeakness.weakness != undefined
													&& $scope.strengthWeakness.weakness.length > 0) {
												$scope.strengthFlag = false;
												$scope.weaknessFlag = true;
												uiFilter.datasource = $scope.strengthWeakness.weakness;
												arr = [ uiFilter.datasource[0] ];
												$scope.business.weakness = "Weakness";
												$scope.business.strwk = "Weakness";
											} else if ($scope.strengthFlag == false
													&& $scope.weaknessFlag == false) {
												// error message
												$scope.errorMessages
														.push("Strength And Weakness Details is not available");
												$scope.iferror = true;

												$timeout(function() {

													$scope.iferror = false;
													$scope.errorMessages = "";

												}, 5000);
												$window.scrollTo(0, 0);

											}
											uiFilter.selectedVals = arr;
											uiFilter.errorflag = false;
											$scope.filterUiArray.push(uiFilter);

										}, function(errordata) {
										});

					} else {

						advanceSearchautocomplete
								.getMasterDataForUrl(ivhNode.id, 'api/advanceSearch/getMasterDataForFilter')
								.then(
										function(data) {

											if (ivhNode.uiType == 'quarter_dropdown') {
												$scope.dateInput = [];
												var date = new Date(data[0]);
												for (var i = 0; i < 12; i++) {

													var dateToShow = angular
															.copy(date);
													dateToShow
															.setDate(dateToShow
																	.getDate() - 1);

													var prevyear = angular
															.copy(dateToShow);

													prevyear.setYear(prevyear
															.getFullYear() - 1);
													var lastDay = new Date(
															prevyear
																	.getFullYear(),
															prevyear.getMonth() + 1,
															0);
													var displaydate = new Date(
															dateToShow
																	.getFullYear(),
															dateToShow
																	.getMonth() + 1,
															0);

													var lastopDate = $filter(
															'date')(lastDay,
															"dd-MMM-yy");

													var displaystr = $filter(
															'date')(
															displaydate,
															"dd-MMM-yy");

													var opDate = $filter('date')
															(dateToShow,
																	"MMM-yy");
													var opvar = {
														'datastr' : opDate,
														'dateval' : displaystr,
														'prevdate' : lastopDate
													};
													$scope.dateInput
															.push(opvar);
													date.setMonth(date
															.getMonth() - 3);
												}
												data = $scope.dateInput;
												var arr = [];
												var uiFilter = {
													'uicomponent' : ivhNode.uiType,
													'datasource' : data,
													'order' : count,
													'node' : ivhNode,
													'showhideflag' : true,
													'selectedVals' : arr
												}
												uiFilter.errorflag = false;
												$scope.filterUiArray
														.push(uiFilter);
											}

											else if (ivhNode.uiType == 'Rzslider') {
												var sliderdata = {
													minValue : data[2],
													maxValue : data[8],
													options : {
														stepsArray : data,
														showSelectionBar : true,
														showTicksValues : true

													}
												};
												var arr = [];
												var uiFilter = {
													'uicomponent' : ivhNode.uiType,
													'datasource' : sliderdata,
													'order' : count,
													'node' : ivhNode,
													'showhideflag' : true,
													'selectedVals' : arr
												}
												uiFilter.errorflag = false;
												$scope.filterUiArray
														.push(uiFilter);
											} else {
												var arr = [];
												var uiFilter = {
													'uicomponent' : ivhNode.uiType,
													'datasource' : data,
													'order' : count,
													'node' : ivhNode,
													'showhideflag' : true,
													'selectedVals' : arr
												}
												uiFilter.errorflag = false;
												$scope.filterUiArray
														.push(uiFilter);

											}
											
											$scope.indFilterWizardFlag(ivhNode);
											
										}, function(errordata) {
										});
					
					}

				} else if (ivhNode.fixedValueFlag == 'Y') {
					if (ivhNode.uiType == 'year_dropdown') {

						var uiFilterDateParam = {
							'uicomponent' : ivhNode.uiType,
							'datasource' : $scope.yeararray,
							'order' : count,
							'node' : ivhNode,
							'showhideflag' : true,
							'selectedVals' : ''
						}
						uiFilterDateParam.errorflag = false;
						$scope.filterUiArray.push(uiFilterDateParam);

					}

				

					

					else if (ivhNode.uiType == 'fin_info_range_input') {
						var keyrationtype = '';
						var rangedatasources = JSON
								.parse(ivhNode.fixedValueList)
								.map(
										function(row) {

											if (ivhNode.filterTreeId
													.indexOf('Manf') > -1) {
												keyrationtype = "Manufacutring"
											}
											if (ivhNode.filterTreeId
													.indexOf('BANK') > -1) {
												keyrationtype = "BANK"
											}
											if (ivhNode.filterTreeId
													.indexOf('NBFC') > -1) {
												keyrationtype = "NBFC"
											}
											if (ivhNode.filterTreeId
													.indexOf('Intrm_manf') > -1) {
												keyrationtype = "Interim_Manufacturing"
											}
											if (ivhNode.filterTreeId
													.indexOf('Intrm_Bank') > -1) {
												keyrationtype = "Interim_Bank"
											}
											if (ivhNode.filterTreeId
													.indexOf('Intrm_Nbfc') > -1) {
												keyrationtype = "Interim_Nbfc"
											}
											if (ivhNode.filterTreeId
													.indexOf('annual_manf') > -1) {
												keyrationtype = "annual_manfacturing";
											}
											if (ivhNode.filterTreeId
													.indexOf('annual_Bank') > -1) {
												keyrationtype = "annual_Bank";
											}
											if (ivhNode.filterTreeId
													.indexOf('annnual_nbfc') > -1) {
												keyrationtype = "annual_Nbfc";
											}

											var uiFilter = {
												'uicomponent' : ivhNode.uiType,
												'datasource' : row,
												'order' : count,
												'node' : ivhNode,
												'showhideflag' : true,
												'selectedVals' : null,
												'keyrationtypeforparam' : keyrationtype
											}
											uiFilter.errorflag = false;
											return uiFilter;
										});

						$scope.filterUiArray.push(rangedatasources[0]);

					} else if (ivhNode.uiType == 'fin_info_range_input_ind') {
						var keyrationtype = "";
						if (ivhNode.filterTreeId.indexOf('ind_mfg_') > -1) {
							keyrationtype = "ManufacturingIndustry";
						}
						if (ivhNode.filterTreeId.indexOf('ind_bank_') > -1) {
							keyrationtype = "BankIndustry";
						}
						if (ivhNode.filterTreeId.indexOf('ind_nbfc_') > -1) {
							keyrationtype = "NbfcIndustry";
						}
						var datasrc = JSON.parse(ivhNode.fixedValueList);
						var uiFilter = {
							'uicomponent' : ivhNode.uiType,
							'datasource' : datasrc[0],
							'order' : count,
							'node' : ivhNode,
							'showhideflag' : true,
							'selectedVals' : null,
							'keyrationtypeforparam' : keyrationtype
						}
						uiFilter.errorflag = false;
						$scope.filterUiArray.push(uiFilter);

					} else if (ivhNode.uiType == 'perRangeBox'
							|| ivhNode.uiType == 'IRSscoreRange') {
						var datasrc = JSON.parse(ivhNode.fixedValueList);
						var uiFilter = {
							'uicomponent' : ivhNode.uiType,
							'datasource' : datasrc[0],
							'order' : count,
							'node' : ivhNode,
							'showhideflag' : true,
							'selectedVals' : null
						}
						uiFilter.errorflag = false;
						$scope.filterUiArray.push(uiFilter);

					}

					else if (ivhNode.filterTreeId == 'CR_Case Type'
							|| ivhNode.filterTreeId == 'All_Case Type'
							|| ivhNode.filterTreeId == 'sf_Case Type'
							|| ivhNode.filterTreeId == 'CR_Facility Type'
							|| ivhNode.filterTreeId == 'sf_rating type') {// for
						// fixed
						// values
						// simple
						// array
						var arr = ivhNode.fixedValueList.split(',');
						var uiFilter = {
							'uicomponent' : ivhNode.uiType,
							'datasource' : arr,
							'order' : count,
							'node' : ivhNode,
							'showhideflag' : true,
							'selectedVals' : null
						}
						uiFilter.errorflag = false;
						$scope.filterUiArray.push(uiFilter);

					}

					else {
						// for fixed json form values list
						var arr = ivhNode.fixedValueList.split(',');
						var uiFilter = {
							'uicomponent' : ivhNode.uiType,
							'datasource' : JSON.parse(arr),
							'order' : count,
							'node' : ivhNode,
							'showhideflag' : true,
							'selectedVals' : null
						}
						uiFilter.errorflag = false;
						$scope.filterUiArray.push(uiFilter);

					}

				} else {

					// should not add same element to array
					if (ivhNode.uiType != 'datefilter') {
						var uiFilter = {
							'uicomponent' : ivhNode.uiType,
							'datasource' : null,
							'order' : count,
							'node' : ivhNode,
							'showhideflag' : true,
							'selectedVals' : null
						}
						uiFilter.errorflag = false;
						$scope.filterUiArray.push(uiFilter);
					}

				}

				count = count + 1;

				// validation for rating info section
				if (ivhNode.filterTreeId.startsWith('CR_')
						|| ivhNode.filterTreeId.startsWith('sf_')
						|| ivhNode.filterTreeId.startsWith('All_')) {
					$scope.searchsectiondatac = angular
							.copy($scope.searchsectiondata);
					$timeout(
							function() {

								var activeparentid = ivhNode.parentId;
								ivhTreeviewBfs(
										$scope.searchsectiondatac,
										opts,
										function(node) {
											if (node.id == '230') {
												ivhTreeviewBfs(
														node,
														opts,
														function(finnode) {
															if (finnode.children.length == 0) {
																if (finnode.parentId != activeparentid) {
																	finnode.disabled = true;
																} 
															}
														});
											}
										});
							}, 10);

					$timeout(function() {
						$scope.searchsectiondata = $scope.searchsectiondatac;
					}, 100);
					if (ivhNode.uiType.startsWith('datefilter')) {
						$scope.selecteddate.option = 'single';
					}
					$timeout(function() {
						$scope.selectdaterangewizard(
								$scope.selecteddate.option, ivhNode);
					}, 200);
				}
				// validation for rating info section ends here
				
				// Summary Financial disable enable logic
				$scope.searchsectiondatac = angular
						.copy($scope.searchsectiondata);

				if (ivhNode.filterTreeId.startsWith('Manf_')
						|| ivhNode.filterTreeId.startsWith('BANK_')
						|| ivhNode.filterTreeId.startsWith('NBFC_')
						|| ivhNode.filterTreeId.startsWith('Intrm_manf_')
						|| ivhNode.filterTreeId.startsWith('Intrm_Bank_')
						|| ivhNode.filterTreeId.startsWith('Intrm_Nbfc_')
						|| ivhNode.filterTreeId.startsWith('annual_manf_')
						|| ivhNode.filterTreeId.startsWith('annual_Bank_')
						|| ivhNode.filterTreeId.startsWith('annnual_nbfc_')
						|| ($scope.finyearquarterarr
								.indexOf(ivhNode.filterTreeId) > -1)) {
					var activeparentid = ivhNode.parentId;

					ivhTreeviewBfs($scope.searchsectiondatac, opts, function(
							node) {
						if (node.id == '6') {
							ivhTreeviewBfs(node, opts, function(finnode) {

								if (finnode.parentId != activeparentid) {
									finnode.disabled = true;
								} else {
									finnode.disabled = false;
								}
							});
						}
					});

					$timeout(function() {
						$scope.searchsectiondata = $scope.searchsectiondatac
					}, 30);

				}
				
				$scope.indFilterWizardFlag(ivhNode);

			} else {

				// added now after changes in validation user access messagess
				$scope.iferror = false;
				$scope.errorMessages = [];

				$scope.filterUiArray.forEach(function(entry) {
					entry.errorflag = false;
				});
				$scope.filterUiArray = $scope.filterUiArray
						.filter(function(row) {
							return (row.node.id != ivhNode.id);
						});
				// code for industry information filter disable enable chk box

				$scope.filterUiArray1 = $scope.filterUiArray.filter(function(
						row) {
					return row.type != 'dummy';
				});

				if (ivhNode.filterTreeId.startsWith('CR_')
						|| ivhNode.filterTreeId.startsWith('sf_')
						|| ivhNode.filterTreeId.startsWith('All_')) {

					$timeout(function() {

						ivhTreeviewBfs($scope.searchsectiondatac, opts,
								function(node) {
									if (node.id == '230') {
										ivhTreeviewBfs(node, opts, function(
												finnode) {
											if (finnode.children.length == 0) {
												finnode.disabled = false;
											}

										});
									}
								});
					}, 10);

					$timeout(function() {
						$scope.searchsectiondata = $scope.searchsectiondatac;
					}, 100);
					if (ivhNode.uiType.startsWith('datefilter')) {
						$scope.selecteddate.option = 'single';
					}
					$timeout(function() {
						$scope.selectdaterangewizard(
								$scope.selecteddate.option, null);
					}, 200);
				}

				// end

				// code for financial parameter enabling
				$scope.remaingFinfilter = $scope.filterUiArray1
						.filter(function(row) {
							return (row.node.filterTreeId.startsWith('Manf_')
									|| row.node.filterTreeId
											.startsWith('BANK_')
									|| row.node.filterTreeId
											.startsWith('NBFC_')
									|| row.node.filterTreeId
											.startsWith('Intrm_manf_')
									|| row.node.filterTreeId
											.startsWith('Intrm_Bank_')
									|| row.node.filterTreeId
											.startsWith('Intrm_Nbfc_')
									|| row.node.filterTreeId
											.startsWith('annual_manf_')
									|| row.node.filterTreeId
											.startsWith('annual_Bank_')
									|| row.node.filterTreeId
											.startsWith('annnual_nbfc_') || ($scope.finyearquarterarr
									.indexOf(row.node.filterTreeId) > -1));
						});

				if ($scope.remaingFinfilter.length == 0) {
					$scope.searchsectiondatac = angular
							.copy($scope.searchsectiondata);
					ivhTreeviewBfs($scope.searchsectiondatac, opts, function(
							node) {
						if (node.id == '6') {
							ivhTreeviewBfs(node, opts, function(finnode) {

								if (finnode.children.length == 0) {
									finnode.disabled = false;
								} else {
									finnode.disabled = true;
								}
							});
						}
					});

					$timeout(function() {
						$scope.searchsectiondata = $scope.searchsectiondatac
					}, 0);
				}

				// end

			}

		}

		// /end for wizard section

		$scope.resetOtherRange = function(finRangeComponent, flag) {

			if (flag) {

				if (finRangeComponent.growthflag != 'NA') {
					finRangeComponent.growthflag = false;
				}
				finRangeComponent.absoluteflag = false;
				finRangeComponent.grwthfromVal = '';
				finRangeComponent.grwthToVal = '';
				finRangeComponent.absfromVal = '';
				finRangeComponent.absToVal = '';
			}
		}

		$scope.removeFromArr = function(uicomp) {

			var objnode = uicomp.node;
			var newarr = [];

			var dummyobj = {
				'uicomponent' : 'dummy',
				'datasource' : null,
				'order' : null,
				'node' : {
					children : [],
					columnname : '',
					disabled : true,
					filterTreeId : '',
					fixedValueFlag : '',
					fixedValueList : '',
					hierarchy : '',
					id : '',
					label : '',
					levelId : '',
					parentId : '',
					queryFlag : '',
					selected : '',
					uiType : ""
				},
				'showhideflag' : false,
				'selectedVals' : null,
				'type' : 'dummy'
			}
			$scope.filterUiArray.splice($scope.filterUiArray.indexOf(uicomp),
					1, dummyobj);

			$scope.filterUiArray1 = $scope.filterUiArray.filter(function(row) {
				return row.type != 'dummy';
			});

			// if array contains only dummy object remove all
			if ($scope.filterUiArray1.length == 0) {
				$scope.filterUiArray = [];
			}

			ivhTreeviewBfs($scope.searchfiletrdata, opts, function(node) {

				if (node.id == uicomp.node.id) {
					$timeout(function() {
						ivhTreeviewMgr.deselect($scope.searchfiletrdata, node,
								opts);
					}, 10);
				}

			});

			if (uicomp.node.filterTreeId.startsWith('ind_')) {
				$scope.industryfilterrm = $scope.filterUiArray1
						.filter(function(row) {
							return (row.node.filterTreeId.startsWith('ind_'));
						});

				if ($scope.industryfilterrm.length == 0) {

					$scope.setCustomSearchTool();
					$scope.industryfilterrm = undefined;
				}
			}

			if (uicomp.node.filterTreeId.startsWith('CR_')
					|| uicomp.node.filterTreeId.startsWith('sf_')
					|| uicomp.node.filterTreeId.startsWith('All_')) {

				$timeout(function() {

					ivhTreeviewBfs($scope.searchfiletrdatac, opts, function(
							node) {
						if (node.id == '230') {
							ivhTreeviewBfs(node, opts, function(
									finnode) {
								if (finnode.children.length == 0) {
									finnode.disabled = false;
								}

							});
						}
					});
				}, 10);

				$timeout(function() {
					$scope.searchfiletrdata = $scope.searchfiletrdatac;
				}, 100);
				if (uicomp.node.uiType.startsWith('datefilter')) {
					$scope.selecteddate.option = 'single';
				}
				$timeout(function() {
					$scope.selectdaterange($scope.selecteddate.option, null);
				}, 200);

			}
			// end

			// code for financial parameter enabling
			$timeout(
					function() {
						$scope.remaingFinfilter = $scope.filterUiArray1
								.filter(function(row) {
									return (row.node.filterTreeId
											.startsWith('Manf_')
											|| row.node.filterTreeId
													.startsWith('BANK_')
											|| row.node.filterTreeId
													.startsWith('NBFC_')
											|| row.node.filterTreeId
													.startsWith('Intrm_manf_')
											|| row.node.filterTreeId
													.startsWith('Intrm_Bank_')
											|| row.node.filterTreeId
													.startsWith('Intrm_Nbfc_')
											|| row.node.filterTreeId
													.startsWith('annual_manf_')
											|| row.node.filterTreeId
													.startsWith('annual_Bank_')
											|| row.node.filterTreeId
													.startsWith('annnual_nbfc_') || ($scope.finyearquarterarr
											.indexOf(row.node.filterTreeId) > -1));
								});

						if ($scope.remaingFinfilter.length == 0) {
							$scope.searchfiletrdatac = angular
									.copy($scope.searchfiletrdata);
							ivhTreeviewBfs(
									$scope.searchfiletrdatac,
									opts,
									function(node) {
										if (node.id == '6') {
											ivhTreeviewBfs(
													node,
													opts,
													function(finnode) {

														if (finnode.children.length == 0) {
															finnode.disabled = false;
														} else {
															finnode.disabled = true;
														}
													});
										}
									});

							$timeout(
									function() {
										$scope.searchfiletrdata = $scope.searchfiletrdatac
									}, 40);
						}

					}, 30);
			// end
		}

		// start of adding for wizard
		$scope.removeFromArrwizard = function(uicomp) {

			var objnode = uicomp.node;
			var newarr = [];

			var dummyobj = {
				'uicomponent' : 'dummy',
				'datasource' : null,
				'order' : null,
				'node' : {
					children : [],
					columnname : '',
					disabled : true,
					filterTreeId : '',
					fixedValueFlag : '',
					fixedValueList : '',
					hierarchy : '',
					id : '',
					label : '',
					levelId : '',
					parentId : '',
					queryFlag : '',
					selected : '',
					uiType : ""
				},
				'showhideflag' : false,
				'selectedVals' : null,
				'type' : 'dummy'
			}
			$scope.filterUiArray.splice($scope.filterUiArray.indexOf(uicomp),
					1, dummyobj);

			$scope.filterUiArray1 = $scope.filterUiArray.filter(function(row) {
				return row.type != 'dummy';
			});

			// if array contains only dummy object remove all
			if ($scope.filterUiArray1.length == 0) {
				$scope.filterUiArray = [];
			}

			ivhTreeviewBfs($scope.searchsectiondata, opts, function(node) {

				if (node.id == uicomp.node.id) {
					$timeout(function() {
						ivhTreeviewMgr.deselect($scope.searchsectiondata, node,
								opts);
					}, 10);
				}

			});

			if (uicomp.node.filterTreeId.startsWith('CR_')
					|| uicomp.node.filterTreeId.startsWith('sf_')
					|| uicomp.node.filterTreeId.startsWith('All_')) {
				$timeout(function() {

					ivhTreeviewBfs($scope.searchsectiondatac, opts, function(
							node) {
						if (node.id == '230') {
							ivhTreeviewBfs(node, opts, function(
									finnode) {
								if (finnode.children.length == 0) {
									finnode.disabled = false;
								}

							});
						}
					});
				}, 10);

				$timeout(function() {
					$scope.searchsectiondata = $scope.searchsectiondatac;
				}, 100);
				if (uicomp.node.uiType.startsWith('datefilter')) {
					$scope.selecteddate.option = 'single';
				}
				$timeout(function() {
					$scope.selectdaterangewizard($scope.selecteddate.option,
							null);
				}, 200);
			}
			// end

			// code for financial parameter enabling
			$timeout(
					function() {
						$scope.remaingFinfilter = $scope.filterUiArray1
								.filter(function(row) {
									return (row.node.filterTreeId
											.startsWith('Manf_')
											|| row.node.filterTreeId
													.startsWith('BANK_')
											|| row.node.filterTreeId
													.startsWith('NBFC_')
											|| row.node.filterTreeId
													.startsWith('Intrm_manf_')
											|| row.node.filterTreeId
													.startsWith('Intrm_Bank_')
											|| row.node.filterTreeId
													.startsWith('Intrm_Nbfc_')
											|| row.node.filterTreeId
													.startsWith('annual_manf_')
											|| row.node.filterTreeId
													.startsWith('annual_Bank_')
											|| row.node.filterTreeId
													.startsWith('annnual_nbfc_') || ($scope.finyearquarterarr
											.indexOf(row.node.filterTreeId) > -1));
								});

						if ($scope.remaingFinfilter.length == 0) {
							$scope.searchsectiondatac = angular
									.copy($scope.searchsectiondata);
							ivhTreeviewBfs(
									$scope.searchsectiondatac,
									opts,
									function(node) {
										if (node.id == '6') {
											ivhTreeviewBfs(
													node,
													opts,
													function(finnode) {

														if (finnode.children.length == 0) {
															finnode.disabled = false;
														} else {
															finnode.disabled = true;
														}
													});
										}
									});

							$timeout(
									function() {
										$scope.searchsectiondata = $scope.searchsectiondatac
									}, 40);
						}

					}, 30);
			// end
		}

		// //////////////end of adding for wizard filters

		GenericService.getIndustryTreeDataModuleWise
				.getIndustryTree(
						{
							moduleName : 'SENSITIVITY'
						},
						function(data) {
							if (data[0] != null) {
								$scope.sampleIndustrydata = JSON.parse(data[0]);

								$scope.loaddirective = true;

							} else {
								$scope.iferror = true;
								$scope.errorMessages
										.push("Error Occured while loading Industry data, please try again. ");

								$timeout(function() {

									$scope.iferror = false;
									$scope.errorMessages = "";

								}, 10000);
							}
						});

		var promise1 = GenericService.getMasterProductTreeData();
		promise1.then(function(data) {

			$scope.prodTreeData = data;

		}, function(error) {
		});

		var promise = GenericService.getZonalLocationDetailsdata();
		promise.then(function(data) {
			$scope.locationTreedata = data;
		}, function(error) {
		});

		$scope.setindustryvaluesdir = function(indids) {
			$scope.useindvals = indids;

		}
		$scope.setproductvaluesdir = function(indids) {
			$scope.useprodvals = indids;

		}

		$scope.setindustryvaluesdir1 = function(indids) {
			$scope.useindvals1 = indids;

		}
		$scope.setindustrysegdir1 = function(indobj1) {
			$scope.useindobjs1 = indobj1;

		}

		$scope.setindustrynamesdir = function(indids) {
			$scope.useindnames = indids;

		}

		$scope.setindustrynamesdir1 = function(indids) {
			$scope.useindnames1 = indids;

		}

		$scope.setplantlocationnames = function(indids) {
			$scope.plantlocnames = indids;

		}

		$scope.setplantlocationids = function(indids) {
			$scope.plantlocids = indids;
		}

		$scope.wizardIndId = "wizardInd";
		$scope.wizardLocId = "wizardLoc";
		$scope.selectedfilterarr = [];
		$scope.filtertoremove = [];
		$scope.selectedoutputfiltr = [];
		$scope.addtoOutputselected = [];
		$scope.removetoOutput = [];

		$scope.outputfilterarr = [ 'Industry', 'Location', 'Rating' ];

		$scope.addToOutputFilter = function(obj) {

			if ((obj.sectionName == 'Detailed Financials' && $scope.advAccessdata
					.indexOf('Detailed financials') == -1)
					|| (obj.sectionName == 'Business Information' && $scope.advAccessdata
							.indexOf('WS Business Info') == -1)
					|| ($scope.advAccessdata.indexOf('WS Equity') == -1 && obj.sectionName == 'Equity Details')
					|| ($scope.advAccessdata.indexOf('WS FI Details') == -1 && obj.sectionName == 'Fixed Income')) {
				$scope.errorMessages = [];
				$scope.iferror = true;
				$scope.errorMessages
						.push(" This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001. ");

				$timeout(function() {

					$scope.iferror = false;
					$scope.errorMessages = "";

				}, 5000);

				return false;
			}

			var ifpresent = $scope.selectedoutputfiltr.filter(function(row) {
				return obj.sectionName == row.sectionName;
			});

			if (ifpresent.length == 0) {
				$scope.selectedoutputfiltr.push(obj);
			}

		}

		$scope.addAllOutputfilter = function() {
			
			$scope.selectedoutputfiltr = [];
			$scope.selectedoutputfiltr = angular.copy($scope.outputfilter.filter(function(obj) {
				return !((obj.sectionName == 'Detailed Financials' && $scope.advAccessdata
						.indexOf('Detailed financials') == -1)
						|| (obj.sectionName == 'Business Information' && $scope.advAccessdata
								.indexOf('WS Business Info') == -1)
						|| ($scope.advAccessdata.indexOf('WS Equity') == -1 && obj.sectionName == 'Equity Details')
						|| ($scope.advAccessdata.indexOf('WS FI Details') == -1 && obj.sectionName == 'Fixed Income'));
			}));
		}

		$scope.removeAllOutputfilter = function() {
			$scope.selectedoutputfiltr = [];
		}

		/*
		 * $scope.addToSelectedoutput = function() {
		 * 
		 * for (var i = 0; i < $scope.addtoOutputselected.length; i++) {
		 * $scope.selectedoutputfiltr.push($scope.addtoOutputselected[i]); } }
		 */
		$scope.removeToOutputFilter = function(obj) {
			$scope.selectedoutputfiltr.splice($scope.selectedoutputfiltr
					.indexOf(obj), 1);
			// $scope.removetoOutput.push(obj);
		}
		/*
		 * $scope.removeSelectedoutput = function() { for (var i = 0; i <
		 * $scope.removetoOutput.length; i++) {
		 * $scope.selectedoutputfiltr.splice($scope.selectedoutputfiltr
		 * .indexOf($scope.removetoOutput[i]), 1); } }
		 */
		$scope.removefromfilter = function() {
			for (var i = 0; i < $scope.filtertoremove.length; i++) {
				$scope.selectedfilterarr.splice($scope.selectedfilterarr
						.indexOf($scope.filtertoremove[i]), 1);
			}

		}
		$scope.addToRemove = function(obj) {
			$scope.filtertoremove.push(obj);
		}
		$scope.addToSelected = function() {
		}

		// get save Search data
		$scope.getSaveSearch = function(subModule) {
			$http({
				url : 'api/advanceSearch/getsavesearch',
				method : 'POST',
				data : subModule || 'C'
			}).success(function(data) {
				$scope.saveSearch = data;
				$scope.loading = false;
				$scope.saveddatareq = false;
			}).error(function(response) {
			});
		}

		$scope.getSaveSearch();

		$scope.queryflag = "";

		$scope.runflag = false;
		// edit Save search

		$scope.status = {
			listed : null,
			unlisted : null,
			rated : null,
			unrated: null
		};

		$scope.editQuerySearch = function(userId, searchName, flag) {
			$scope.showrun = false;
			$scope.searchOutput = [];
			var fd = new FormData();
			var url = 'api/advanceSearch/editQueryByName';
			fd.append('userId', userId);
			fd.append('searchName', searchName);
			$scope.runflag = true;
			$scope.queryflag = flag;
			$http
					.post(url, fd, {
						transformRequest : angular.identity,

						headers : {
							'Content-Type' : undefined
						}

					})
					.then(
							function(response) {
								$scope.filterUiArray = JSON
										.parse(response.data.filterArray);
								$scope.searchName = response.data.searchName;

								if (flag === 'edit') {

									$scope.hide = true;
									$scope.setCustomSearchTool();
									$scope.filterUiArray = JSON
											.parse(response.data.filterArray);

									$timeout(
											function() {
												for (var i = 0; i < $scope.filterUiArray.length; i++) {

													if ($scope.filterUiArray[i] != undefined) {
														if ($scope.filterUiArray[i].uicomponent
																.indexOf('grid') > -1) {
															$rootScope
																	.$broadcast(
																			'loaddatafor',
																			{
																				id : $scope.filterUiArray[i].node.id,
																				selectedvals : $scope.filterUiArray[i].selectedVals
																			});

														} else if ($scope.filterUiArray[i].uicomponent == 'Listingcheckbox') {
															$scope.status.listed = $scope.filterUiArray[i].selectedVals[0].val;
															$scope.status.unlisted = $scope.filterUiArray[i].selectedVals[1].val;

														}else if ($scope.filterUiArray[i].uicomponent == 'RatingStatuscheckbox') {
															$scope.status.rated = $scope.filterUiArray[i].selectedVals[0].val;
															$scope.status.unrated = $scope.filterUiArray[i].selectedVals[1].val;

														}  
														else if ($scope.filterUiArray[i].uicomponent == 'AutocompleteMultiselectbod') {
															$scope.financialfilter.type = $scope.filterUiArray[i].selectedFilterType;
														} else if ($scope.filterUiArray[i].uicomponent == 'AutocompleteMultiselectcustomer') {
															$scope.searcharrcustomer = $scope.filterUiArray[i].selectedVals;
														} else if ($scope.filterUiArray[i].uicomponent == 'AutocompleteMultiselectsupplier') {
															$scope.searcharrSupplier = $scope.filterUiArray[i].selectedVals;
														} else if ($scope.filterUiArray[i].uicomponent == 'year_dropdown') {
															$scope.financialfilter.type = $scope.filterUiArray[i].selectedFilterType;

														} else if ($scope.filterUiArray[i].node != undefined
																&& $scope.filterUiArray[i].node.filterTreeId == 'Business_info_str_weak') {
															$scope.business.strwk = $scope.filterUiArray[i].selectedstrwkType;

														} else if ($scope.filterUiArray[i].uicomponent == 'quarter_dropdown') {
															$scope.searcharrbod = $scope.filterUiArray[i].selectedVals;

														} else if ($scope.filterUiArray[i].uicomponent == 'AutocompleteMultiselectasscomp') {

															$scope.searcharrcmp = $scope.filterUiArray[i].selectedObjs;

														}

													}

												}
											}, 3000)

								}
								if (flag === 'run') {

									$scope.runspinner = true;
									$scope.showrun = false;

									for (var i = 0; i < $scope.filterUiArray.length; i++) {

										if ($scope.filterUiArray[i].uicomponent == 'Listingcheckbox') {
											$scope.status.listed = $scope.filterUiArray[i].selectedVals[0].val;
											$scope.status.unlisted = $scope.filterUiArray[i].selectedVals[1].val;

										}else if ($scope.filterUiArray[i].uicomponent == 'RatingStatuscheckbox') {
											$scope.status.rated = $scope.filterUiArray[i].selectedVals[0].val;
											$scope.status.unrated = $scope.filterUiArray[i].selectedVals[1].val;
										}  
										else if ($scope.filterUiArray[i].uicomponent == 'AutocompleteMultiselectbod') {
											$scope.financialfilter.type = $scope.filterUiArray[i].selectedFilterType;
										} else if ($scope.filterUiArray[i].uicomponent == 'AutocompleteMultiselectcustomer') {
											$scope.searcharrcustomer = $scope.filterUiArray[i].selectedVals;
										} else if ($scope.filterUiArray[i].uicomponent == 'AutocompleteMultiselectsupplier') {
											$scope.searcharrSupplier = $scope.filterUiArray[i].selectedVals;
										} else if ($scope.filterUiArray[i].uicomponent == 'year_dropdown') {
											$scope.financialfilter.type = $scope.filterUiArray[i].selectedFilterType;

										} else if ($scope.filterUiArray[i].uicomponent == 'quarter_dropdown') {
											$scope.searcharrbod = $scope.filterUiArray[i].selectedVals;

										} else if ($scope.filterUiArray[i].uicomponent == 'AutocompleteMultiselectasscomp') {

											$scope.searcharrcmp = $scope.filterUiArray[i].selectedObjs;

										} else if ($scope.filterUiArray[i].node != undefined
												&& $scope.filterUiArray[i].node.filterTreeId == 'Business_info_str_weak') {
											$scope.business.strwk = $scope.filterUiArray[i].selectedstrwkType;

										}

									}

									$scope.searchComapny(true);

								}

							})["catch"](function(response) {

				$scope.failure = 'Error';
			})

		}

		$scope.deletefilter = function(userId, searchName) {
			if (searchName != null && searchName != "") {
				var fd = new FormData();
				var url = 'api/advanceSearch/deleteFilter';

				fd.append('searchName', searchName);

				$http.post(url, fd, {
					transformRequest : angular.identity,
					headers : {
						'Content-Type' : undefined
					}

				}).success(function(response) {
					$scope.deletesuccess = 'OK';

					$timeout(function() {
						$scope.deletesuccess = '';
					}, 10000);
					
					$http({
						url : 'api/advanceSearch/getsavesearch',
						method : 'POST',
						data : $scope.isWizardRatingSearch() ? 'W' : 'C'
					}).success(function(data) {
						$scope.saveSearch = data;

					}).error(function(response) {
					});

				}).error(function(response) {
					$scope.deletesuccess = 'ERROR';
					$scope.deleteerror = "Error ocuured while deleting data";
					$timeout(function() {
						$scope.deletesuccess = '';
						$scope.deleteerror = "";
					}, 10000);
				});
			}
		}

		$scope.cancelUpdate = function() {
			$state.reload();
		}
		$scope.saveflag = false;
		$scope.saveAdvanceSearch = function(searchName) {
			if (searchName != null && searchName != "") {
				var fd = new FormData();
				var url = 'api/advanceSearch/saveUserSaveFilter';
				fd.append('data', angular.toJson($scope.filterUiArray));
				fd.append('searchName', searchName);
				fd.append('subModule', $scope.saveType);
				$http.post(url, fd, {
					transformRequest : angular.identity,
					headers : {
						'Content-Type' : undefined
					}

				}).success(function(response) {
					$scope.success = 'OK';
					$timeout(function() {
						$scope.success = '';
					}, 10000);
					$scope.cancel();
					if ($scope.isWizardRatingSearch())
						$scope.getSaveSearch('W');
				}).error(function(response) {
					$scope.validateSearch = '';
					$scope.alreadySearch = "Search Name is Already Exists.";

				});
			} else {
				$scope.alreadySearch = '';
				$scope.validateSearch = "Search Name is Required.";
			}
		}

		$scope.saveType = '';
		$scope.saveComapny = function(saveType) {
			if (saveType)
				$scope.saveType = saveType
			else
				$scope.saveType = 'C';
			$scope.saveflag = true;
			if ($scope.searchComapny(true)) {
				$scope.validateSearch = '';
				$scope.alreadySearch = '';
				var modal = $uibModal.open({
					templateUrl : 'advanceSearch-dialog.html',
					scope : $scope
				})

				$scope.modalInstance = modal;

				$scope.cancel = function() {

					$scope.modalInstance.dismiss('cancel');
				}
			}

		}

		$scope.updateComapny = function() {
			var fd = new FormData();
			
			//will update $scope.filterUiArray values for custom search and wizard
			$scope.saveflag = true;
			$scope.searchComapny(true)
			
			var url = 'api/advanceSearch/updateCompanyByName';
			fd.append('data', angular.toJson($scope.filterUiArray));
			fd.append('searchName', $scope.searchName);

			$http.post(url, fd, {
				transformRequest : angular.identity,
				headers : {
					'Content-Type' : undefined
				}

			}).then(function(response) {
				$scope.success = 'OK';
				$timeout(function() {
					$scope.success = '';
				}, 10000);
			})["catch"](function(response) {

				$scope.failure = 'Error';
			})

		}

		// add portfolio

		$scope.saveComapnyPortfolio = function() {
			$scope.shows = false;
			$scope.validatePortfolio = '';

			var modal = $uibModal.open({
				templateUrl : 'advanceSearchPortfolio-dialog.html',
				scope : $scope
			})

			$scope.modalInstance = modal;

			$scope.cancel = function() {

				$scope.modalInstance.dismiss('cancel');
			}

		}
		// portfolio details saved

		$scope.SavePortfolio = function(portfolioName) {
			if (portfolioName != null && portfolioName != "") {

				$http({
					url : 'api/advanceSearch/portfolio/portfolioNameValidation',
					method : 'POST',
					data : portfolioName,
				})
						.success(
								function(data) {

									if (data[0] === 'TRUE') {
										$scope.validatePortfolio = 'Portfolio already exists with name '
												+ portfolioName + '';

									} else {
										

										/*prepare request payload*/
										var filter = '';
										var filterType = $scope.searchType;
										if (filterType === 'WIZARD') {
											filter = JSON
													.stringify($scope.wizardFilters);
										} else if (filterType === 'CUSTOM') {
											filter = JSON
													.stringify($scope.customFilters);
										}

										if($scope.runflag){
											filterType = 'CUSTOM';
											filter = JSON
											.stringify($scope.customFilters);
										}
										var htmltreegridData = {
											filterObject : filter,
											searchType : filterType
										}
										

										$scope.inputData = {
											id : null,
											name : portfolioName,
											spreadData : '',
											uploadFlag : 'N',
											isDeleted : 'N',
											companyFilterObject : htmltreegridData,
											isShared : 'Y'
										}

										$http(
												{
													url : 'api/advanceSearch/portfolioresource/addPortfolio',
													method : 'POST',
													data : $scope.inputData,
												}).success(function(data) {
											$scope.successPortfolio = 'OK';
											$scope.cancel();
											$window.scrollTo(0, 0);
											$timeout(function() {
												$scope.successPortfolio = '';
											}, 10000);
											return false;
										}, function(error) {
										});

									}
								}, function(error) {

								});
			}

			else {
				$scope.validatePortfolio = "Portfolio Name is Required.";

			}
		}

		// Udpate Portfolio
		$scope.selectedPorfolio = null;
		$scope.upatePortfolio = function(updatePortfolio) {
			$scope.selectedPorfolio = updatePortfolio;
			
			if('Y' == $scope.selectedPorfolio.isAlertSet ){
				$('#editPortfolioRemoveAlertModal').modal('show');
			}else{
				$scope.updatePortfolioWithConfirmation(false);
			}
		}
		
		$scope.updatePortfolioWithConfirmation = function(addRemoveAlert){
			
			$('#editPortfolioRemoveAlertModal').modal('hide');

			if ($scope.selectedPorfolio.name != null && $scope.selectedPorfolio.name != "") {
				/*prepare request payload*/
				var filter = '';
				var filterType = $scope.searchType;
				if (filterType === 'WIZARD') {
					filter = JSON
							.stringify($scope.wizardFilters);
				} else if (filterType === 'CUSTOM') {
					filter = JSON
							.stringify($scope.customFilters);
				}
				
				if($scope.runflag){
					filterType = 'CUSTOM';
					filter = JSON
					.stringify($scope.customFilters);
				}

				var htmltreegridData = {
					filterObject : filter,
					searchType : filterType
				}
				
				$scope.inputData = {
					id : $scope.selectedPorfolio.id,
					name : $scope.selectedPorfolio.name,
					spreadData : '',
					uploadFlag : 'N',
					isDeleted : 'N',
					companyFilterObject : htmltreegridData,
					isShared : 'N',
					addRemoveAlert: addRemoveAlert
				}

				$http({
					url : 'api/advanceSearch/portfolioresource/addPortfolio',
					method : 'POST',
					data : $scope.inputData,
				}).then(function(data) {
					$scope.successPortfolio = 'OK';
					$scope.cancel();

					$window.scrollTo(0, 0);
					$timeout(function() {
						$scope.successPortfolio = '';
					}, 10000);
					
					if(addRemoveAlert){
						$scope.cacheReload = true;
						if ($scope.searchType === 'WIZARD') {
							$scope.seachWizardGnerate();
						} else if ($scope.searchType === 'CUSTOM'
								|| $scope.runflag) {
							$scope.searchComapny(true);
						} else if ($scope.searchType === 'COMPANY_TOOL') {
							$scope.searchCompanyTool('search');
						}
					}
					return false;

				}, function(error) {
					
					$scope.validatePortfolio = error.data.message;
					
					
				});

			}

			else {
				$scope.validatePortfolio = "Portfolio Name is Required.";

			}
		
		}

		// get save List Portfolio

		$scope.getListPortfolio = function() {
			$scope.shows = true;
			$scope.validatePortfolio = "";
			$http({
				url : 'api/portfolioresource/getListPortfolio',
				method : 'POST',
			}).success(function(data) {
				$scope.ListPortfolio = data;

			}).error(function(response) {
			});
		}

		$scope.validatefininputui = function(row) {
			var flag = 0;
			if (row.datasource.absoluteflag) {
				if (row.datasource.absToVal != null
						|| row.datasource.absfromVal != null) {
					flag++;
				}
			} else if (row.datasource.growthflag) {
				if (row.datasource.grwthfromVal != null
						|| row.datasource.grwthToVal != null) {
					flag++;
				}
			} else if (row.datasource.quartileFlag) {
				$scope.qflag = true;
				flag++;
			}

			flag = 0;
			return flag;
		}

		$scope.validatefininputuiind = function(row) {
			var flag = 0;

			if (row.datasource.absFrom != null || row.datasource.absTo != null) {
				flag++;
			}

			return flag;
		}

		$scope.searcharrcmp = [];
		$scope.selecteddata = {
			'rs' : []
		};

		//decide weather to reload the cache data
		$scope.cacheReload = false;
		
		//will call on click of search button for custom search
		$scope.searchComapny = function(resetFilter) {

			if (resetFilter) {
				$scope.filter = undefined;
				$scope.rbtnCaseTypeAll = true;
			}
			$scope.removeData = false;
			$scope.gridflag = '';
			$scope.errorMessages = [];
			$scope.qflag = false;
			$scope.showrun = false;
			$scope.smeflag = false;
			$scope.smecomponentlist = [ 'CB_Industry_Classification',
					'CB_Registered_Office_Location', 'CB_Listing_Status' ];
			$scope.searcharr = [];
			if ($scope.filterUiArray.length <= 3) {
				$scope.smefilterarray = $scope.filterUiArray.map(function(row) {
					return row.node.filterTreeId;
				});

				angular.forEach($scope.smefilterarray, function(value, key) {
					if ($scope.smecomponentlist.indexOf(value) != -1) {
						$scope.smeflag = true;
					} else {
						$scope.smeflag = false;
					}
				});

			}

			$scope.filterUiArray = $scope.filterUiArray.filter(function(row) {
				return row.KeyRatioName != 'Manufacutring/Trading/Service';
			});

			$scope.filterUiArray = $scope.filterUiArray.filter(function(row) {
				return row.uicomponent != 'dummy';
			});

			var flag = 0;
			var fsmDateValid = false;
			var fsmRangeValid = false;
			var flagforscorecardslider = false;
			var flagforscorecardyeardropdown = false;

			for (var i = 0; i < $scope.filterUiArray.length; i++)

			{
				if ($scope.filterUiArray[i].uicomponent == 'radioinputupdown') {
					$scope.filterUiArray[i].selectedVals = {
						'type' : $scope.selctedReason.type,
						'data' : $scope.selecteddata.rs

					};
					if ($scope.selctedReason.type != 'none'
							&& $scope.selecteddata.rs.length > 0) {
						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}

				}

				if ($scope.filterUiArray[i].uicomponent == 'year_dropdown') {
					$scope.filterUiArray[i].selectedFilterType = $scope.financialfilter.type;
					if ($scope.filterUiArray[i].selectedVals != "") {
						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}
				}

				if ($scope.filterUiArray[i].uicomponent == 'dropdown'
						&& $scope.filterUiArray[i].node.filterTreeId == 'Business_info_str_weak') {
					$scope.filterUiArray[i].selectedstrwkType = $scope.business.strwk;

				}

				if ($scope.filterUiArray[i].uicomponent == 'quarter_dropdown') {
					$scope.filterUiArray[i].selectedFilterType = $scope.financialfilter.type;
					if ($scope.filterUiArray[i].selectedVals.datastr != null
							|| $scope.filterUiArray[i].selectedVals.datastr != "") {
						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}
				}

				if ($scope.filterUiArray[i].uicomponent == 'Rzslider') {
					if ($scope.filterUiArray[i].datasource.minValue != null
							|| $scope.filterUiArray[i].datasource.maxValue != "") {
						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;

					}
				}
				if ($scope.filterUiArray[i].uicomponent == 'dropdown' || $scope.filterUiArray[i].uicomponent == 'dropdown_single_select') {
					if ($scope.filterUiArray[i].selectedVals != null
							&& $scope.filterUiArray[i].selectedVals.length > 0) {
						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}
				}
				if ($scope.filterUiArray[i].uicomponent == 'datefilter') {

					if ($scope.selecteddate.option == 'single') {
						$scope.filterUiArray[i].datasource.end = null;
						if ($scope.filterUiArray[i].datasource.start != null) {
							flag++;
						} else {
							$scope.filterUiArray[i].errorflag = true;
						}

					} else {

						if ($scope.filterUiArray[i].datasource.start != null
								&& $scope.filterUiArray[i].datasource.end != null) {
							flag++;
						} else {
							$scope.filterUiArray[i].errorflag = true;
						}
					}
				}
				
				
				if($scope.filterUiArray[i].uicomponent == 'Rzslider_for_scorecard'){
					if($scope.filterUiArray[i].datasource.minValue != undefined &&   $scope.filterUiArray[i].datasource.maxValue != undefined){
						flagforscorecardslider = true;
					}
				}
				if($scope.filterUiArray[i].uicomponent == 'year_dropdown_for_scorecard'){
					if($scope.filterUiArray[i].selectedVals != undefined){
						flagforscorecardyeardropdown = true; 

					}
				}

				
				
				if ($scope.filterUiArray[i].uicomponent == 'date_filter_fsm') {

					if ($scope.selecteddatefsm.option == 'single') {
						$scope.filterUiArray[i].datasource.end = null;
						if ($scope.filterUiArray[i].datasource.start != null) {
							flag++;
							fsmDateValid = true;
						} else {
							fsmDateValid = false;
							$scope.filterUiArray[i].errorflag = true;
						}

					} else {

						if ($scope.filterUiArray[i].datasource.start != null
								&& $scope.filterUiArray[i].datasource.end != null) {
							fsmDateValid = true;
							flag++;
						} else {
							fsmDateValid = false;
							$scope.filterUiArray[i].errorflag = true;
						}
					}
					
					
				}
				
				if ($scope.filterUiArray[i].uicomponent == 'range_input_fsm') {
					
					var row = $scope.filterUiArray[i];
					if (row.datasource.absFrom != null
							|| row.datasource.absTo != null) {
						flag++;

						if (parseFloat(row.datasource.absTo) < parseFloat(row.datasource.absFrom) || parseFloat(row.datasource.absTo) > 4 
								|| parseFloat(row.datasource.absFrom) < 0) {
							$scope.errorMessages
									.push("Please select From and To value correctly (between 0 To 4) ");
							flag = 0;
							$scope.filterUiArray[i].errorflag = true;
							fsmRangeValid = false;
						}else{
							fsmRangeValid = true;
						}

					} else {
						fsmRangeValid = false;
						$scope.filterUiArray[i].errorflag = true;
					}
				}
				if ($scope.filterUiArray[i].uicomponent == 'fin_info_range_input') {

					var row = $scope.filterUiArray[i];
					var flag = 0;
					if (row.datasource.absoluteflag) {
						if (row.datasource.absToVal != null
								|| row.datasource.absfromVal != null) {
							flag++;

							if (parseInt(row.datasource.absToVal) < parseInt(row.datasource.absfromVal)) {
								$scope.errorMessages
										.push("Please select From and To value correctly ");
								flag = 0;
								$scope.filterUiArray[i].errorflag = true;
							}

						} else {
							$scope.filterUiArray[i].errorflag = true;
						}

					} else if (row.datasource.growthflag
							&& row.datasource.growthflag != 'NA') {
						if (parseInt(row.datasource.grwthfromVal) != null
								|| parseInt(row.datasource.grwthToVal) != null) {
							flag++;

							if (parseInt(row.datasource.grwthToVal) < parseInt(row.datasource.grwthfromVal)) {
								$scope.errorMessages
										.push("Please select From and To value correctly ");
								flag = 0;
								$scope.filterUiArray[i].errorflag = true;
							}

						} else {
							$scope.filterUiArray[i].errorflag = true;
						}
					} else if (row.datasource.quartileFlag) {

						flag++;
						$scope.qflag = true;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}

				}
				// added for industry validation
				if ($scope.filterUiArray[i].uicomponent == 'fin_info_range_input_ind') {

					var row = $scope.filterUiArray[i];
					var flag = 0;

					if (row.datasource.absTo != null
							|| row.datasource.absFrom != null) {
						flag++;

						if (parseInt(row.datasource.absTo) < parseInt(row.datasource.absFrom)) {
							$scope.errorMessages
									.push("Please select From and To value correctly ");
							flag = 0;
							$scope.filterUiArray[i].errorflag = true;
						}

					} else {
						$scope.filterUiArray[i].errorflag = true;
					}

				}

				if ($scope.filterUiArray[i].uicomponent == 'FixedIncomeDateFilter') {
					/*
					 * if ($scope.filterUiArray[i].datasource[i].fromVal !=
					 * null) {
					 */
					if ($scope.filterUiArray[i].datasource.start != null) {

						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}
				}
				if ($scope.filterUiArray[i].uicomponent == 'daterangefilter') {

					if ($scope.filterUiArray[i].datasource.start != null
							&& $scope.filterUiArray[i].datasource.end != null) {

						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}

				}
				if ($scope.filterUiArray[i].uicomponent == 'facilityoptions') {
					flag = 0;
					for (var j = 0; j < $scope.filterUiArray[i].datasource.length; j++) {
						var paramkeys = Object
								.keys($scope.filterUiArray[i].datasource[j]);
						if (paramkeys.length > 1) {
							flag++;
						}
					}

					if (flag == 0) {
						$scope.filterUiArray[i].errorflag = true;
					}

				}
				if ($scope.filterUiArray[i].uicomponent == 'IRSscoreRange') {
					if ($scope.filterUiArray[i].datasource.fromVal != null
							&& $scope.filterUiArray[i].datasource.toVal != null) {
						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}
				}

				if ($scope.filterUiArray[i].uicomponent == 'sharereturninput') {

					if ($scope.filterUiArray[i].datasource[0].returnoption != null
							&& $scope.filterUiArray[i].datasource[0].rangeFrom != null
							&& $scope.filterUiArray[i].datasource[0].rangeTo != null) {
						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}
				}
				if ($scope.filterUiArray[i].uicomponent == 'dividentinput') {

					if ($scope.filterUiArray[i].datasource[0].rangeFrom != null
							&& $scope.filterUiArray[i].datasource[0].rangeTo != null) {

						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}
				}

				if ($scope.filterUiArray[i].uicomponent == 'marketinput') {

					var row = $scope.filterUiArray[i];
					var flag = 0;
					if (row.datasource[0].absoluteflag) {
						if (row.datasource[0].absToVal != null
								|| row.datasource[0].absfromVal != null) {
							flag++;

							if (parseInt(row.datasource[0].absToVal) < parseInt(row.datasource[0].absfromVal)) {
								$scope.errorMessages
										.push("Please select From and To value correctly ");
								flag = 0;
								$scope.filterUiArray[i].errorflag = true;
							}

						} else {
							$scope.filterUiArray[i].errorflag = true;
						}

					} else if (row.datasource[0].growthflag) {
						if (parseInt(row.datasource[0].grwthfromVal) != null
								|| parseInt(row.datasource[0].grwthToVal) != null) {
							flag++;

							if (parseInt(row.datasource[0].grwthToVal) < parseInt(row.datasource[0].grwthfromVal)) {
								$scope.errorMessages
										.push("Please select From and To value correctly ");
								flag = 0;
								$scope.filterUiArray[i].errorflag = true;
							}

						} else {
							$scope.filterUiArray[i].errorflag = true;
						}
					} else if (row.datasource[0].quartileFlag) {
						flag++;
						$scope.qflag = true;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}

					/*
					 * if ($scope.filterUiArray[i].datasource[i].absfromVal !=
					 * null && $scope.filterUiArray[i].datasource[i].absToVal !=
					 * null) {
					 * 
					 * flag++; }else { $scope.filterUiArray[i].errorflag = true; }
					 */
				}

				if ($scope.filterUiArray[i].uicomponent == 'rangeinputs') {
					if ($scope.filterUiArray[i].datasource[0].PEfrom != null) {
						flag++;
					}// logic applied by Srinivas for task #46908
					else if ($scope.filterUiArray[i].datasource[0].PBfrom != null) {
						flag++;
					} else if ($scope.filterUiArray[i].datasource[0].EPSfrom != null) {
						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}
				}

				if ($scope.filterUiArray[i].uicomponent == 'perRangeBox') {
					if ($scope.filterUiArray[i].datasource.fromVal != null
							&& $scope.filterUiArray[i].datasource.fromVal != ''
							&& $scope.filterUiArray[i].datasource.toVal != null
							&& $scope.filterUiArray[i].datasource.toVal != '') {
						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}
				}

				if ($scope.filterUiArray[i].uicomponent == 'defaultpushbuttons') {
					flag = 0;
					for (var k = 0; k < $scope.filterUiArray[i].datasource.length; k++) {

						if ($scope.filterUiArray[i].datasource[k].value) {
							flag++;
						}
					}
					if (flag == 0) {
						$scope.filterUiArray[i].errorflag = true;
					}
				}
				
				if ($scope.filterUiArray[i].uicomponent == 'defaultpushbuttonsoutlookchange') {
					var flagFrom = 0;
					var flagTo = 0
					for (var k = 0; k < $scope.filterUiArray[i].datasource.from.length; k++) {

						if ($scope.filterUiArray[i].datasource.from[k].value) {
							flagFrom++;
						}
					}
					for (var k = 0; k < $scope.filterUiArray[i].datasource.to.length; k++) {

						if ($scope.filterUiArray[i].datasource.to[k].value) {
							flagTo++;
						}
					}
					if (flagFrom == 0 || flagTo ==0) {
						$scope.filterUiArray[i].errorflag = true;
					}
				}
				
				if ($scope.filterUiArray[i].uicomponent == 'dropdownAmountChange') {
					
					
					if($scope.filterUiArray[i].selectedVals == null || $scope.filterUiArray[i].selectedVals.length == 0){
						$scope.filterUiArray[i].errorflag = true;
					}else{
						if(($scope.filterUiArray[i].datasource.amntRange.amntRangeFrom == null 
								&& $scope.filterUiArray[i].datasource.amntRange.amntRangeTo == null ) ||
								($scope.filterUiArray[i].datasource.amntRange.amntRangeFrom != null 
										&& $scope.filterUiArray[i].datasource.amntRange.amntRangeTo != null  
										&& $scope.filterUiArray[i].datasource.amntRange.amntRangeTo > 0 
										&& $scope.filterUiArray[i].datasource.amntRange.amntRangeFrom <	$scope.filterUiArray[i].datasource.amntRange.amntRangeTo )){
							flag++;
						}else{
							$scope.errorMessages
							.push("please select From and To value correctly.");
							flag = 0;
							$scope.filterUiArray[i].errorflag = true;
						}
						
					}
					
				}
				
				// added for bod and associate companies
				if ($scope.filterUiArray[i].uicomponent == 'AutocompleteMultiselectbod') {
					$scope.filterUiArray[i].selectedVals = $scope.searcharrbod;
					if ($scope.filterUiArray[i].selectedVals.length > 0) {
						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}
				}

				// added for customerDetails
				if ($scope.filterUiArray[i].uicomponent == 'AutocompleteMultiselectcustomer') {
					$scope.filterUiArray[i].selectedVals = $scope.searcharrcustomer;
					if ($scope.filterUiArray[i].selectedVals.length > 0) {
						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}
				}
				if ($scope.filterUiArray[i].uicomponent == 'AutocompleteMultiselectsupplier') {
					$scope.filterUiArray[i].selectedVals = $scope.searcharrSupplier;
					if ($scope.filterUiArray[i].selectedVals.length > 0) {
						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}
				}

				if ($scope.filterUiArray[i].uicomponent == 'AutocompleteMultiselectasscomp') {
					var listofcomp = $scope.searcharrcmp.map(function(row) {
						return row.companyName;
					});
					$scope.filterUiArray[i].selectedObjs = $scope.searcharrcmp;
					$scope.filterUiArray[i].selectedVals = listofcomp;
					if ($scope.filterUiArray[i].selectedVals.length > 0) {
						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}
				}

				if ($scope.filterUiArray[i].uicomponent == 'AutocompleteMultiselect') {
					$scope.filterUiArray[i].selectedVals = $scope.searcharrcmp;
					if ($scope.filterUiArray[i].selectedVals.length > 0) {
						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}
				}

				if ($scope.filterUiArray[i].uicomponent == 'radioinputTransiiton') {
					if ($scope.showlongtermscale) {
						$scope.filterUiArray[i].selectedVals = {
							'minVal' : $scope.peerGroupLongTermRatingValues.minValue,
							'maxVal' : $scope.peerGroupLongTermRatingValues.maxValue,
							'minValTo' : $scope.peerGroupLongTermRatingValuesTo.minValue,
							'maxValTo' : $scope.peerGroupLongTermRatingValuesTo.maxValue,
							'type' : 'LONG'

						};
					}
					if ($scope.showshorttermscale) {
						$scope.filterUiArray[i].selectedVals = {
							'minVal' : $scope.peerGroupShortTermRatingValues.minValue,
							'maxVal' : $scope.peerGroupShortTermRatingValues.maxValue,
							'minValTo' : $scope.peerGroupShortTermRatingValuesTo.minValue,
							'maxValTo' : $scope.peerGroupShortTermRatingValuesTo.maxValue,
							'type' : 'SHORT'
						};
					}

					if ($scope.filterUiArray[i].selectedVals != null) {
						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}

				}

				if ($scope.filterUiArray[i].uicomponent == 'treeviewtype') {
					if (($scope.filterUiArray[i].selectedVals == null || $scope.filterUiArray[i].selectedVals == undefined)
							&& ($scope.filterUiArray[i].selectedVals.arrval == null || $scope.filterUiArray[i].selectedVals.arrval == undefined)) {
						$scope.filterUiArray[i].errorflag = true;
					} else {

						if ($scope.filterUiArray[i].selectedVals.arrval != undefined) {
							$scope.filterUiArray[i].selectedVals = $scope.filterUiArray[i].selectedVals.arrval
									.map(function(row) {
										return row;
									});
						}

						if ($scope.filterUiArray[i].selectedVals.length > 0) {
							flag++;
						} else {
							$scope.filterUiArray[i].errorflag = true;
						}
					}

				}

				if ($scope.filterUiArray[i].uicomponent == 'locationTreegrid'
						&& $scope.filterUiArray[i].node.filterTreeId != 'Business_info_plant_loc') {
					if ($scope.queryflag != 'run') {
						$rootScope.$broadcast('getdatafor'
								+ $scope.filterUiArray[i].node.id);

						$scope.filterUiArray[i].selectedVals = $scope.useindvals1;

						if ($scope.useindvals1.indexOf('All') > -1) {
							$scope.filterUiArray[i].selectedVals = 'All selected';
						}

						if ($scope.filterUiArray[i].selectedVals.length > 0) {
							flag++;
						} else {
							$scope.filterUiArray[i].errorflag = true;
						}

					}
				}

				if ($scope.filterUiArray[i].uicomponent == 'plantlocationgrid') {
					if ($scope.queryflag != 'run') {
						$rootScope.$broadcast('getdatafor'
								+ $scope.filterUiArray[i].node.id);

						$scope.filterUiArray[i].selectedVals = $scope.plantlocids;

						if ($scope.filterUiArray[i].selectedVals.indexOf('All') > -1) {
							$scope.filterUiArray[i].selectedVals = 'All selected';
						}
						if ($scope.filterUiArray[i].selectedVals.length > 0) {
							flag++;
						} else {
							$scope.filterUiArray[i].errorflag = true;
						}

					}
				}

				if ($scope.filterUiArray[i].uicomponent == 'industryTreegrid') {
					if ($scope.queryflag != 'run') {
						$rootScope.$broadcast('getdatafor'
								+ $scope.filterUiArray[i].node.id);

						$scope.filterUiArray[i].selectedVals = $scope.useindvals;

						if ($scope.filterUiArray[i].selectedVals.indexOf('All') > -1) {
							$scope.filterUiArray[i].selectedVals = 'All selected';
						}

						if ($scope.filterUiArray[i].selectedVals.length > 0) {
							flag++;
						} else {
							$scope.filterUiArray[i].errorflag = true;
						}

					}
				}

				if ($scope.filterUiArray[i].uicomponent == 'productTreegrid') {
					if ($scope.queryflag != 'run') {
						$rootScope.$broadcast('getdatafor'
								+ $scope.filterUiArray[i].node.id);
						$scope.filterUiArray[i].selectedVals = $scope.useprodvals;

						if ($scope.filterUiArray[i].selectedVals.length > 0) {
							flag++;
						} else {
							$scope.filterUiArray[i].errorflag = true;
						}

					}

				}

				if ($scope.filterUiArray[i].uicomponent == 'Listingcheckbox') {
					$scope.selectedValues = [];
					var valuearr = $scope.filterUiArray[i].datasource;

					var temp = {
						"name" : 'Listed',
						"val" : $scope.status.listed
					};

					$scope.selectedValues.push(temp);

					var temp1 = {
						"name" : 'Unlisted',
						"val" : $scope.status.unlisted
					};

					$scope.selectedValues.push(temp1);

					$scope.filterUiArray[i].selectedVals = $scope.selectedValues;

					if ($scope.status.listed != null
							|| $scope.status.unlisted != null) {
						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}

				}
				if ($scope.filterUiArray[i].uicomponent == 'RatingStatuscheckbox') {
					$scope.selectedValues = [];
					var valuearr = $scope.filterUiArray[i].datasource;
					var temp = {
						"name" : 'Rated',
						"val" : $scope.status.rated
					};

					$scope.selectedValues.push(temp);

					var temp1 = {
						"name" : 'Unrated',
						"val" : $scope.status.unrated
					};

					$scope.selectedValues.push(temp1);

					$scope.filterUiArray[i].selectedVals = $scope.selectedValues;

					if ($scope.status.rated != null
							|| $scope.status.unrated != null) {
						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}

				}

				if ($scope.filterUiArray[i].uicomponent == 'checkboxes') {
					$scope.selectedValues = [];
					var valuearr = $scope.filterUiArray[i].datasource;
					for (var j = 0; j < valuearr.length; j++) {
						var temp = {
							"name" : valuearr[j].display,
							"val" : valuearr[j].selectedval
						};

						$scope.selectedValues.push(temp);

					}

					$scope.filterUiArray[i].selectedVals = $scope.selectedValues;

					var validarr = $scope.selectedValues.filter(function(row) {
						return row.val;
					});
					if (validarr.length > 0) {
						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}

				}

				if ($scope.filterUiArray[i].uicomponent == 'ratingMovementInput') {
					if ($scope.filterUiArray[i].datasource[0].CompareOperator != ""
							&& $scope.filterUiArray[i].datasource[0].updownstr != "") {

						if ($scope.filterUiArray[i].datasource[0].inputtext.fromVal != null) {
							flag++;
						} else {
							$scope.filterUiArray[i].errorflag = true;
						}

					} else {
						$scope.filterUiArray[i].errorflag = true;
					}
				}

				if ($scope.filterUiArray[i].uicomponent == 'radioinput') {
					$scope.selectedValues = [];
					var valuearr = $scope.filterUiArray[i].datasource;
					for (var j = 0; j < valuearr.length; j++) {
						var temp = {
							"name" : valuearr[j].Name,
							"val" : valuearr[j].selectedval
						};

						$scope.selectedValues.push(temp);

					}
					$scope.filterUiArray[i].selectedVals = $scope.selectedValues;

					$scope.filterUiArray[i].selectedVals
							.forEach(function(entry) {
								if (entry.val) {
									flag++;
								}
							});

					if (flag == 0) {
						$scope.filterUiArray[i].errorflag = true;
					}

				}

				if ($scope.filterUiArray[i].uicomponent == 'textinput') {
					$scope.selectedValues = [];
					var valuearr = $scope.filterUiArray[i].datasource;

					if ($scope.filterUiArray[i].inputtext != null
							&& $scope.filterUiArray[i].inputtext != '') {
						flag++;
					} else {
						$scope.filterUiArray[i].errorflag = true;
					}

				}

			}
			
			if((!fsmDateValid && fsmRangeValid) ||(fsmDateValid && !fsmRangeValid)){
				
				
				for (var i = 0; i < $scope.filterUiArray.length; i++){
					if($scope.filterUiArray[i].uicomponent == "date_filter_fsm" || $scope.filterUiArray[i].uicomponent == "range_input_fsm"){
						$scope.filterUiArray[i].errorflag = true;
					}
				}
				
				$scope.errorMessages
				.push("Please provide input for both filters - Date and FSM Score Range.");
			}

			if((!flagforscorecardslider && flagforscorecardyeardropdown) ||(flagforscorecardslider && !flagforscorecardyeardropdown)){
				
				
				for (var i = 0; i < $scope.filterUiArray.length; i++){
					if($scope.filterUiArray[i].uicomponent == "Rzslider_for_scorecard" || $scope.filterUiArray[i].uicomponent == "year_dropdown_for_scorecard"){
						$scope.filterUiArray[i].errorflag = true;
					}
				}
				
				$scope.errorMessages
				.push("Please provide input for both filters - Score and year.");
			}

			
			$scope.finalFilterArr = [];
			$scope.finalFilterArr = angular.copy($scope.filterUiArray);

			//for Manufacutring
			$scope.Manufacturingkeyfilters = [];

			$scope.Manufacturingkeyfilters = $scope.finalFilterArr
					.filter(function(row) {

						return row.keyrationtypeforparam == 'Manufacutring' || (row.node != undefined
								&& row.node.filterTreeId == 'MFG_year');
					});

			if ($scope.Manufacturingkeyfilters.length > 0) {
				
				
				// validate year filter
				var validYearData = $scope.Manufacturingkeyfilters.filter(function(row) {

					return (row.node != undefined
							&& row.node.filterTreeId == 'MFG_year');

				});
				
				//validate financial filter
				var validDataFilters = $scope.Manufacturingkeyfilters.filter(function(row) {

					return row.keyrationtypeforparam == 'Manufacutring';

				});

				if (validYearData.length == 0 || validDataFilters.length == 0) {
					$scope.iferror = true;
					$scope.errorMessages
							.push("please select atleast one financial parameter and result year to compare");

					$timeout(function() {

						$scope.iferror = false;
						$scope.errorMessages = "";

					}, 5000);

					return false;
				} 
				
					var yearToSet = '';
					validYearData.map(function(row) {

						if (row.node != undefined
								&& row.node.filterTreeId == 'MFG_year') {

							yearToSet = row.selectedVals;
						}

					});

					$scope.mnfgDtasourceArr = validDataFilters.map(function(row) {
								return row.datasource;
							});
					var manufacuringFilterObj = {

						'KeyRatioName' : 'Manufacutring/Trading/Service',
						'filterDataArr' : $scope.mnfgDtasourceArr,
						'yearToSet' : yearToSet,
						'financialType' : $scope.financialfilter.type

					};
					$scope.finalFilterArr.push(manufacuringFilterObj);
					
			}

			// FOR BANK

			$scope.BankKeyfilters = [];
			var yeatToSetbnk = '';
			$scope.BankKeyfilters = $scope.finalFilterArr.filter(function(row) {
				return row.keyrationtypeforparam == 'BANK' || (row.node != undefined
						&& row.node.filterTreeId == 'BNK_year');
			});

			if ($scope.BankKeyfilters.length > 0) {

				// validate year filter
				var validYearData = $scope.BankKeyfilters.filter(function(row) {

					return (row.node != undefined
							&& row.node.filterTreeId == 'BNK_year');

				});

				// validate financial filter
				var validDataFilters = $scope.BankKeyfilters.filter(function(
						row) {

					return row.keyrationtypeforparam == 'BANK';

				});

				if (validYearData.length == 0 || validDataFilters.length == 0) {
					$scope.iferror = true;
					$scope.errorMessages
							.push("please select atleast one financial parameter and result year to compare");

					$timeout(function() {

						$scope.iferror = false;
						$scope.errorMessages = "";

					}, 5000);

					return false;
				}

				validYearData.map(function(row) {

					if (row.node != undefined
							&& row.node.filterTreeId == 'BNK_year') {

						yeatToSetbnk = row.selectedVals;
					}

				});

				$scope.bnkgDtasourceArr = validDataFilters.map(function(row) {
					return row.datasource;
				});
				var bankFilterObj = {

					'KeyRatioName' : 'BANK',
					'filterDataArr' : $scope.bnkgDtasourceArr,
					'yearToSet' : yeatToSetbnk,
					'financialType' : $scope.financialfilter.type

				};
				$scope.finalFilterArr.push(bankFilterObj);

			}

			// for nbfc

			$scope.NbfcKeyfilters = [];
			var yeatToSetnbfc = '';
			$scope.nbfcKeyfilters = $scope.finalFilterArr.filter(function(row) {
				return row.keyrationtypeforparam == 'NBFC' || (row.node != undefined
						&& row.node.filterTreeId == 'NFC_year');
			});

			if ($scope.nbfcKeyfilters.length > 0) {

				// validate year filter
				var validYearData = $scope.nbfcKeyfilters.filter(function(row) {

					return (row.node != undefined
							&& row.node.filterTreeId == 'NFC_year');

				});

				// validate financial filter
				var validDataFilters = $scope.nbfcKeyfilters.filter(function(
						row) {

					return row.keyrationtypeforparam == 'NBFC';

				});

				if (validYearData.length == 0 || validDataFilters.length == 0) {
					$scope.iferror = true;
					$scope.errorMessages
							.push("please select atleast one financial parameter and result year to compare");

					$timeout(function() {

						$scope.iferror = false;
						$scope.errorMessages = "";

					}, 5000);

					return false;
				}

				validYearData.map(function(row) {

					if (row.node != undefined
							&& row.node.filterTreeId == 'NFC_year') {

						yeatToSetnbfc = row.selectedVals;
					}

				});
					
					$scope.nbfcDtasourceArr = validDataFilters.map(function(row) {
								return row.datasource;
							});
					var nbfcFilterObj = {

						'KeyRatioName' : 'NBFC',
						'filterDataArr' : $scope.nbfcDtasourceArr,
						'yearToSet' : yeatToSetnbfc,
						'financialType' : $scope.financialfilter.type

					};
					$scope.finalFilterArr.push(nbfcFilterObj);
			}

			// FOR INTERIM MANUFACTURING
			$scope.IntManfKeyfilters = [];
			var quarterDateMfg = '';
			var prevquarterDateMfg = '';
			$scope.IntManfKeyfilters = $scope.finalFilterArr.filter(function(
					row) {
				return row.keyrationtypeforparam == 'Interim_Manufacturing' || (row.node != undefined
						&& row.node.filterTreeId == 'Interim_Manf_Qurter');
			});

			if ($scope.IntManfKeyfilters.length > 0) {

				// validate year filter
				var validYearData = $scope.IntManfKeyfilters.filter(function(row) {

					return (row.node != undefined
							&& row.node.filterTreeId == 'Interim_Manf_Qurter');

				});

				// validate financial filter
				var validDataFilters = $scope.IntManfKeyfilters.filter(function(
						row) {

					return row.keyrationtypeforparam == 'Interim_Manufacturing';

				});

				if (validYearData.length == 0 || validDataFilters.length == 0) {
					$scope.iferror = true;
					$scope.errorMessages
							.push("please select atleast one financial parameter and result year to compare");

					$timeout(function() {

						$scope.iferror = false;
						$scope.errorMessages = "";

					}, 5000);

					return false;
				}
				
				validYearData.map(function(row) {

						if (row.node != undefined
								&& row.node.filterTreeId == 'Interim_Manf_Qurter') {

							quarterDateMfg = row.selectedVals.dateval;
							prevquarterDateMfg = row.selectedVals.prevdate;
						}

					});

					$scope.intmfgDtasourceArr = validDataFilters.map(function(row) {
								return row.datasource;
							});
					var intmfgFilterObj = {

						'KeyRatioName' : 'Interim_Manufacturing',
						'filterDataArr' : $scope.intmfgDtasourceArr,
						'QuarterDate' : quarterDateMfg,
						'PrevQuarterDate' : prevquarterDateMfg,
						'financialType' : $scope.financialfilter.type

					};
					$scope.finalFilterArr.push(intmfgFilterObj);
					
			}
			// FOR INTERIM bANK
			$scope.IntBankKeyfilters = [];
			var quarterDateBank = '';
			var prevquarterDateBank = '';
			$scope.IntBankKeyfilters = $scope.finalFilterArr.filter(function(
					row) {
				return row.keyrationtypeforparam == 'Interim_Bank' || (row.node != undefined
						&& row.node.filterTreeId == 'Interim_Bank_Qurter');
			});

			if ($scope.IntBankKeyfilters.length > 0) {

				// validate year filter
				var validYearData = $scope.IntBankKeyfilters.filter(function(row) {

					return (row.node != undefined
							&& row.node.filterTreeId == 'Interim_Bank_Qurter');

				});

				// validate financial filter
				var validDataFilters = $scope.IntBankKeyfilters.filter(function(
						row) {

					return row.keyrationtypeforparam == 'Interim_Bank';

				});

				if (validYearData.length == 0 || validDataFilters.length == 0) {
					$scope.iferror = true;
					$scope.errorMessages
							.push("please select atleast one financial parameter and result year to compare");

					$timeout(function() {

						$scope.iferror = false;
						$scope.errorMessages = "";

					}, 5000);

					return false;
				}
				validYearData.map(function(row) {

					if (row.node != undefined
							&& row.node.filterTreeId == 'Interim_Bank_Qurter') {

						quarterDateBank = row.selectedVals.dateval;
						prevquarterDateBank = row.selectedVals.prevdate;

					}

				});
				
					$scope.intbankDtasourceArr = validDataFilters.map(function(row) {
								return row.datasource;
							});
					var intbankFilterObj = {

						'KeyRatioName' : 'Interim_Bank',
						'filterDataArr' : $scope.intbankDtasourceArr,
						'QuarterDate' : quarterDateBank,
						'PrevQuarterDate' : prevquarterDateBank,
						'financialType' : $scope.financialfilter.type

					};
					$scope.finalFilterArr.push(intbankFilterObj);
			}
			// Interim_Nbfc
			// FOR INTERIM bANK
			$scope.IntNbfcKeyfilters = [];
			var quarterDateNbfc = '';
			var prevquarterDateNbfc = '';
			$scope.IntNbfcKeyfilters = $scope.finalFilterArr.filter(function(
					row) {
				return row.keyrationtypeforparam == 'Interim_Nbfc' || (row.node != undefined
						&& row.node.filterTreeId == 'Interim_Nbfc_Qurter');
			});

			if ($scope.IntNbfcKeyfilters.length > 0) {

				// validate year filter
				var validYearData = $scope.IntNbfcKeyfilters.filter(function(row) {

					return (row.node != undefined
							&& row.node.filterTreeId == 'Interim_Nbfc_Qurter');

				});

				// validate financial filter
				var validDataFilters = $scope.IntNbfcKeyfilters.filter(function(
						row) {

					return row.keyrationtypeforparam == 'Interim_Nbfc';

				});

				if (validYearData.length == 0 || validDataFilters.length == 0) {
					$scope.iferror = true;
					$scope.errorMessages
							.push("please select atleast one financial parameter and result year to compare");

					$timeout(function() {

						$scope.iferror = false;
						$scope.errorMessages = "";

					}, 5000);

					return false;
				}
				
				validYearData.map(function(row) {

					if (row.node != undefined
							&& row.node.filterTreeId == 'Interim_Nbfc_Qurter') {

						quarterDateNbfc = row.selectedVals.dateval;
						prevquarterDateNbfc = row.selectedVals.prevdate;
					}

				});
				
					$scope.intNbfcDtasourceArr = validDataFilters.map(function(row) {
								return row.datasource;
							});
					var intNbfcFilterObj = {

						'KeyRatioName' : 'Interim_Nbfc',
						'filterDataArr' : $scope.intNbfcDtasourceArr,
						'QuarterDate' : quarterDateNbfc,
						'PrevQuarterDate' : prevquarterDateNbfc,
						'financialType' : $scope.financialfilter.type

					};
					$scope.finalFilterArr.push(intNbfcFilterObj);
			}

			// annual_manf
			// FOR annual mfg
			$scope.AnnMfgKeyfilters = [];
			var annYearMfg = '';
			$scope.annMfgKeyfilters = $scope.finalFilterArr
					.filter(function(row) {
						return row.keyrationtypeforparam == 'annual_manfacturing' || (row.node != undefined
								&& row.node.filterTreeId == 'annual_Manf_Year');
					});


			if ($scope.annMfgKeyfilters.length > 0) {

				// validate year filter
				var validYearData = $scope.annMfgKeyfilters.filter(function(row) {

					return (row.node != undefined
							&& row.node.filterTreeId == 'annual_Manf_Year');

				});

				// validate financial filter
				var validDataFilters = $scope.annMfgKeyfilters.filter(function(
						row) {

					return row.keyrationtypeforparam == 'annual_manfacturing';

				});

				if (validYearData.length == 0 || validDataFilters.length == 0) {
					$scope.iferror = true;
					$scope.errorMessages
							.push("please select atleast one financial parameter and result year to compare");

					$timeout(function() {

						$scope.iferror = false;
						$scope.errorMessages = "";

					}, 5000);

					return false;
				}
				
				validYearData.map(function(row) {

					if (row.node != undefined
							&& row.node.filterTreeId == 'annual_Manf_Year') {

						annYearMfg = row.selectedVals;
					}

				});

					$scope.annMfgDtasourceArr = validDataFilters.map(function(row) {
								return row.datasource;
							});
					var annMfgFilterObj = {

						'KeyRatioName' : 'Annual_Mnfg',
						'filterDataArr' : $scope.annMfgDtasourceArr,
						'yearToSet' : annYearMfg,
						'financialType' : $scope.financialfilter.type

					};
					$scope.finalFilterArr.push(annMfgFilterObj);
			}

			// for Bank Annual
			$scope.annBnkKeyfilters = [];
			var annYearBnk = '';
			$scope.annBnkKeyfilters = $scope.finalFilterArr
					.filter(function(row) {
						return row.keyrationtypeforparam == 'annual_Bank' || (row.node != undefined
								&& row.node.filterTreeId == 'annual_Bank_Year');
					});

			if ($scope.annBnkKeyfilters.length > 0) {

				// validate year filter
				var validYearData = $scope.annBnkKeyfilters.filter(function(row) {

					return (row.node != undefined
							&& row.node.filterTreeId == 'annual_Bank_Year');

				});

				// validate financial filter
				var validDataFilters = $scope.annBnkKeyfilters.filter(function(
						row) {

					return row.keyrationtypeforparam == 'annual_Bank';

				});

				if (validYearData.length == 0 || validDataFilters.length == 0) {
					$scope.iferror = true;
					$scope.errorMessages
							.push("please select atleast one financial parameter and result year to compare");

					$timeout(function() {

						$scope.iferror = false;
						$scope.errorMessages = "";

					}, 5000);

					return false;
				}
				
				validYearData.map(function(row) {

					if (row.node != undefined
							&& row.node.filterTreeId == 'annual_Bank_Year') {

						annYearBnk = row.selectedVals;
					}

				});
				
					$scope.annBnkDtasourceArr = validDataFilters.map(function(row) {
								return row.datasource;
							});
					var annBnkFilterObj = {

						'KeyRatioName' : 'Annual_Bank',
						'filterDataArr' : $scope.annBnkDtasourceArr,
						'yearToSet' : annYearBnk,
						'financialType' : $scope.financialfilter.type

					};
					$scope.finalFilterArr.push(annBnkFilterObj);
			}

			// for nbfc annual

			$scope.annNbfcKeyfilters = [];
			var annYearNbfc = '';
			$scope.annNbfcKeyfilters = $scope.finalFilterArr.filter(function(
					row) {
				return row.keyrationtypeforparam == 'annual_Nbfc' || (row.node != undefined
						&& row.node.filterTreeId == 'annual_nbfc_Year');
			});

			if ($scope.annNbfcKeyfilters.length > 0) {

				// validate year filter
				var validYearData = $scope.annNbfcKeyfilters.filter(function(row) {

					return (row.node != undefined
							&& row.node.filterTreeId == 'annual_nbfc_Year');

				});

				// validate financial filter
				var validDataFilters = $scope.annNbfcKeyfilters.filter(function(
						row) {

					return row.keyrationtypeforparam == 'annual_Nbfc';

				});

				if (validYearData.length == 0 || validDataFilters.length == 0) {
					$scope.iferror = true;
					$scope.errorMessages
							.push("please select atleast one financial parameter and result year to compare");

					$timeout(function() {

						$scope.iferror = false;
						$scope.errorMessages = "";

					}, 5000);

					return false;
				}
				
				validYearData.map(function(row) {

					if (row.node != undefined
							&& row.node.filterTreeId == 'annual_nbfc_Year') {

						annYearNbfc = row.selectedVals;
					}

				});
				
					$scope.annNbfcDtasourceArr = validDataFilters.map(function(row) {
								return row.datasource;
							});
					var annNbfcFilterObj = {

						'KeyRatioName' : 'Annual_Nbfc',
						'filterDataArr' : $scope.annNbfcDtasourceArr,
						'yearToSet' : annYearNbfc,
						'financialType' : $scope.financialfilter.type

					};
					$scope.finalFilterArr.push(annNbfcFilterObj);
			}

			// added for industryinfo ratio mfg
			$scope.mfgIndRatio = [];
			var yeatToSetbnk = '';
			$scope.mfgIndRatio = $scope.finalFilterArr.filter(function(row) {
				return row.keyrationtypeforparam == 'ManufacturingIndustry';
			});
			if ($scope.mfgIndRatio.length > 0) {
				$scope.mfgIndRatioDataArr = $scope.mfgIndRatio
						.map(function(row) {

							return row.datasource;
						});
				var mfgIndFilterObj = {
					'KeyRatioName' : 'IndustryManufacturingRatio',
					'filterDataArr' : $scope.mfgIndRatioDataArr
				};
				$scope.finalFilterArr.push(mfgIndFilterObj);
			}

			$scope.finalFilterArr = $scope.finalFilterArr.filter(function(row) {
				return row.keyrationtypeforparam != 'ManufacturingIndustry';
			});

			// added for industryinfo ratio bank
			$scope.bnkIndRatio = [];

			$scope.bnkIndRatio = $scope.finalFilterArr.filter(function(row) {
				return row.keyrationtypeforparam == 'BankIndustry';
			});
			if ($scope.bnkIndRatio.length > 0) {
				$scope.bnkIndRatioDataArr = $scope.bnkIndRatio
						.map(function(row) {
							return row.datasource;
						});
				var bnkIndFilterObj = {
					'KeyRatioName' : 'IndustryBankRatio',
					'filterDataArr' : $scope.bnkIndRatioDataArr
				};
				$scope.finalFilterArr.push(bnkIndFilterObj);
			}

			$scope.finalFilterArr = $scope.finalFilterArr.filter(function(row) {
				return row.keyrationtypeforparam != 'BankIndustry';
			});

			// added for industryinfo ratio nbfc
			$scope.nbfcIndRatio = [];

			$scope.nbfcIndRatio = $scope.finalFilterArr.filter(function(row) {
				return row.keyrationtypeforparam == 'NbfcIndustry';
			});
			if ($scope.nbfcIndRatio.length > 0) {
				$scope.nbfcIndRatioDataArr = $scope.nbfcIndRatio.map(function(
						row) {
					return row.datasource;
				});
				var nbfcIndFilterObj = {
					'KeyRatioName' : 'IndustryNbfcRatio',
					'filterDataArr' : $scope.nbfcIndRatioDataArr
				};
				$scope.finalFilterArr.push(nbfcIndFilterObj);
			}

			$scope.finalFilterArr = $scope.finalFilterArr.filter(function(row) {
				return row.keyrationtypeforparam != 'NbfcIndustry';
			});

			$scope.columnsToShow = [];
			$scope.searchOutput = null;

			var filter = { // just send the entire filter object for the server
				// to convert to SQL Statement.

				pageNumber : 1,
				pageSize : 10,
				filterExpressions : [],
				sortExpressions : [],
				doFilter: false,
				ratingActionIndex: -1,
				lastRatingActionIndex: -1,
				ltRating: -1,
				stRating: -1

			};

			if (typeof $scope.filter != 'undefined') {
				filter.pageNumber = $scope.filter.pageIndex + 1 || 1;
				filter.pageSize = $scope.filter.pageSize || 10;

				//for filter expression
				$scope.filter.filterExpressions.forEach(function(
						filterExpression) {

					var expression = {};
					expression.columnIndex = filterExpression.columnName;
					expression.expression = filterExpression.expression;
					filter.filterExpressions.push(expression);
				});

				$scope.filter.sorts.forEach(function(sortExpression) {

					var expression = {};
					expression.sortColumn = sortExpression.sortColumn;
					expression.sortOrder = sortExpression.isAscending ? "asc"
							: "desc";
					filter.sortExpressions.push(expression);
				});

			}
			
			//this filter are for Suspended / INC*>15M Case
			if (!$scope.rbtnCaseTypeAll
					&& typeof $scope.filterdataoutput != 'undefined') {
				filter.doFilter = true;
				filter.ratingActionIndex = $scope.filterdataoutput.ratingActionIndex;
				filter.lastRatingActionIndex = $scope.filterdataoutput.lastRatingActionIndex;
				filter.ltRating = $scope.filterdataoutput.ltRating;
				filter.stRating = $scope.filterdataoutput.stRating;
				
			}

			$scope.quartilevalidate = $scope.filterUiArray
					.filter(function(row) {
						if (row.datasource != null
								&& row.datasource.quartileFlag != undefined
								&& row.datasource.quartileFlag) {

							return row;
						}

					});

			if ($scope.quartilevalidate.length > 1) {
				$scope.errorMessages
						.push(" Quartile flag can be selected only for one parameter.");
				$scope.filterUiArray.filter(function(row) {
					if (row.datasource != null
							&& row.datasource.quartileFlag != undefined
							&& row.datasource.quartileFlag) {
						row.errorflag = true;
						return row;
					}

				});
			}

			/*
			 * if($scope.quartilefilter.length > 0 ) { flag = 0; }
			 */

			$scope.errarray = $scope.filterUiArray.filter(function(row) {
				return row.errorflag;
			});
			$scope.associate_comp_flag = false;
			var associatearr = $scope.finalFilterArr
					.filter(function(row) {
						return (row.node != undefined && row.node.filterTreeId == 'CB_associate_company');
					});
			if (associatearr.length > 0) {
				$scope.associate_comp_flag = true;
			}
			if ($scope.queryflag != 'run') {
				if ($scope.errarray.length > 0) {
					$scope.iferror = true;
					if($scope.errorMessages.length == 0){
						$scope.errorMessages
							.push("please enter input for selected filter.");
					}
					$window.scrollTo(0, 0);
					$timeout(function() {

						$scope.iferror = false;
						$scope.errorMessages = [];

						$scope.filterUiArray.forEach(function(entry) {
							entry.errorflag = false;
						});

					}, 5000);

					return false;
				}
			}

			if ($scope.saveflag) {
				$scope.saveflag = false;
				return true;
			}

			if ($scope.wizardvalidate) {
				return true;
			}

			if ($scope.queryflag == 'run') {
				$scope.showrun = true;

			} else {
				$scope.showSearchResult = true;
			}

			if ($scope.wizardflag || $scope.custAddData) {
				return angular.toJson($scope.finalFilterArr);
			}
			$scope.universeFlag = true;
			if ($scope.selectedoption.val == 'Universe') {
				$scope.universeFlag = true;
			} else {
				$scope.universeFlag = false + ',' +  ( typeof $scope.selectedoption.portfolio != 'undefined' ? $scope.selectedoption.portfolio : 'All');
			}

			var fd = new FormData();

			fd.append('param1', angular.toJson(filter));
			fd.append('param2', angular.toJson($scope.finalFilterArr));
			fd.append('param3', $scope.universeFlag);
			fd.append('param4', $scope.smeflag);
			fd.append('cacheReload', $scope.cacheReload);

			// used for setting company alert
			$scope.customFilters = {
				'param1' : angular.toJson(filter),
				'param2' : angular.toJson($scope.finalFilterArr),
				'param3' : $scope.universeFlag,
				'param4' : $scope.smeflag,
				'cacheReload' : $scope.cacheReload
			};

			$http
					.post('api/advanceSearch/getFilterOutput', fd, {
						transformRequest : angular.identity,

						headers : {
							'Content-Type' : undefined
						}
					})
					.success(
							function(response) {

								$scope.cacheReload = false;
								
								$scope.searcharr = [];
								$scope.ratedOrListedCompanies = [];
								$scope.prevresponse = response;
								$scope.headerrow = response[0];
								$scope.compCount = response[1];
								if ($scope.headerrow == undefined
										|| $scope.headerrow == null) {
									$scope.showSearchResult = false;
									$scope.iferror = true;
									$scope.errorMessages = [];
									$scope.errorMessages
											.push("No data found for selected criteria ");
									$scope.showrun = false;
									$window.scrollTo(0, 0);
									$scope.compCount = 0;
									$timeout(function() {

										$scope.iferror = false;
										$scope.errorMessages = [];

										$scope.filterUiArray.forEach(function(
												entry) {
											entry.errorflag = false;
										});

									}, 5000);

									return false;

								}
								$scope.columnsToShow = $scope.headerrow;
								$scope.searchOutput = response[3];
								$scope.searchOutputRowCnt = response[2];
								$scope.searchRunOutput = angular
										.copy($scope.searchOutput);

								//will add unique company code for portfolio and search
								var set = new Set();
								angular.forEach($scope.searchOutput, function(
										value, key) {
									set.add(value[0]);
								});

								$scope.ratedOrListedCompanies = Array.from(set);

								angular.forEach($scope.ratedOrListedCompanies,
										function(x) {
											$scope.searcharr.push({
												companyCode : x
											});
										});

								var index = 0;
								var lastRatingActionIndex = -1;
								var ratingActionIndex = -1;
								var ltRating= -1;
								var stRating= -1;
								$scope.columnsarr = $scope.headerrow
										.map(function(row) {
											if (row.displayFlag) {
												row.displayindex = index;
											}
											if ($scope.storeColumnIndexOf[0] == row.displayName
													.trim()) {
												lastRatingActionIndex = index;
											} else if ($scope.storeColumnIndexOf[1] == row.displayName
													.trim()) {
												ratingActionIndex = index;
											}
											else if ($scope.storeColumnIndexOf[2] == row.displayName
													.trim()) {
												ltRating = index;
											}
											else if ($scope.storeColumnIndexOf[3] == row.displayName
													.trim()) {
												stRating = index;
											}
											index = index + 1;
											return row;
										});
								$scope.columnsarr = $scope.columnsarr
										.filter(function(row) {
											return row.displayFlag;
										});
								if ($scope.runflag) {
									// saved run
									$scope.runspinner = false;
									$scope.showrun = true;
									$scope.showsavedfilter = false;
									$scope.filterrunqueryop = {
										dataProvider : $scope.searchOutput,
										styles : flexiciousNmsp.UIUtils
												.getThemeById('officeblue').styles,
										delegate : $scope,
										fullresponse : response
									};
									$timeout(function() {
										$scope.buildGridrunoutput();
									}, 100);

								}

								else if (!$scope.wizardflag) {
									// custom search
									$scope.showSearchResult = true;
									$scope.custsearchfilterflag = false;
									$scope.filterdataoutput = {
										dataProvider : $scope.searchOutput,
										styles : flexiciousNmsp.UIUtils
												.getThemeById('officeblue').styles,
										delegate : $scope,
										lastRatingActionIndex : lastRatingActionIndex,
										ratingActionIndex : ratingActionIndex,
										ltRating : ltRating,
										stRating : stRating,
										outStandingRatingIndex : -1
									};
									$timeout(function() {
										$scope.showcustfilter.open = false;
										$scope.buildGridfilteroutput();
									}, 100);
									$scope.loading = false;
								}

							}).error(function(response) {
						console.log(response);
					});

		}

		// for runquery
		var rungrid = null;
		$scope.dynamicColumns_runqrygrid_creationCompleteHandler = function(
				event) {
			rungrid = event.target;
			$scope.buildGridrunoutput();
		};
		
		$scope.runqryfilterPageSortChangeHandler = function(evt1) {
			grid = evt1.target;
			$scope.filter = evt1.filter;
			$scope.cacheReload = false;
			if ($scope.removeData) {
				$scope.getsectiondatainoutput($scope.gridflag);
			} else {
				$scope.searchComapny(false);
				$scope.buildGridrunoutput();
			}
		}

		// for custom output
		var grid = null;
		$scope.dynamicColumns_grid_creationCompleteHandler = function(event) {
			grid = event.target;
			$scope.buildGridfilteroutput();
		};

		$scope.filterPageSortChangeHandler = function(evt1) {
			grid = evt1.target;
			$scope.filter = evt1.filter;
			$scope.cacheReload = false;
			if ($scope.removeData) {
				$scope.getsectiondatainoutput($scope.gridflag);
			} else {
				$scope.searchComapny(false);
				$scope.buildGridfilteroutput();
			}
		}

		// for wizard
		$scope.dynamicColumns_wizardgrid_creationCompleteHandler = function(
				event) {
			wizardgrid = event.target;
			$scope.buildGridwizardopfilter();
		};

		$scope.wizardFilterPageSortChangeHandler = function(evt1) {
			wizardgrid = evt1.target;
			$scope.filter = evt1.filter;
			if ($scope.removeData) {
				$scope.getsectiondatainoutput($scope.gridflag);
			} else {
				$scope.seachWizardGnerate(false);
				$scope.buildGridwizardopfilter();
			}
		}

		// for company search tool
		var opfiltergrid = null;
		$scope.dynamicColumns_grid_creationCompleteHandler_opfilter = function(
				event) {
			opfiltergrid = event.target;
			$scope.buildGridfilteroutputopfilter();
		};

		$scope.gotocompanyprofile = function(rowData, column) {
			var ind = parseInt(column.dataField);
			var html = '<a  onClick= "generateCompanyProfile(this, \''
					+ rowData[0] + '\', \'' + rowData[2] + '\', \''
					+ rowData[1] + '\')"  id="' + rowData[0] + '" title= "'
					+ rowData[1] + '" > ' + rowData[1] + ' </a> ';
			return html;
		}

		$scope.getnumberforamtted = function(rowData, column) {
			var ind = parseInt(column.dataField);
			var a = rowData[ind];
			var html = "";
			if (a == null || a == undefined) {
				html = "<label >" + "" + "</label>";
			} else {
				if (column.getHeaderText().indexOf('Year') > -1) {
					html = "<label title='" + a + "'>" + a + "</label>";
				} else {
					html = "<label title='" + a + "'>" + a.toLocaleString()
							+ "</label>";
				}

			}

			if (!isNaN(a)) {
				column.setStyle("textAlign", "right");
			} else {
				column.setStyle("textAlign", "left");
			}

			return html;
		}

		$scope.gotoIndustryprofile = function(rowData, column) {

			var html = '<a  target="_blank" id="'
					+ rowData[1]
					+ '" title= "'
					+ rowData[0]
					+ '" > '
					+ rowData[0] + ' </a> ';
			return html; //  onClick= "generateIndustryProfile(this)" removed ind ink
		}

		$window.generateIndustryProfile = function(item) {

			if (!$scope.Advsrchmoduleaccess[INDUSTRY_PROFILE]) {
				ErrorHandlerService.forbiddenError(INDUSTRY_PROFILE);
				return;
			}
			var id = '';
			if (item.id.indexOf('_') > -1) {
				id = item.id.substr(0, item.id.indexOf('_'));
			} else {
				id = item.id;
			}
			$scope.compObj = {
				"id" : id,
				"label" : item.text
			};

			$scope.industryobjtemp = {};

			$scope.industryobjtemp = $scope.compObj;

			$scope.companyCode = $scope.compObj.id;

			$scope.industryObj = {
				"id" : $scope.compObj.id,
				"label" : $scope.compObj.label
			};

			var paramsValue = {
					objtodisplay : $scope.outputParameters,
					industryId : $scope.companyCode,
					industryName : $scope.compObj.label,
					industryAlertFlag : $scope.compObj.industryAlertFlag,
					label : $scope.industryobjtemp.label,
					compObj: $scope.compObj
				}; 
			
			$scope.detailSearch('industryProfileDetails', paramsValue, 'IndustryIDToRedirect');

		}

		$scope.detailSearch = function(stateName, routeParam, localStorageKey) {

			var url = $state.href(stateName, routeParam);
			$window.localStorage[localStorageKey] = JSON
					.stringify(routeParam);
			$window.open(url, '_blank');

		}

		$window.generateCompanyProfile = function(item, companyCodeToview,
				flag, companyName) {

			if (!$scope.Advsrchmoduleaccess[COMPANY_PROFILE]) {
				ErrorHandlerService.forbiddenError(COMPANY_PROFILE);
				return;
			}

			if (flag != null) {

				if (flag == 'SME' && flag == 'NSIC') {
					var paramsValue = {
						'companyCode' : companyCodeToview,
						'flag' : flag
					};
					$scope.detailSearch('smeDetails', paramsValue, 'companyCodeToRedirect');

				} else {
					var paramsValue = {
						'companyCode' : companyCodeToview,
						'flag' : flag,
						'companyName' : companyName
					};
					$scope.detailSearch('companyDetails', paramsValue, 'companyCodeToRedirect');

				}
			} else {
				$scope.errorMessages = [];
				$scope.errorMessages
						.push("Unable to view details for the selected company.");
				$scope.iferror = true;

				$timeout(function() {

					$scope.iferror = false;
					$scope.errorMessages = "";

				}, 5000);
				$window.scrollTo(0, 0);
			}
			$anchorScroll();
		}

		// RRHrefData for Crisil SF RatingList
		$scope.getRRHrefData = function(item, column) {
			var filepath = parseInt(column.getDataField()) + 3;

			if (item[column.getDataField()] != null
					&& item[column.getDataField()] != '') {

				if (JSON.stringify(item).includes('CRISIL') && item[filepath] != null && item[filepath].trim() != '' && $scope.Advsrchmoduleaccess[COMPANY_PROFILE]) {
					return ('<div>'
							+ '<a onClick=openSFRatingRRANDCRRDOC1(this,"RRDOC") id="'
							+ item[filepath] + '" name="' + item[1] + '"> '
							+ item[column.getDataField()] + ' </a></div>');
				}
				return ('<div><span id="' + item[filepath] + '" > '
						+ item[column.getDataField()] + ' </span></div>');

			} else {
				return ('<div><a  id="' + item[filepath] + '" > '
						+ '             ' + ' </a></div>');
			}

		}

		// CRRHrefData for Crisil SF RatingList
		$scope.getCRRHrefData = function(item, column) {

			var filepath = parseInt(column.getDataField()) + 2;

			if (item[column.getDataField()] != null
					&& item[column.getDataField()] != '') {

				if (JSON.stringify(item).includes('CRISIL') && item[filepath] != null && item[filepath].trim() != ''  && $scope.Advsrchmoduleaccess[COMPANY_PROFILE]) {
					return ('<div><a onClick=openSFRatingRRANDCRRDOC1(this,"CRRDOC") id="'
							+ item[filepath]
							+ '" name="'
							+ item[1]
							+ '"> '
							+ item[column.getDataField()] + ' </a></div>');
				}
				return ('<div><span id="' + item[filepath] + '" > '
						+ item[column.getDataField()] + ' </span></div>');

			} else {
				return ('<div><a  id="' + item[filepath] + '" > '
						+ '              ' + ' </a></div>');

			}

		}
		// Reading RRDOC and CRRDOC form companyProfile for Crisil SF RatingList
		$window.openSFRatingRRANDCRRDOC1 = function(item, itemType) {
			var crrDOCFile = item.id;
			var type = '';
			var companyNam = item.name;
			$scope.rRCRRfileName = crrDOCFile;
			$scope.documentTypeName = itemType;
			var fd = new FormData();
			fd.append('fileName', crrDOCFile);
			fd.append('docType', itemType);
			fd.append('companyName', companyNam);
			fd.append('userDoc', '');
			var uploadUrl = 'api/companyProfile/showDocumentOfPDFOrHTML';
			var filext = crrDOCFile.substring(crrDOCFile.lastIndexOf(".") + 1);
			$http.post(uploadUrl, fd, {
				transformRequest : angular.identity,
				responseType : 'arraybuffer',
				headers : {
					'Content-Type' : undefined,
				}
			}).success(
					function(response) {
						if (filext != '' && filext == 'pdf') {
							type = 'application/pdf'
						} else if (filext != '' && filext == 'html'
								|| filext == 'htm') {
							type = 'text/html'
						}
						var blob = new Blob([ response ], {
							type : type
						});

						var fileURL = (window.URL || window.webkitURL)
								.createObjectURL(blob);
						$scope.SFRRORCRRContent = $sce
								.trustAsResourceUrl(fileURL);
						$('#SFdocumentPopUp').val("");
						$('#SFdocumentPopUp').modal({
							show : 'false'
						});
					}).error(function(response, status, headers, config) {
				console.log(response);
			});

		}

		$scope.morecol = false;

		$scope.buildGridrunoutput = function() {

			var gridCgs = [];
			var ycgmain = new flexiciousNmsp.FlexDataGridColumnGroup();
			gridCgs.push(ycgmain);
			var gridforoperatingmargin = "Search Result";
			ycgmain.setHeaderText(gridforoperatingmargin);
			var allheadCols = [];

			var companynamefiled = null;

			for (var i = 0; i < $scope.columnsarr.length; i++) {
				if ($scope.columnsarr[i].displayFlag) {
					var mCol = new flexiciousNmsp.FlexDataGridColumn();
					mCol.setHeaderText(($scope.columnsarr[i].displayName + ""));
					mCol.setDataField($scope.columnsarr[i].displayindex + "");
					mCol.setFilterControl('TextInput');
					mCol.filterOperation = 'Contains';
					mCol.setColumnWidthMode('fixed');
					mCol.Width = "400";
					if ($scope.columnsarr[i].displayName.trim() == 'Company Name') {
						mCol.setStyle("textAlign", "left");
						mCol.setLabelFunction2($scope.gotocompanyprofile);
						companynamefiled = mCol.getDataField();

					}
					if ($scope.columnsarr[i].displayName.trim() == 'Industry Name') {
						mCol.setStyle("textAlign", "left");
						mCol.setLabelFunction2($scope.gotoIndustryprofile);
					}
					if ($scope.columnsarr[i].displayName.trim() == 'Last Rating Action Date') {
						mCol.setStyle("textAlign", "left");
						mCol.setLabelFunction2($scope.getRRHrefData);
					}
					if ($scope.columnsarr[i].displayName.trim() == 'CRR Date') {
						mCol.setStyle("textAlign", "left");
						mCol.setLabelFunction2($scope.getCRRHrefData);
					}
					if ($scope.columnsarr[i].displayName == 'Set Alert') {
						mCol
								.setLabelFunction($scope.setOrRemoveCompanyAlertFlagLabel);
					}
					if ($scope.columnsarr[i].displayName.trim() != 'Company Name'
							&& $scope.columnsarr[i].displayName.trim() != 'Industry Name'
							&& $scope.columnsarr[i].displayName.trim() != 'Last Rating Action Date'
							&& $scope.columnsarr[i].displayName.trim() != 'CRR Date') {
						mCol.setLabelFunction2($scope.getnumberforamtted);
					}

					/*
					 * if ($scope.columnsarr[i].displayName != 'Company Name') {
					 * mCol.setStyle("textAlign", "right"); }
					 */

					allheadCols.push(mCol);
				}
			}
			/*
			 * if($scope.columnsarr.length > 7) { $scope.morecol = true; }
			 */

			for (var j = 0; j < allheadCols.length; j++) {
				if (allheadCols.length > 8) {
					allheadCols[j].setColumnWidthMode('none');

				} else {

					allheadCols[j].setColumnWidthMode('fitToContent');
				}
			}
			$timeout(
					function() {
						ycgmain.setColumns(allheadCols);
						if (rungrid != null) {
							
							rungrid.setFilterPageSortMode('server');
							rungrid.setPreservePager(true);
							rungrid.setDataProvider($scope.searchOutput);
							rungrid.setTotalRecords($scope.searchOutputRowCnt);
							rungrid.setHorizontalScrollPolicy('auto');
							if (!$scope.qflag) {
								rungrid.getColumnLevel().initialSortField = companynamefiled;
							}

							rungrid.getColumnLevel().setGroupedColumns(gridCgs);
							rungrid.rebuild();

							rungrid.validateNow();
						}
					}, 100);
		}

		$scope.capitalise = function(str) {

			str = str.replace(/\_/gi, " ");
			var frags = str.split(' ');
			for (i = 0; i < frags.length; i++) {
				frags[i] = frags[i].toLowerCase();
				frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
			}
			return frags.join(' ');
		}

		$scope.morecolwizard = false;
		$scope.buildGridwizardopfilter = function() {
			var gridCgs = [];
			var ycgmain = new flexiciousNmsp.FlexDataGridColumnGroup();
			gridCgs.push(ycgmain);
			var gridforoperatingmargin = "Search Result";
			ycgmain.setHeaderText(gridforoperatingmargin);
			var allheadCols = [];
			var companynamefiled = null;
			for (var i = 0; i < $scope.columnsarr.length; i++) {
				if ($scope.columnsarr[i].displayFlag) {
					var mCol = new flexiciousNmsp.FlexDataGridColumn();
					mCol.setHeaderText(($scope.columnsarr[i].displayName + ""));
					mCol.setDataField($scope.columnsarr[i].displayindex + "");
					mCol.setFilterControl('TextInput');
					mCol.filterOperation = 'Contains';
					mCol.setColumnWidthMode('fixed');
					mCol.Width = "400";
					if ($scope.columnsarr[i].displayName.trim() == 'Company Name') {
						mCol.setStyle("textAlign", "left");
						companynamefiled = mCol.getDataField();
						mCol.setLabelFunction2($scope.gotocompanyprofile);
					}
					if ($scope.columnsarr[i].displayName.trim() == 'Industry Name') {
						mCol.setStyle("textAlign", "left");
						mCol.setLabelFunction2($scope.gotoIndustryprofile);
					}
					if ($scope.columnsarr[i].displayName
							.indexOf('Last Rating Action Date') > -1) {
						mCol.setStyle("textAlign", "left");
						mCol.setLabelFunction2($scope.getRRHrefData);
					}
					if ($scope.columnsarr[i].displayName.indexOf('CRR Date') > -1) {
						mCol.setStyle("textAlign", "left");
						mCol.setLabelFunction2($scope.getCRRHrefData);
					}
					if ($scope.columnsarr[i].displayName == 'Set Alert') {
						mCol
								.setLabelFunction($scope.setOrRemoveCompanyAlertFlagLabel);
					}
					if ($scope.columnsarr[i].displayName != 'Company Name'
							&& $scope.columnsarr[i].displayName != 'Industry Name'
							&& $scope.columnsarr[i].displayName != 'Last Rating Action Date'
							&& $scope.columnsarr[i].displayName != 'CRR Date') {
						mCol.setLabelFunction2($scope.getnumberforamtted);
					}
					/*
					 * if ($scope.columnsarr[i].displayName != 'Company Name') {
					 * mCol.setStyle("textAlign", "right"); }
					 */

					allheadCols.push(mCol);
				}
			}
			/*
			 * if($scope.columnsarr.length > 7) { $scope.morecolwizard = true; }
			 */

			for (var j = 0; j < allheadCols.length; j++) {
				if (allheadCols.length > 8) {
					allheadCols[j].setColumnWidthMode('none');

				} else {

					allheadCols[j].setColumnWidthMode('fitToContent');
				}
			}
			ycgmain.setColumns(allheadCols);
			if (wizardgrid != null) {

				wizardgrid.setFilterPageSortMode('server');
				wizardgrid.setPreservePager(true);
				wizardgrid.setDataProvider($scope.searchOutput);
				wizardgrid.setTotalRecords($scope.searchOutputRowCnt);
			
				wizardgrid.getColumnLevel().setGroupedColumns(gridCgs);
				wizardgrid.setHorizontalScrollPolicy('auto');
				if (!$scope.qflag) {
					wizardgrid.getColumnLevel().initialSortField = companynamefiled;
				}
				wizardgrid.rebuild();
				wizardgrid.validateNow();
			}

		}
		$scope.morecolfilterop = false;
		$scope.buildGridfilteroutputopfilter = function() {

			var gridCgs = [];
			var ycgmain = new flexiciousNmsp.FlexDataGridColumnGroup();
			gridCgs.push(ycgmain);
			var gridforoperatingmargin = "Search Result";
			ycgmain.setHeaderText(gridforoperatingmargin);
			var allheadCols = [];
			var companynamefiled = null;
			for (var i = 0; i < $scope.columnsarr.length; i++) {
				if ($scope.columnsarr[i].displayFlag) {
					var mCol = new flexiciousNmsp.FlexDataGridColumn();
					mCol.setHeaderText(($scope.columnsarr[i].displayName + ""));
					mCol.setDataField($scope.columnsarr[i].displayindex + "");
					mCol.setFilterControl('TextInput');
					mCol.filterOperation = 'Contains';
					if ($scope.columnsarr[i].displayName == 'Company Name') {
						mCol.setStyle("textAlign", "left");
						mCol.setLabelFunction2($scope.gotocompanyprofile);
						companynamefiled = mCol.getDataField();
					}
					if ($scope.columnsarr[i].displayName == 'Industry Name') {
						mCol.setStyle("textAlign", "left");
						mCol.setLabelFunction2($scope.gotoIndustryprofile);
					}
					if ($scope.columnsarr[i].displayName
							.indexOf('Last Rating Action Date') > -1) {
						mCol.setStyle("textAlign", "left");
						mCol.setLabelFunction2($scope.getRRHrefData);
					}
					if ($scope.columnsarr[i].displayName.indexOf('CRR Date') > -1) {
						mCol.setStyle("textAlign", "left");
						mCol.setLabelFunction2($scope.getCRRHrefData);
					}
					if ($scope.columnsarr[i].displayName == 'Set Alert') {
						mCol
								.setLabelFunction($scope.setOrRemoveCompanyAlertFlagLabel);
					}

					if ($scope.columnsarr[i].displayName != 'Company Name'
							&& $scope.columnsarr[i].displayName != 'Industry Name'
							&& $scope.columnsarr[i].displayName != 'Last Rating Action Date'
							&& $scope.columnsarr[i].displayName != 'CRR Date') {
						mCol.setLabelFunction2($scope.getnumberforamtted);
					}
					/*
					 * if ($scope.columnsarr[i].displayName != 'Company Name') {
					 * mCol.setStyle("textAlign", "right"); }
					 */
					allheadCols.push(mCol);
				}
			}
			/*
			 * if($scope.columnsarr.length > 7) { $scope.morecolfilterop = true; }
			 */

			for (var j = 0; j < allheadCols.length; j++) {
				if (allheadCols.length > 8) {
					allheadCols[j].setColumnWidthMode('none');

				} else {

					allheadCols[j].setColumnWidthMode('fitToContent');
				}
			}
			ycgmain.setColumns(allheadCols);
			if (opfiltergrid != null) {
				opfiltergrid.getColumnLevel().setGroupedColumns(gridCgs);
				if (!$scope.qflag) {
					opfiltergrid.getColumnLevel().initialSortField = companynamefiled;
				}
				opfiltergrid.setHorizontalScrollPolicy('auto');
				opfiltergrid.rebuild();
				opfiltergrid.validateNow();
			}
		}

		$scope.morecolfilteropdata = true;

		$scope.buildGridfilteroutput = function() {
			var gridCgs = [];
			var ycgmain = new flexiciousNmsp.FlexDataGridColumnGroup();
			gridCgs.push(ycgmain);
			var gridforoperatingmargin = "Search Result";
			ycgmain.setHeaderText(gridforoperatingmargin);

			var allheadCols = [];

			var companynamefiled = null;
			for (var i = 0; i < $scope.columnsarr.length; i++) {
				if ($scope.columnsarr[i].displayFlag) {
					var mCol = new flexiciousNmsp.FlexDataGridColumn();
					mCol.setHeaderText(($scope.columnsarr[i].displayName + ""));
					mCol.setDataField($scope.columnsarr[i].displayindex + "");
					mCol.setFilterControl('TextInput');

					mCol.filterOperation = 'Contains';

					if ($scope.columnsarr[i].displayName == 'Company Name') {
						mCol.setStyle("textAlign", "left");
						companynamefiled = mCol.getDataField();

						mCol.sortCaseInsensitive = true;
						mCol.setLabelFunction2($scope.gotocompanyprofile);
					} else if ($scope.columnsarr[i].displayName == 'Industry Name') {
						mCol.setStyle("textAlign", "left");
						mCol.setLabelFunction2($scope.gotoIndustryprofile);
					} else if ($scope.columnsarr[i].displayName == 'Last Rating Action Date') {
						mCol.setStyle("textAlign", "left");
						mCol.setLabelFunction2($scope.getRRHrefData);
					} else if ($scope.columnsarr[i].displayName == 'CRR Date') {
						mCol.setStyle("textAlign", "left");
						mCol.setLabelFunction2($scope.getCRRHrefData);
					} else if ($scope.columnsarr[i].displayName == 'Set Alert') {
						mCol
								.setLabelFunction($scope.setOrRemoveCompanyAlertFlagLabel);
					}
					if ($scope.columnsarr[i].displayName != 'Company Name'
							&& $scope.columnsarr[i].displayName != 'Industry Name'
							&& $scope.columnsarr[i].displayName != 'Last Rating Action Date'
							&& $scope.columnsarr[i].displayName != 'CRR Date') {
						mCol.setLabelFunction2($scope.getnumberforamtted);
					}

					allheadCols.push(mCol);
				}

			}

			for (var j = 0; j < allheadCols.length; j++) {
				if (allheadCols.length > 8) {
					allheadCols[j].setColumnWidthMode('none');

				} else {

					allheadCols[j].setColumnWidthMode('fitToContent');
				}
			}

			ycgmain.setColumns(allheadCols);

			if (grid != null) {

				grid.setFilterPageSortMode('server');
				grid.setPreservePager(true);
				grid.setDataProvider($scope.searchOutput);
				grid.setTotalRecords($scope.searchOutputRowCnt);
			
				grid.setHorizontalScrollPolicy('auto');
				if (!$scope.qflag) {
					grid.getColumnLevel().initialSortField = companynamefiled;
				}

				grid.getColumnLevel().setGroupedColumns(gridCgs);
				grid.rebuild();

				grid.validateNow();
			}

		}

		// For grid lable with set alert option
		$scope.setOrRemoveCompanyAlertFlagLabel = function(row, column) {
			var html = '';
			if (row[parseInt(column.dataField)] == 0) {
				html = '<a class="search" onClick= "setOrRemoveCompanyAlertFlag(this, '
						+ column.dataField
						+ ')"><i class="fa fa-bell bell-align"></i></a>';
			} else {
				html = '<a class="search" onClick= "setOrRemoveCompanyAlertFlag(this, '
						+ column.dataField
						+ ')"><i class="fa fa-bell-slash bell-align"></i></a>';

			}
			return html;
		};

		$window.setOrRemoveCompanyAlertFlag = function(item, columnIndex) {

			$scope.setOrRemoveCompanyAlert(item.parentNode.component.data,
					columnIndex);

		}

		$scope.setOrRemoveCompanyAlert = function(companyData, columnIndex) {

			var companyDataDto = {
				companyCode : companyData[0],
				industryId : '',
				portFolioId : '',
				isIndustryLevel : 'N',
				isPortfolioLevel : 'N',
				isCompanyLevel : 'Y'

			};

			if (companyData[parseInt(columnIndex)] == 0) {
				$scope.setStatus = false;
				$uibModal
						.open({

							templateUrl : 'app/alert components/set alert/companyLevelAlert.html',
							controller : 'CompanyLevelAlert',
							controllerAs : 'vm',
							size : 'lg',
							resolve : {
								companyData : function() {
									return companyDataDto;
								},
								controllerModule : function() {
									return 'AdvanceSearchController';
								},
								parentAccess : function() {
									return $scope;
								},
								isSelectAll : function() {
									return false;
								},
								isInstrumentalFilter : function() {
									return 'N'
								},
								portfolioFilter : function() {
									return ''
								}

							}
						}).closed.then(function() {
					if ($scope.setStatus) {
						companyData[parseInt(columnIndex)] = 1;
						$scope.refreshGrid(companyData[0], columnIndex);
						$scope.setStatus = false;
					}
				});

			} else {
				$scope.removeStatus = false;
				$uibModal
						.open({
							templateUrl : 'app/alert components/remove alert/removeAlert-dialog.html',
							controller : 'RemoveAlertDialogController',
							controllerAs : 'vm',
							size : 'lg',
							resolve : {
								alertNameFor : function() {
									return companyData[1];
								},
								companyData : function() {
									return companyDataDto;
								},
								selectedForAll : function() {
									return 'NA';
								},

								selectedForAlertList : function() {
									return [];
								},
								searchedText : function() {
									return 'NA';
								},
								controllerModule : function() {
									return 'AdvanceSearchController';
								},
								parentAccess : function() {
									return $scope;
								}
							}
						}).closed.then(function() {
					if ($scope.removeStatus) {
						companyData[parseInt(columnIndex)] = 0;
						$scope.refreshGrid(companyData[0], columnIndex);
						$scope.removeStatus = false;
					}

				});

			}

		}

		$scope.refreshGrid = function(companyName, columnIndex) {

			if ($window
					.confirm("Are you sure you want to reload All Companies?")) {

				$scope.cacheReload = true;
				if ($scope.removeData) {
					$scope.getsectiondatainoutput($scope.gridflag);
				}else{
					if ($scope.searchType === 'WIZARD') {
						$scope.seachWizardGnerate(true);
					} else if ($scope.searchType === 'CUSTOM' || $scope.runflag) {
						$scope.searchComapny(true);
					} else if ($scope.searchType === 'COMPANY_TOOL') {
						$scope.searchCompanyTool('search');
					}	
				}
			} else {
				if ($scope.searchType === 'WIZARD') {
					wizardgrid.rebuild();
					wizardgrid.validateNow();
				} else if ($scope.searchType === 'CUSTOM') {
					grid.rebuild();
					grid.validateNow();
				} else if ($scope.searchType === 'COMPANY_TOOL') {
					opfiltergrid.rebuild();
					opfiltergrid.validateNow();
				} else if ($scope.runflag) {
					rungrid.rebuild();
					rungrid.validateNow();
				}
			}
		}

		$scope.setAlertForAll = function() {

			var filter = '';
			var filterType = $scope.searchType;
			if (filterType === 'WIZARD') {
				filter = JSON.stringify($scope.wizardFilters);
			} else if (filterType === 'CUSTOM' || $scope.runflag) {
				if ($scope.runflag) {
					filterType = 'CUSTOM';
				}
				filter = JSON.stringify($scope.customFilters);
			} else if (filterType === 'COMPANY_TOOL') {
				filter = JSON.stringify($scope.companyFilters);
			}

			var companyDataDto = {
				companyCode : '',
				industryId : '',
				portFolioId : '',
				isIndustryLevel : 'N',
				isPortfolioLevel : 'N',
				isCompanyLevel : 'N',
				isAdvanceSearchLevel : 'Y',
				isInstrumentalType : filterType,
				portfolioFilter : filter,
				ratingDetailType : ''
			};
			$uibModal
					.open({

						templateUrl : 'app/alert components/set alert/companyLevelAlert.html',
						controller : 'CompanyLevelAlert',
						controllerAs : 'vm',
						size : 'lg',
						resolve : {
							companyData : function() {
								return companyDataDto;
							},
							controllerModule : function() {
								return 'AdvanceSearchController';
							},
							parentAccess : function() {
								return $scope;
							},
							isSelectAll : function() {
								return true;
							}

						}
					}).closed.then(function() {
			});

		}

		$scope.columnfiltermodal = function(flag) {
			$scope.gridflag = flag;
			if (!$scope.removeData) {
				$scope.setCompanyTool('false');
			}
			$scope.validateCompany = "";
			$scope.sectiondata = angular.copy($scope.tempdata);

			$('#hideshowcolumn').modal('show');
		}
		$scope.updatedatagrid = function() {
			$scope.buildGridfilteroutput();
			$('#hideshowcolumn').modal('hide');
		}

		$scope.exportExcel = function(grid) {
			if ($scope.advAccessdata.indexOf('Export Adv Search') == -1) {
				$scope.errorMessages = [];
				$scope.errorMessages
						.push("This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.");
				$scope.iferror = true;

				$timeout(function() {

					$scope.iferror = false;
					$scope.errorMessages = "";

				}, 5000);
				$window.scrollTo(0, 0);

			} else {

				var filter = '';
				var filterType = $scope.searchType;
				if (filterType === 'WIZARD') {
					filter = JSON.stringify($scope.wizardFilters);
				} else if (filterType === 'CUSTOM' || $scope.runflag) {
					filterType = 'CUSTOM';
					filter = JSON.stringify($scope.customFilters);
				} else if (filterType === 'COMPANY_TOOL') {
					filter = JSON.stringify($scope.companyFilters);
				}

				if ($scope.removeData) {
					var dataTosend = {
						"sectiondata" : $scope.arrtosend,
						"pagable" : filter,
						"universeFlag" : $scope.universeFlag,
						"smeflag" : $scope.smeflag,
						"gridflag" : filterType,
						"currentYear" : $scope.currentYear.val,
						"currentQuarter" : $scope.currentQuarter.val,
						"associate_comp_flag" : $scope.associate_comp_flag,
						"filterObj" : $scope.filterdatalist
					};
					filterType = 'ADD_DATA';
					filter = JSON.stringify(dataTosend);
				}

				$scope.exportheader = $scope.columnsarr.map(function(row) {
					var headerObj = {};
					headerObj.displayIndex = row.displayindex;
					headerObj.displayName = row.displayName.trim();
					headerObj.displayFlag = row.displayFlag;
					headerObj.headersWidth = 40;
					return headerObj
				});

				if ($scope.searchOutput.length > 0) {

					var templeteName = "AdvanceSearch Report";
					var htmltreegridData = {
						headersObject : $scope.exportheader,
						filterObject : filter,
						templeteName : templeteName,
						searchType : filterType
					}

					GenericServiceNew
							.generateAdvSearchHtmltreegridDataExport(
									htmltreegridData)
							.then(
									function(response) {
										var isIE = false || !!document.documentMode;
										$scope.response = response;
										var blob = new Blob(
												[ response ],
												{
													type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
												});
										if (isIE) {

											window.navigator
													.msSaveOrOpenBlob(blob,
															'AdvanceSearchExportData.xlsx');

										} else {

											var anchor = angular
													.element('<a/>');
											var objectUrl = (window.URL || window.webkitURL)
													.createObjectURL(blob);
											anchor.css({
												display : 'none'
											});
											// Make sure it's not visible
											angular.element(document.body)
													.append(anchor); // Attach
											// to
											// document
											anchor
													.attr({
														href : objectUrl,
														target : '_blank',
														download : 'AdvanceSearchExportDatas.xlsx'
													})[0].click();

											anchor.remove();

										}

									})["catch"](function(response) {
					});
				} else {
					$scope.errorMessagesExport = "No Records Found.";
					return validationError(true, $scope.errorMessagesExport);
				}
			}

		}

		// For toggle strength and weakness
		$scope.selectStrenAndWeak = function() {
			if ($scope.business.strwk == 'Strength'
					&& $scope.filterUiArray.length > 0) {
				$scope.filterUiArray[0].datasource = $scope.strengthWeakness.strength;
				$scope.filterUiArray[0].selectedVals = [ $scope.filterUiArray[0].datasource[0] ];
				$scope.filterUiArray[0].showhideflag = true;
			} else if ($scope.business.strwk == 'Weakness'
					&& $scope.filterUiArray.length > 0) {
				$scope.filterUiArray[0].datasource = $scope.strengthWeakness.weakness;
				$scope.filterUiArray[0].selectedVals = [ $scope.filterUiArray[0].datasource[0] ];
				$scope.filterUiArray[0].showhideflag = true;
			}

		}

		// get list of my portoflios
		$scope.myPortfolios = [];
		$scope.getMyPortfolios = function() {
			if ($scope.myPortfolios.length == 0) {
				$http({
					url : 'api/portfolioresource/getListPortfolio',
					method : 'POST',
				}).success(function(data) {
					$scope.myPortfolios = data;
					$scope.selectedoption.portfolio = 'All';
				}).error(function(response) {
					console.log(response);
				});
			}
		}

		// disable othere rating type if
		// Issuer Rating is selected in multiselct controle
		$scope.disableOtherType = function(compo, isReset) {
			// filter selected Issuer rating into array
			var issuerRatingList = [];
			if (!isReset) {
				issuerRatingList = compo.filter(function(el) {
					return typeof el.symbol !== 'undefined'
							&& el.symbol.indexOf('IR ') > -1 && el.ticked;
				});
			}
			if (issuerRatingList.length > 0) {
				$.each(compo, function(key, value) {
					if (typeof value.symbol !== 'undefined'
							&& !(value.name == 'Issuer Rating' || value.symbol
									.indexOf('IR ') > -1)) {
						value.disabled = true;
						value.ticked = false;
					}
				});
			} else {
				$.each(compo, function(key, value) {
					value.disabled = false;
				});
			}
		}

		$scope.getAllData = function(allData) {
			$scope.rbtnCaseTypeAll = allData;
			var filterType = $scope.searchType;
			$scope.cacheReload = false;
			if ($scope.removeData) {
				$scope.getsectiondatainoutput($scope.gridflag);
			} else {
				if (filterType === 'WIZARD') {
					$scope.seachWizardGnerate(false);
				} else if (filterType === 'CUSTOM') {
					$scope.searchComapny(false);
				}
			}
		}

		$scope.downloadRRCRRReports = function() {
			var fileNames = $scope.rRCRRfileName;
			var documentTypess = $scope.documentTypeName;
			var fd = new FormData();
			fd.append('fileName', fileNames);
			fd.append('docType', documentTypess);

			var uploadUrl = 'api/RRCRR/downloadPdf';
			$http.post(uploadUrl, fd, {
				transformRequest : angular.identity,
				responseType : 'arraybuffer',
				headers : {
					'Content-Type' : undefined,
				}
			}).success(
					function(response) {

						var isIE = false || !!document.documentMode;
						$scope.response = response;
						var blob = new Blob([ response ], {
							type : 'application/octet-stream'
						});
						if (isIE) {

							window.navigator.msSaveOrOpenBlob(blob,
									$scope.rRCRRfileName);
						} else {

							var anchor = angular.element('<a/>');
							var blob = new Blob([ response ], {
								type : 'application/octet-stream'
							})
							var objectUrl = (window.URL || window.webkitURL)
									.createObjectURL(blob);
							anchor.css({
								display : 'none'
							});
							// Make sure it's not visible
							angular.element(document.body).append(anchor); // Attach
							// to
							// document
							anchor.attr({
								href : objectUrl,
								target : '_self',

								download : $scope.rRCRRfileName
							})[0].click();

							anchor.remove();

						}
						$scope.updateStatusForRRCRRReport(fileNames,
								documentTypess);

					})

		}

		$scope.updateStatusForRRCRRReport = function(fileNames, documentTypess) {

			var fd = new FormData();
			fd.append('fileName', fileNames);
			fd.append('docType', documentTypess);

			GenericService.updateDownloadStatusForRRCRRreport(fd);
		}
		
		$scope.changeRatingStatus = function(){
			var nodearr = [];
			$scope.searchfiletrdatac = angular
			.copy($scope.searchfiletrdata);
			ivhTreeviewBfs($scope.searchfiletrdatac, opts, function(
					node) {
				if (node.id == '230') {
					$scope.disableEnableChildren(node,nodearr);
				}
			});
			
			$timeout(function() {
				$scope.searchfiletrdata = $scope.searchfiletrdatac
			}, 20);
			
			nodearr.map(function(row) {
				$timeout(function(node1) {
					ivhTreeviewMgr.deselect($scope.searchfiletrdata, node1,
							opts);
				}, 30);
			});
			
			if($scope.status.unrated != undefined && $scope.status.unrated == false){
				ivhTreeviewBfs($scope.searchfiletrdatac, opts, function(
						ivhNode) {
					if (ivhNode.uiType.startsWith('datefilter')) {
						$scope.selecteddate.option = 'single';
					}
					$timeout(function() {
						$scope.selectdaterange($scope.selecteddate.option,
								ivhNode);
					}, 80);
				});
			}
			
		}
		
		
		
		$scope.disableEnableChildren = function(node, nodearr){
			
			ivhTreeviewBfs(node, opts, function(ratingnode) {
				if(ratingnode.uiType!= null && ratingnode.uiType != 'null'){
					if($scope.status.unrated != undefined && $scope.status.unrated == true){
						ratingnode.disabled = true;
					}else{
						ratingnode.disabled = false;
					}
					ratingnode.selected = false;
					nodearr.push(ratingnode);
				}
				
			});
			if (node.children != undefined && node.children.length > 0) {
				for(i = 0;i<node.children.length;i++){
					$scope.disableEnableChildren(node.children[i],nodearr);
				}
			}
			
			
		}
		

		
	}

	angular
			.module('quantixApp')
			.directive(
					'htmltreegridir',
					function() {
						return {

							restrict : 'E',
							replace : 'true',
							scope : {
								industrydata : '@',
								uniqueid : '@',
								setvaluesind : '&',
								setnameind : '&',
								setindobj : '&',
								type : '@',
								selectionmode : '@',
								selectallflag : '@'
							},
							templateUrl : 'app/company/advanceSearch/htmltreegriddirTemplate.html',
							controller : htmltreegridController
						};
					});

})();
